var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoliticaExtraBoldItalic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\n        Created by FontForge 20170731 at Sun Dec 22 17:43:21 2013\n        By Aleksey,,,\n        Copyright 2004-2013 SUDTIPOS. Disenada por Alejandro Paul y Alfredo Graziani. Todos los derechos reservados.\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Politica-ExtraBoldItalic",
    horizAdvX: 525
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Politica",
    fontWeight: 800,
    fontStyle: "italic",
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "0 0 9 0 0 0 0 0 0 0",
    ascent: 830,
    descent: -170,
    xHeight: 560,
    capHeight: 800,
    bbox: "-123 -276 1242 1138",
    underlineThickness: 50,
    underlinePosition: -200,
    slope: -9,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 182,
    d: "M124 492q10 0 10 -9q0 -13 -13 -13q-9 0 -9 9q0 13 12 13zM50 22q9 0 9 -9q0 -13 -12 -13q-10 0 -10 9q0 13 13 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 605,
    d: "M548 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l46 289h-175l-69 -435q-11 -63 -62 -107q-52 -44 -116 -44l19 130q23 0 27 21l69 435h-55l20 129h55l10 54q11 63 62 107q52 45 114 44h97l-22 -130h-94q-23 0 -26 -21l-9 -54h307z M451 765h130l-17 -106h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 629,
    d: "M605 764l-99 -622v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l21 129l57 364h-176q-23 0 -26 -21l-9 -54h80l-20 -129h-80l-69 -435q-11 -63 -62 -107q-52 -44 -116 -44l19 130q23 0 27 21l69 435h-55l20 129h55l10 54q11 63 62 107q52 45 114 44 h310v-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 182,
    d: "M124 492q10 0 10 -9q0 -13 -13 -13q-9 0 -9 9q0 13 12 13zM50 22q9 0 9 -9q0 -13 -12 -13q-10 0 -10 9q0 13 13 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 219
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 273,
    d: "M283 796l-94 -590h-130l94 590h130zM173 106l-16 -106h-130l16 106h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 403,
    d: "M263 764l-41 -258h-130l41 258h130zM423 764l-41 -258h-130l41 258h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 735,
    d: "M685 417h-133l-25 -53h114l-20 -129h-156l-64 -135h-115l64 135h-116l-64 -135h-115l64 135h-55l20 129h97l25 53h-78l21 129h118l59 124h115l-59 -124h116l59 124h115l-59 -124h93zM412 364l25 53h-116l-25 -53h116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    d: "M382 681h12q46 0 80 -33t34 -80q0 -2 -2 -20l-5 -30h-130l3 20v3l1 2q0 8 -8 8h-126q-9 0 -12 -13v-8q-5 -25 36 -47l34 -18l43 -18q122 -48 122 -150q0 -3 -2 -27l-6 -36q-10 -58 -54 -96q-43 -37 -100 -37h-8l-16 -101h-111l16 101h-20q-45 0 -80 33q-33 34 -33 82 q0 14 1 18l14 89h130l-12 -79q0 -2 -1 -3v-2q0 -8 8 -8h127q8 0 11 13l3 18q0 2 1 6v3q0 25 -27 44q-10 9 -38 19q-5 3 -23 10t-20 8q-128 53 -128 146q0 1 2 25l3 25q10 59 53.5 96t100.5 37h16l13 85h111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 900,
    d: "M736 798l-435 -798h-90l435 798h90zM249 778h127q42 0 68 -30.5t26 -78.5q0 -2 -2 -24l-24 -149q-7 -55 -48 -94q-39 -39 -86 -39h-127q-42 0 -68 30.5t-26 78.5q0 2 2 24l24 149q7 54 47 94q40 39 87 39zM337 662h-86q-10 0 -13 -17l-24 -149v-5q0 -11 8 -11h86 q11 0 14 16l24 149v4q0 13 -9 13zM625 407h126q42 0 68 -30.5t26 -77.5q0 -1 -2 -25l-24 -149q-7 -54 -48 -95q-39 -39 -86 -39h-126q-41 0 -67.5 31.5t-26.5 78.5q0 2 2 24l24 149q9 57 48 94q39 39 86 39zM712 290h-86q-12 0 -13 -16l-24 -149q0 -1 -0.5 -3t-0.5 -3 q0 -11 9 -11h87q9 0 12 17l24 149v5q0 11 -8 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 624,
    d: "M500 448h127l-21 -130h-127l-32 -203q-10 -59 -48.5 -89.5t-99.5 -30.5h-146q-57 0 -90.5 25.5t-33.5 71.5q0 1 2 23l23 150q7 39 36 73t67 47q-27 13 -43 39.5t-16 59.5q0 15 1 19l23 143q10 59 50.5 90t103.5 31h145q54 0 83 -24t29 -70q0 -15 -2 -27l-11 -69h-130 l9 56v3q0 7 -8 7h-129q-11 0 -12 -10l-21 -130l-1 -3v-5q0 -20 16.5 -32.5t36.5 -12.5h49l-21 -130h-49q-25 0 -48.5 -16t-27.5 -39l-22 -136v-2q0 -8 9 -8h136q11 0 12 10l56 355h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 243,
    d: "M263 764l-41 -258h-130l41 258h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 351,
    d: "M290 842h142q-127 -130 -191.5 -275.5t-64.5 -287.5q0 -191 110 -361h-142q-96 150 -96 334q0 336 242 590z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 352,
    d: "M93 -82h-142q127 130 191.5 275.5t64.5 287.5q0 191 -110 361h142q96 -150 96 -334q0 -336 -242 -590z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 436,
    d: "M343 776l-14 -91l119 30l-16 -104l-105 -26l81 -93l-82 -71l-75 91l-93 -83l-65 67l106 89l-90 26l16 104l103 -30l15 91h100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    d: "M371 515l-15 -91h104l-23 -143h-104l-17 -116h-144l17 116h-102l23 143h102l15 91h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 273,
    d: "M181 155l-49 -311h-130l49 311h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 409,
    d: "M379 416l-20 -129h-307l20 129h307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 251,
    d: "M102 138q25 0 42.5 -17t17.5 -41q0 -31 -24.5 -55.5t-56.5 -24.5q-25 0 -42 17t-17 42v3q1 4 1 6q5 29 28 49.5t51 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 476,
    d: "M560 860l-492 -920h-115l493 920h114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    d: "M282 775h117q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-78 -497q-11 -61 -59 -102q-48 -42 -108 -42h-117q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l78 497q11 61 58 102q49 42 109 42zM379 645h-117q-14 0 -17 -14l-78 -497l-1 -3v-3q0 -8 12 -8h117q14 0 17 14l78 497 q0 1 0.5 3t0.5 3q0 8 -12 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    d: "M339 130h134l-20 -130h-430l20 130h165l80 505h-165l21 130h295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    d: "M274 776h133q53 0 87.5 -36t34.5 -91q0 -3 -2 -27l-5 -31q-8 -42 -24 -81q-18 -41 -35.5 -65.5t-48.5 -52.5q-22 -20 -49 -42q-15 -12 -56 -39l-48 -33q-86 -59 -100 -148h288l-20 -130h-421l11 70q18 109 53.5 178.5t99.5 114.5q21 15 58 37q28 16 57 35q95 64 105 156 l5 31q1 3 1 10q0 14 -21 14h-113q-14 0 -20 -7t-10 -27h-130q11 70 60 116q49 48 110 48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    d: "M273 775h133q54 0 84.5 -26.5t30.5 -74.5q0 -2 -2 -26l-18 -110q-17 -98 -66 -117q38 -17 38 -79q0 -24 -3 -42l-25 -175q-9 -65 -50.5 -100t-104.5 -35h-131q-56 0 -86.5 27.5t-30.5 79.5q0 2 2 28l23 157h130l-21 -146v-5q0 -11 8 -11h121q9 0 12 16l23 164q1 3 1 12 q0 28 -33 28h-68l20 130h68q17 0 27 15.5t16 52.5l16 95v3q0 9 -8 9h-123q-10 0 -13 -12l-3 -19h-130l3 19q11 66 54.5 104t105.5 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    d: "M518 765l-83 -521h52l-20 -130h-52l-18 -114h-130l18 114h-300l306 651h227zM367 635h-9l-168 -391h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    d: "M541 764l-21 -129h-252l-24 -154h98q70 0 100.5 -27t30.5 -84q0 -18 -5 -55l-28 -178q-12 -72 -58 -109.5t-118 -37.5h-93q-65 0 -101 29.5t-36 86.5q0 14 3 31l24 145h130l-24 -145v-3q0 -14 25 -14h92q23 0 26 17l28 178q0 3 0.5 6.5t1 5.5t0.5 3q0 21 -19 21h-228 l66 413h382z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    d: "M272 776h139q48 0 79 -37q33 -36 33 -86q0 -4 -2 -22l-10 -64h-130l10 64q0 1 0.5 3t0.5 3q0 9 -11 9h-119q-14 0 -16 -15l-32 -197h132q54 0 88 -34t34 -86q0 -1 -2 -23l-25 -157q-9 -60 -58 -101q-49 -42 -108 -42h-118q-53 0 -88 34.5t-35 86.5q0 4 2 22l80 499 q7 54 55 99q49 44 101 44zM311 134l25 157v3l1 1q0 9 -12 9h-119q-12 0 -15 -14l-25 -156v-3q0 -10 11 -10h119q14 0 15 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    d: "M554 770l-360 -770h-130l301 640h-238l20 130h407z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    d: "M283 775h113q53 0 86 -33.5t33 -85.5q0 -2 -2 -24l-15 -96q-15 -89 -81 -118q53 -21 53 -91q0 -3 -2 -29l-26 -160q-11 -61 -60 -104t-110 -43h-113q-54 0 -89.5 35.5t-35.5 87.5q0 2 2 24l25 160q13 94 88 120q-47 23 -47 85q0 15 3 33l15 96q11 59 57 101q48 42 106 42 zM244 491h102q17 15 22 45l15 96l1 2v2q0 9 -10 9h-111q-10 0 -13 -13l-15 -96q-1 -4 -1 -15q0 -20 10 -30zM312 138l26 160q1 3 1 14q0 22 -16 34h-102q-25 -15 -30 -48l-25 -160v-5q0 -12 14 -12h113q16 0 19 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    d: "M286 -8h-139q-47 0 -80 36q-32 38 -32 87q0 4 2 22l10 64h130l-10 -64q0 -1 -0.5 -3t-0.5 -3q0 -9 11 -9h119q14 0 16 15l32 197h-132q-54 0 -88 34t-34 86q0 1 2 23l25 157q9 60 58 101q49 42 108 42h118q53 0 88 -34.5t35 -86.5q0 -4 -2 -22l-80 -499q-7 -55 -56 -99 q-47 -44 -100 -44zM247 634l-25 -157v-3l-1 -1q0 -9 12 -9h119q12 0 15 14l25 156v3q0 10 -11 10h-119q-14 0 -15 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 252,
    d: "M161 503q25 0 42 -17t17 -42q0 -31 -25 -55t-56 -24q-25 0 -41.5 16t-16.5 40q0 9 1 12q4 28 27.5 49t51.5 21zM102 138q25 0 42.5 -17t17.5 -41q0 -31 -24.5 -55.5t-56.5 -24.5q-25 0 -42 17t-17 42v3q1 4 1 6q5 29 28 49.5t51 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 250,
    d: "M163 524q25 0 42 -16.5t17 -40.5q0 -9 -1 -12q-4 -28 -27 -48t-52 -20q-25 0 -42 16.5t-17 41.5q0 31 25 55t55 24zM121 -156h-130l49 311h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    d: "M375 663l97 -45l-213 -205l156 -212l-113 -46l-184 258z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    d: "M473 506l-20 -130h-350l20 130h350zM446 326l-21 -131h-350l21 131h350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    d: "M271 663l176 -250l-266 -258l-97 46l223 212l-150 205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 500,
    d: "M255 806h158q50 0 82 -32t32 -81q0 -2 -2 -20l-21 -128q-12 -78 -59 -116t-103 -38h-28q-13 0 -18 -20l-27 -176h-130l27 176q12 73 57 111q46 38 97 40h34q17 0 20 21l20 126v5q0 10 -8 10h-143q-11 0 -13 -15l-16 -100h-130l17 104q7 54 53 94q45 39 101 39zM255 106 l-17 -106h-130l17 106h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 818,
    d: "M387 634h148q110 0 176 -63q67 -63 67 -166q0 -31 -4 -51l-22 -138q-7 -49 -49 -84q-40 -34 -89 -34h-166l9 49q-126 -61 -180 -61q-36 0 -59 23t-23 57q0 13 1 16l26 169q9 57 49 94q41 39 95 39h141q49 0 81 -31.5t32 -79.5q0 -4 -2 -22l-20 -123h15q11 0 12 10l18 113 q2 14 2 29q0 56 -36.5 90t-97.5 34h-141q-66 0 -114 -42.5t-59 -112.5l-26 -168q-2 -18 -2 -20q0 -43 28.5 -69t76.5 -26h167l-20 -130h-189q-88 0 -143 52q-55 51 -55 132q0 18 3 36l30 191q19 130 108 208q88 79 212 79zM480 361h-115q-10 0 -13 -10l-16 -109q-1 -1 -1 -7 q0 -14 17 -14q11 0 53 18q53 25 71 35l12 77v3q0 7 -8 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 568,
    d: "M506 0h-129v174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766zM196 304h185v355q0 11 -6 11h-61q-6 0 -9 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 560,
    d: "M153 800h311q44 0 73.5 -29t29.5 -72q0 -1 -2 -19l-23 -144q-5 -38 -30 -70t-61 -48q29 -13 45.5 -40t16.5 -61q0 -14 -1 -19l-28 -178q-8 -50 -49 -85t-90 -35h-318zM234 483h157q19 8 19 44l1 7l19 124v3l1 3q0 8 -8 8h-160zM356 137l26 161v5q1 5 1 7q0 34 -14 43 h-156l-35 -223h172q5 0 6 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 546,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l19 124v3l1 2q-2 11 -13 11h-148q-14 0 -17 -16l-83 -525q0 -1 -0.5 -3t-0.5 -3q0 -9 12 -9h153q11 0 14 15l25 157h130l-25 -158q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 565,
    d: "M153 800h294q54 0 89 -32t35 -83q0 -1 -2 -23l-82 -518q-9 -60 -58 -102q-48 -42 -108 -42h-294zM427 670h-164l-85 -540h164q12 0 15 14l82 518v2q0 6 -12 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 485,
    d: "M531 800l-21 -130h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 460,
    d: "M532 800l-23 -145h-249l-24 -149h221l-20 -130h-221l-59 -376h-130l126 800h379z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 541,
    d: "M284 806h145q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l20 126v2q0 12 -11 12h-145q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h145q15 0 17 14l26 168h-122l22 130h252l-48 -298q-11 -61 -59 -102q-48 -42 -108 -42h-145q-54 0 -88.5 34.5t-34.5 86.5 q0 1 2 23l83 528q11 61 58 102q49 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 577,
    d: "M588 800l-126 -800h-130l59 378h-175l-59 -378h-130l126 800h130l-47 -294h175l47 294h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 283,
    d: "M288 800l-126 -800h-130l126 800h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 510,
    d: "M536 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-146q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l25 158h130l-25 -158v-2q0 -12 11 -12h146q15 0 17 14l105 666h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 595,
    d: "M666 800l-243 -354l-1 -9l118 -437h-137l-99 377h-89l-59 -377h-129l126 800h129l-47 -294h89l205 294h137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 455,
    d: "M282 800l-105 -670h247l-21 -130h-376l126 800h129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 802,
    d: "M543 800h249l-96 -800h-130l78 670h-8l-219 -660h-119l-8 660h-9l-134 -670h-130l157 800h245l-20 -522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 629,
    d: "M640 800l-126 -800h-223l-21 670h-7l-106 -670h-130l126 800h225l19 -670h8l105 670h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 530,
    d: "M153 800h290q54 0 89 -32t35 -83q0 -1 -2 -23l-30 -186q-7 -60 -57 -102q-48 -42 -108 -42h-160l-53 -332h-130zM423 670h-160l-33 -208h160q13 0 15 14l30 186v1q0 7 -12 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-5l-24 -143h-130l24 143h-15q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM342 134l83 528v3q0 11 -11 11h-150q-14 0 -17 -14l-83 -528 v-2q0 -12 11 -12h16l15 90h130l-15 -90h4q15 0 17 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 563,
    d: "M153 800h314q44 0 73.5 -29t29.5 -72q0 -1 -2 -19l-23 -144q-6 -38 -31 -70t-61 -48q29 -13 46 -40t17 -62q0 -14 -1 -18l-47 -298h-130l47 298q0 4 0.5 8t1 7t0.5 5v3q0 22 -16 32h-158l-56 -353h-130zM234 483h152q14 6 19 15.5t9 35.5l20 126q0 12 -11 12h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 527,
    d: "M279 806h139q54 0 88.5 -39t34.5 -98q0 -3 -2 -27h-130q1 4 1 15q0 19 -12 19h-139q-12 0 -17 -14l-8 -55q-1 -3 -1 -12q0 -36 34 -65q21 -16 32 -23l43 -26q6 -5 10 -6q114 -71 114 -210q0 -31 -4 -54l-12 -77q-11 -61 -59 -102q-48 -42 -108 -42h-139q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l23 148h130l-23 -148v-2q0 -12 11 -12h139q12 0 17 14l12 77q2 14 2 29q0 45 -26 82q-7 12 -32 31q-23 19 -34 25l-41 26q-100 61 -100 167q0 18 3 36l8 55q11 61 58 102q50 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 474,
    d: "M548 800l-20 -130h-164l-106 -670h-130l106 670h-164l20 130h458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 561,
    d: "M581 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149q15 0 17 14l105 666h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 570,
    d: "M635 800l-251 -776q-4 -12 -18.5 -23t-29.5 -11h-191q-32 0 -45 34v776h127v-671q0 -15 4 -15h59q4 0 9 15l206 671h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 850,
    d: "M740 800h130l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-80q-49 0 -82 28t-40 74q-21 -45 -64 -73.5t-92 -28.5h-80q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h80q33 0 59 32q25 32 30 57l93 591h130l-93 -591q-4 -25 11 -58 q16 -31 48 -31h80q15 0 17 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 543,
    d: "M581 800l-211 -363l110 -437h-132l-70 319l-172 -319h-134l248 435l-93 365h135l48 -275l136 275h135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 569,
    d: "M504 800h130l-209 -546q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 503,
    d: "M556 800l-362 -670h257l-21 -130h-446l364 670h-258l20 130h446z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 301,
    d: "M385 870l-20 -130h-91l-107 -680h91l-22 -130h-221l149 940h221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 396,
    d: "M224 800l120 -800h-135l-119 800h134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 299,
    d: "M322 870l-149 -940h-221l21 130h92l107 680h-91l20 130h221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    d: "M380 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 480,
    d: "M428 1l-20 -129h-466l20 129h466z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 383,
    d: "M285 765l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 519,
    d: "M457 120h28l-20 -130h-31q-42 -1 -75 20t-48 56q-44 -23 -112 -50q-67 -27 -98 -27q-36 0 -59 23.5t-23 59.5q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-47 -292q-2 -11 4 -18.5t19 -7.5zM309 185l41 247v2q0 7 -7 7h-126 q-9 0 -12 -10l-43 -283v-2l-1 -2q0 -9 9 -9q25 0 139 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 512,
    d: "M255 708l-31 -195q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l93 585h-1l9 57h130l-9 -57h1zM308 133l43 277l1 2v3q0 9 -9 9q-13 0 -140 -40l-39 -251q0 -1 -0.5 -3 l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 481,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-12 -75h-130l11 70v2q0 6 -8 6h-125q-9 0 -11 -8l-48 -298v-2q-1 -2 -1 -3q0 -9 8 -9h125q10 0 13 14l9 61h130l-11 -72q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 517,
    d: "M533 764l-10 -57h1l-112 -707h-130l7 47l-38 -13q-25 -9 -47 -16q-82 -28 -112 -28q-34 0 -53.5 19.5t-19.5 54.5q0 1 2 23l56 350q8 56 53 95q46 39 100 38h139h3l22 137l9 57h130zM309 176l40 251v3q0 11 -10 12h-119q-14 0 -15 -15l-44 -277v-3q0 -11 8 -11 q16 0 140 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 492,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-139q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM344 440h-129 q-9 0 -10 -9l-18 -116l134 55q23 11 24 31l5 30q0 9 -6 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 315,
    d: "M370 635h-94q-23 0 -26 -21l-9 -54h80l-20 -129h-80l-69 -435q-11 -63 -62 -107q-52 -44 -116 -44l19 130q23 0 27 21l69 435h-55l20 129h55l10 54q11 63 62 107q52 45 114 44h97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 512,
    d: "M230 571h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-74 -463q-9 -55 -53 -93t-100 -38h-138q-49 0 -82 31t-33 76q0 13 3 26l7 32h130l-5 -21v-3l-1 -2q0 -9 7 -9h129q7 0 9 11l21 129q-145 -63 -189 -63q-36 0 -59 23t-23 57q0 13 1 16l45 291q7 54 53 94q47 39 101 39z M343 441h-128q-7 0 -10 -9l-38 -236v-4q0 -8 7 -8q38 0 148 70l28 178v3q0 6 -7 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 522,
    d: "M235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h1l32 205h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 298,
    d: "M285 765l-17 -106h-130l17 106h130zM252 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l66 418h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 278,
    d: "M287 765l-17 -106h-131l17 106h131zM257 560l-89 -565q-10 -63 -63 -108q-52 -45 -115 -44h-71l19 130h70q25 0 28 22l89 565h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 543,
    d: "M234 560l-8 -47q138 56 189 56q35 0 58 -22.5t23 -56.5q0 -1 -2 -17l-24 -150q-5 -40 -33.5 -74t-67.5 -49l69 -200h-142l-63 190h-58l-28 -190h-129l87 560l33 205h129zM341 329l16 90q2 8 -5 8q-6 0 -57 -15t-90 -30l-9 -62h136q8 0 9 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 298,
    d: "M285 764l-99 -622v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l20 129l78 493h133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 739,
    d: "M467 507v-1q112 64 166 64q35 0 58 -23t23 -56q0 -2 -2 -18l-73 -473h-129l65 412v3q0 8 -5 8q-16 0 -118 -40l-60 -383h-129l63 407q1 1 1 5q0 8 -6 8q-8 0 -115 -43l-59 -377h-130l88 560h130l-8 -53q106 60 160 60q32 0 56 -17t24 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 522,
    d: "M235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 507,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39zM345 440h-131q-6 0 -9 -8l-47 -298q-1 -1 -1 -6q0 -8 5 -8h130q8 0 11 14l47 298q2 8 -5 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 517,
    d: "M235 560l-7 -47l37 13q10 4 47 16q86 28 113 28q34 0 53.5 -19.5t19.5 -54.5q0 -1 -2 -23l-56 -350q-8 -56 -53 -95q-46 -39 -100 -38h-139h-3l-22 -137h-130l112 707h130zM312 133l44 277v3q0 11 -8 11q-16 0 -140 -40l-40 -251v-3q0 -11 10 -12h119q13 0 15 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 512,
    d: "M230 571h138q50 0 82 -31.5t32 -79.5q0 -4 -2 -22l-93 -585h-130l31 195q-168 -57 -196 -57q-35 0 -54.5 19.5t-19.5 54.5q0 1 2 23l57 350q7 55 52 95q46 39 101 38zM338 443h-118q-13 0 -16 -15l-43 -277q0 -1 -0.5 -3l-0.5 -2q0 -9 9 -9q13 0 140 40l39 251v2q1 2 1 3 q0 10 -11 10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 486,
    d: "M235 560l-8 -47q138 56 189 56q36 0 58.5 -23t22.5 -57q0 -13 -1 -16l-15 -100h-130l6 43v5q0 7 -6 7t-144 -45l-60 -383h-130l88 560h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 490,
    d: "M221 570h139q46 0 80 -33t34 -80q0 -2 -2 -20l-5 -30h-130l3 20v3l1 2q0 8 -8 8h-126q-9 0 -12 -13v-8q-5 -25 36 -47l34 -18l43 -18q122 -48 122 -150q0 -3 -2 -27l-6 -36q-10 -59 -54 -96q-43 -37 -100 -37h-139q-45 0 -80 33q-33 35 -33 82q0 14 1 18l14 89h130 l-12 -79q0 -2 -1 -3v-2q0 -8 8 -8h127q8 0 11 13l3 18l1 3v6q0 25 -27 44q-10 9 -38 19q-5 3 -23 10t-20 8q-128 53 -128 146q0 1 2 25l3 25q10 59 53.5 96t100.5 37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 359,
    d: "M237 432l-46 -290v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44t-27 108l46 290h-73l20 128h74l23 144h132l-23 -144h138l-21 -128h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 522,
    d: "M287 0l8 47q-137 -57 -189 -57q-36 0 -58.5 23t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130l-88 -560h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 483,
    d: "M505 560l-170 -534q-4 -13 -18.5 -24t-29.5 -11h-178q-15 0 -26.5 10t-15.5 25v534h133l-11 -422q0 -16 6 -16h43q11 0 15 16l122 422h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 765,
    d: "M623 560h130l-66 -420q-10 -66 -53.5 -108t-103.5 -42h-66q-45 0 -75.5 25.5t-37.5 70.5q-20 -45 -59 -70.5t-84 -25.5h-65q-52 0 -81.5 32.5t-29.5 86.5q0 17 2 31l66 420h130l-66 -420v-5q0 -15 15 -15h49q64 0 79 95l54 345h130l-54 -345q-3 -19 -3 -34q0 -61 50 -61 h50q20 0 23 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 496,
    d: "M493 560l-173 -258l111 -302h-141l-58 176l-115 -176h-141l208 302l-88 258h141l35 -134l80 134h141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 527,
    d: "M511 560l-92 -582q-9 -57 -54 -94q-43 -39 -100 -39h-261l20 130h254q9 0 11 11l12 70q-135 -59 -187 -59q-36 0 -59 23.5t-23 58.5q0 12 1 15l74 466h130l-65 -406q-1 -2 -1 -8q0 -7 7 -7q16 0 144 45l59 376h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 462,
    d: "M471 560l-19 -126l-301 -305h256l-21 -129h-400l21 130l299 304h-249l19 126h395z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 302,
    d: "M352 860l-21 -130q-21 -1 -24 -23l-27 -168q-12 -71 -34 -100t-65 -31l-2 -16q33 -2 47.5 -18t14.5 -55q0 -26 -5 -58l-27 -168v-4q0 -15 18 -19l-21 -130q-47 6 -89 36q-42 29 -42 79q0 14 1 18l30 188q3 17 3 30q0 36 -16.5 48.5t-50.5 12.5l16 96q17 0 29 2.5t25.5 11 t23 28t14.5 49.5l30 188q9 57 63 92q57 35 109 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 273,
    d: "M291 850l-142 -900h-130l142 900h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 302,
    d: "M-12 -60l21 130q21 1 24 23l27 168q12 71 34 100t65 31l2 16q-33 2 -47.5 18t-14.5 55q0 26 5 58l27 168v4q0 15 -18 19l21 130q47 -6 89 -36q42 -28 42 -79q0 -14 -1 -18l-30 -188q-3 -17 -3 -30q0 -36 16.5 -48.5t50.5 -12.5l-16 -96q-17 0 -29 -2.5t-25.5 -11t-23 -28 t-14.5 -49.5l-30 -188q-9 -58 -64 -92q-55 -35 -108 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    d: "M192 624l13 111q31 31 67 31q26 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-40 18 -64 18q-33 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "DEL",
    horizAdvX: 500
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 273,
    d: "M133 666h130l-16 -106h-130zM101 460h130l-94 -590h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    d: "M388 678h19q50 0 82 -32t32 -80q0 -2 -2 -20l-12 -75h-125l11 70v2q0 6 -7 6h-31l-51 -323h27q12 0 13 10l11 67h125l-11 -72q-9 -56 -55 -96q-46 -39 -102 -39h-16l-16 -96h-130l16 98h-15q-50 0 -82 32.5t-32 80.5q0 2 2 20l50 315q9 57 54 94q46 38 101 38h14l14 87 h130zM212 541l-49 -305q0 -8 9 -8h27l51 321h-27q-9 0 -11 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    d: "M318 776h132q54 0 89 -35t35 -87q0 -4 -2 -22l-16 -96h-130l16 96v3q0 11 -12 11h-132q-11 0 -16 -14l-26 -161h96l-20 -130h-96l-21 -125q-2 -19 14 -38l16 -16l37 -32h215l-21 -130h-511l21 130h137q-39 23 -39 70q0 12 1 16l21 125h-87l20 130h87l26 161q9 60 57 102 q50 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 526,
    d: "M299 776h139q54 0 89 -35t35 -87q0 -4 -2 -22l-20 -126h-130l20 126v3l1 2q0 9 -13 9h-139q-8 0 -11 -2.5t-5 -11.5l-20 -116h107l-16 -100h-293l16 100h56l20 116q9 60 57 102q50 42 109 42zM348 134l25 158h133l-25 -158q-11 -61 -59 -102q-48 -42 -108 -42h-139 q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l24 146h-54l16 100h293l-16 -100h-109l-24 -146v-5q0 -9 11 -9h139q22 0 22 2l-4 4q-5 5 -4 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    d: "M339 350l-9 -57h123l-16 -100h-380l16 100h129l9 57h-26q-15 -1 -25.5 9t-12.5 25l-69 382h133l52 -293q0 -7 6 -7h51q7 0 8 7l142 294h130l-184 -383q-16 -34 -51 -34h-26zM34 47l16 100h381l-17 -100h-123l-7 -47h-128l7 47h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 258,
    d: "M276 850l-62 -390h-115l62 390h115zM195 340l-61 -390h-115l61 390h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 518,
    d: "M261 726h138q50 0 82 -31.5t32 -79.5q0 -4 -2 -22l-5 -33h-130l5 33q0 2 1 3v1q0 9 -12 9h-118q-12 0 -15 -13l-2 -14q-4 -24 22 -45q5 -4 26 -17q9 -5 38.5 -20.5t34.5 -17.5q56 -28 84 -61.5t28 -82.5q0 -14 -2 -28l-5 -29q-5 -34 -26 -64q8 -26 8 -46q0 -13 -1 -17 l-5 -29q-9 -54 -54 -95q-45 -39 -100 -39h-139q-49 0 -81 32t-32 80q0 4 2 22l14 90h130l-14 -90l-1 -2v-3q0 -8 11 -8h119q13 0 16 13l5 29q3 29 -25 51q-9 8 -44 27q-6 3 -26.5 13.5t-26.5 14.5q-57 30 -85 62.5t-28 78.5q0 1 2 25l2 14q7 40 32 71q-11 25 -11 50 q0 3 2 21l2 14q9 57 54 94q45 39 100 39zM356 304l2 10q6 44 -67 81l-45 23l-41 21q-7 -7 -9 -17l-2 -11q-5 -33 58 -67q6 -3 53 -28l47 -23q3 6 4 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 327,
    d: "M155 757q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM323 757q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 638,
    d: "M296 568h139q75 0 121 -41t46 -107q0 -16 -3 -32l-34 -218q-13 -79 -75 -130q-62 -50 -147 -50h-139q-75 0 -121 41t-46 107q0 16 3 32l34 218q14 80 75 129q61 51 147 51zM419 468h-139q-41 0 -70.5 -22.5t-35.5 -57.5l-34 -218q-1 -3 -1 -13q0 -30 22 -48.5t59 -18.5 h139q41 0 70.5 22.5t35.5 57.5l34 218q1 3 1 13q0 30 -22 48.5t-59 18.5zM277 448h139q31 0 49 -17t14 -43l-10 -66h-95l3 21v4q0 13 -12 13h-60q-15 0 -18 -17l-20 -128q0 -1 -0.5 -3l-0.5 -2q0 -12 12 -12h60q16 0 19 17l3 19h95l-10 -64q-4 -25 -28 -42.5t-55 -17.5h-139 q-30 0 -48.5 18t-14.5 42l34 218q4 25 28 42.5t55 17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 437,
    d: "M225 774h130q29 0 48.5 -19t19.5 -47q0 -11 -1 -14l-41 -262h-85l5 29q-129 -35 -153 -35q-22 0 -36 14t-14 35v3q1 4 1 6l33 210q6 34 32.5 57t60.5 23zM323 688h-93q-12 0 -14 -15l-24 -141v-3q0 -10 8 -10q18 0 115 20l20 134v4q0 11 -12 11zM385 399l-15 -99h-310 l15 99h310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 618,
    d: "M264 392l98 -48l-165 -105l131 -105l-113 -47l-186 152zM474 392l98 -48l-165 -105l131 -105l-113 -47l-186 152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    d: "M508 396l-35 -221h-129l15 92h-328l20 129h457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 614,
    d: "M286 792h205q61 0 94 -30t33 -84q0 -17 -2 -31l-42 -262q-10 -68 -55.5 -106.5t-115.5 -38.5h-205q-61 0 -94 30t-33 84q0 17 2 31l42 262q10 68 55.5 106.5t115.5 38.5zM475 692h-205q-49 0 -55 -45l-42 -262q-6 -45 41 -45h205q49 0 55 45l42 262q6 45 -41 45zM244 662 h193q21 0 35.5 -14.5t11.5 -33.5l-8 -49q-5 -33 -38 -47q26 -11 26 -39q0 -7 -1 -9l-17 -107h-89l18 107v3q0 10 -7 10h-63l-19 -120h-89zM389 599h-66l-6 -40h64q7 3 10 22l2 11q0 7 -4 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "overscore",
    unicode: "\xAF",
    horizAdvX: 315,
    d: "M384 736l-15 -99h-220l15 99h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 432,
    d: "M257 765h73q45 0 75 -30t30 -74q0 -3 -2 -19l-4 -24q-7 -49 -50 -86t-93 -37h-73q-45 0 -74.5 31t-29.5 76q0 12 1 16l4 24q8 50 50 86q43 37 93 37zM314 665h-73q-22 0 -27 -23l-4 -24v-2q0 -9 6 -15t15 -6h73q10 0 17 6.5t8 16.5l4 24l1 2v3q0 7 -6 12.5t-14 5.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    d: "M382 575l-14 -91h103l-23 -143h-104l-18 -116h-144l18 116h-102l23 143h103l14 91h144zM427 206l-22 -129h-350l22 129h350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 400,
    d: "M251 771h59q37 0 60.5 -21.5t23.5 -54.5q0 -9 -1 -12l-4 -24q-11 -76 -88 -127q-5 -3 -22 -14.5t-22 -14.5q-33 -24 -38 -49h137l-15 -101h-258l11 70q13 87 106 146l40 26q14 10 28 29t17 39l2 9v4q0 6 -6 6h-29q-8 0 -10 -11l-3 -17h-104l2 12q7 44 39.5 74.5 t74.5 30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 372,
    d: "M214 771h105q27 0 45.5 -17.5t18.5 -43.5q0 -2 -1 -6v-3l-8 -55q-7 -42 -40 -64q24 -18 24 -50q0 -11 -1 -14l-15 -93q-4 -28 -29.5 -48.5t-55.5 -20.5h-105q-30 0 -49.5 20t-15.5 49l14 85h93l-10 -62v-3q0 -7 7 -7h51q10 0 11 10l12 72v5q0 13 -18 14h-103l14 87h102 q19 0 20 16l6 39v3q0 6 -6 6h-54q-8 0 -9 -9l-1 -7h-93l5 27q4 28 30 49q27 21 56 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 383,
    d: "M486 765l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 664,
    d: "M675 800l-150 -950h-130l130 821h-49l-130 -821h-130l58 370h-100q-50 0 -82 32.5t-32 80.5q0 2 2 20l50 314q9 57 54 94q45 39 100 39h409zM346 671h-100h-2q-2 0 -2 -1v-3l-50 -314l4 -3h100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "middot",
    unicode: "\xB7",
    horizAdvX: 250,
    d: "M137 359q25 0 42 -16.5t17 -40.5q0 -9 -1 -12q-4 -28 -27 -48t-52 -20q-25 0 -42 16.5t-17 41.5q0 30 25 54.5t55 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 462,
    d: "M299 11l-14 -38q32 -12 52 -40.5t20 -63.5q0 -57 -47 -101t-111 -44q-38 0 -91 38l60 79q36 -17 47 -17q40 0 40 31q0 21 -21 21h-75l37 135h103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 290,
    d: "M296 765l-64 -405h-109l49 312h-39l15 93h148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 424,
    d: "M226 774h130q30 0 49 -19t19 -48q0 -10 -1 -13l-30 -188q-5 -33 -32.5 -56.5t-60.5 -23.5h-130q-30 0 -49 19t-19 48q0 10 1 13l30 188q5 34 32 57t61 23zM315 684h-76q-8 0 -9 -7l-24 -153v-3q0 -5 7 -5h75q6 0 8 8l24 153q1 7 -5 7zM387 399l-16 -99h-311l16 99h311z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 618,
    d: "M182 392l184 -153l-233 -152l-100 47l165 105l-131 105zM392 392l184 -153l-233 -152l-100 47l165 105l-131 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 740,
    d: "M634 798l-435 -798h-111l435 798h111zM282 765l-64 -405h-109l49 312h-39l15 93h148zM678 410l-36 -225h26l-14 -94h-27l-14 -92h-94l14 92h-200l187 319h158zM569 318h-9l-60 -133h48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 700,
    d: "M603 798l-435 -798h-111l435 798h111zM282 765l-64 -405h-109l49 312h-39l15 93h148zM510 418h59q37 0 60.5 -21.5t23.5 -54.5q0 -9 -1 -12l-4 -24q-11 -76 -88 -127q-5 -4 -22.5 -15t-21.5 -14q-33 -24 -38 -49h137l-15 -101h-258l11 70q13 87 106 146l40 26 q14 10 28 29t17 39l2 9v4q0 6 -6 6h-29q-8 0 -10 -11l-3 -17h-104l2 12q7 44 39.5 74.5t74.5 30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 819,
    d: "M612 798h110l-434 -798h-111zM357 518l-15 -93q-4 -28 -29.5 -48.5t-55.5 -20.5h-105q-30 0 -49.5 20t-15.5 49l14 85h93l-10 -62v-3q0 -7 7 -7h51q10 0 11 10l12 72v5q0 13 -18 14h-103l14 87h102q19 0 20 16l6 39v3q0 6 -6 6h-54q-8 0 -9 -9l-1 -7h-93l5 27q4 28 30 49 q27 21 56 21h105q27 0 45.5 -17.5t18.5 -43.5q0 -2 -1 -6v-3l-8 -55q-7 -42 -40 -64q24 -18 24 -50q0 -11 -1 -14zM761 410l-36 -225h27l-15 -94h-26l-15 -92h-94l15 92h-201l187 319h158zM631 185l22 133h-10l-60 -133h48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 500,
    d: "M275 640h130l-17 -106h-130zM258 -166h-158q-50 0 -82 32t-32 81q0 2 2 20l21 128q12 78 59 116t103 38h28q13 0 18 20l27 176h130l-27 -176q-12 -73 -58 -112q-45 -37 -96 -39h-34q-17 0 -20 -21l-20 -126v-5q0 -10 8 -10h143q12 0 13 15l16 100h130l-17 -104 q-7 -54 -53 -94q-45 -39 -101 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 568,
    d: "M377 0v174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185zM344 1005l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 568,
    d: "M377 0v174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185zM554 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 568,
    d: "M377 0v174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185zM420 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 568,
    d: "M377 0v174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185zM239 864l13 111q31 31 67 31q25 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32 q-24 0 -67 17q-40 18 -64 18q-32 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 568,
    d: "M304 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM472 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM377 0v174h-221l-54 -174h-130 l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 568,
    d: "M405 1075q47 0 76.5 -31.5t29.5 -77.5t-40 -93q-39 -47 -105 -47q-48 0 -78 31.5t-30 79.5q0 45 38 92q39 46 109 46zM392 996q-20 0 -37 -16.5t-17 -35.5q0 -16 12 -28t28 -12q20 0 37 16.5t17 35.5q0 16 -12 28t-28 12zM377 0v174h-221l-54 -174h-130l246 766 q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 794,
    d: "M841 800l-22 -133h-247l-26 -161h220l-20 -130h-221l-38 -246h248l-21 -130h-377l26 174h-202l-58 -174h-131l247 766q4 13 18.5 23.5t29.5 10.5h574zM443 676h-125q-4 0 -6 -6l-112 -366h184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 546,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l19 124v3l1 2q-2 11 -13 11h-148q-14 0 -17 -16l-83 -525q0 -1 -0.5 -3t-0.5 -3q0 -9 12 -9h153q11 0 14 15l25 157h130l-25 -158q-11 -61 -59 -102q-48 -42 -108 -42h-28l-6 -17q32 -12 52 -40.5 t20 -63.5q0 -57 -47 -101t-111 -44q-38 0 -91 38l60 79q36 -17 47 -17q40 0 40 31q0 21 -21 21h-75l31 114h-21q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378zM325 1005l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378zM535 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378zM401 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 485,
    d: "M284 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM452 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM510 670h-247l-31 -194h221 l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 283,
    d: "M162 0h-130l126 800h130zM207 1005l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 283,
    d: "M162 0h-130l126 800h130zM417 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 283,
    d: "M162 0h-130l126 800h130zM283 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 283,
    d: "M167 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM335 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM162 0h-130l126 800h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 565,
    d: "M153 800h294q54 0 89 -32t35 -83q0 -1 -2 -23l-82 -518q-9 -60 -58 -102q-48 -42 -108 -42h-294l58 368h-51l20 129h51zM357 144l82 518v2q0 6 -12 6h-164l-27 -173h94l-20 -129h-95l-37 -238h164q12 0 15 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 629,
    d: "M514 0h-223l-21 670h-7l-106 -670h-130l126 800h225l19 -670h8l105 670h130zM271 864l13 111q31 31 67 31q25 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-40 18 -64 18q-32 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11zM339 1005l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11zM549 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11zM415 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11zM233 864l13 111q31 31 67 31q25 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-41 18 -64 18q-32 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 551,
    d: "M298 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM466 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM284 806h150q54 0 88.5 -34.5 t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3q0 11 -11 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    d: "M380 521l76 -91l-94 -82l77 -90l-106 -91l-77 91l-100 -87l-77 91l101 86l-67 78l106 91l66 -78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 576,
    d: "M616 860l-64 -115q15 -25 15 -60q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-16 0 -31 3l-30 -53h-106l60 108q-16 28 -16 63q0 1 2 23l83 528q11 61 58 102q50 42 109 42h150q22 0 35 -4l32 58h105zM257 662l-56 -359l207 373h-134q-14 0 -17 -14z M352 134l55 351l-203 -365h131q15 0 17 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 561,
    d: "M581 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149q15 0 17 14l105 666h130zM347 1005l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 561,
    d: "M581 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149q15 0 17 14l105 666h130zM557 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 561,
    d: "M581 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149q15 0 17 14l105 666h130zM423 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 561,
    d: "M581 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149q15 0 17 14l105 666h130zM307 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5 q0 30 23.5 53t52.5 23zM475 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 569,
    d: "M634 800l-209 -546q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130zM548 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 536,
    d: "M282 792l-24 -153h160q54 0 89 -32t35 -83q0 -1 -2 -23l-28 -176q-11 -61 -59 -102q-48 -42 -108 -42h-160l-28 -181h-130l125 792h130zM398 509h-160l-31 -198h160q12 0 15 14l28 176v2q0 6 -12 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 528,
    d: "M281 774h132q55 0 86.5 -25t31.5 -72q0 -2 -0.5 -5t-1 -9t-0.5 -10l-18 -116q-7 -39 -33.5 -71t-62.5 -47q30 -12 48 -40.5t18 -62.5q0 -13 -1 -17l-30 -189q-9 -57 -52.5 -88.5t-107.5 -31.5h-97l20 130h94q13 0 18 17l25 162q2 18 -12 36.5t-33 18.5h-52l20 130h52 q18 0 35.5 17.5t20.5 35.5l17 110v1l1 2q0 7 -9 7h-118q-10 0 -11 -10l-101 -652q-11 -65 -62 -107q-52 -45 -116 -45h-41l20 130h39q27 0 30 22l101 658q9 58 48.5 89.5t101.5 31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 519,
    d: "M279 765l80 -131h-125l-81 131h126zM485 120l-20 -130h-31q-42 -1 -75 20t-48 56q-44 -23 -112 -50q-67 -27 -98 -27q-36 0 -59 23.5t-23 59.5q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-47 -292q-2 -11 4 -18.5t19 -7.5h28z M309 185l41 247v2q0 7 -7 7h-126q-9 0 -12 -10l-43 -283l-1 -4q0 -9 9 -9q25 0 139 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 519,
    d: "M489 765l-122 -131h-126l123 131h125zM485 120l-20 -130h-31q-42 -1 -75 20t-48 56q-44 -23 -112 -50q-67 -27 -98 -27q-36 0 -59 23.5t-23 59.5q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-47 -292q-2 -11 4 -18.5t19 -7.5h28z M309 185l41 247v2q0 7 -7 7h-126q-9 0 -12 -10l-43 -283l-1 -4q0 -9 9 -9q25 0 139 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 519,
    d: "M355 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69zM485 120l-20 -130h-31q-42 -1 -75 20t-48 56q-44 -23 -112 -50q-67 -27 -98 -27q-36 0 -59 23.5t-23 59.5q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-47 -292 q-2 -11 4 -18.5t19 -7.5h28zM309 185l41 247v2q0 7 -7 7h-126q-9 0 -12 -10l-43 -283l-1 -4q0 -9 9 -9q25 0 139 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 519,
    d: "M173 624l13 111q31 31 67 31q25 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-40 18 -64 18q-32 0 -61 -27zM485 120l-20 -130h-31q-42 -1 -75 20t-48 56q-44 -23 -112 -50q-67 -27 -98 -27q-36 0 -59 23.5t-23 59.5q0 12 1 15l56 351 q7 54 53 94q47 39 101 39h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-47 -292q-2 -11 4 -18.5t19 -7.5h28zM309 185l41 247v2q0 7 -7 7h-126q-9 0 -12 -10l-43 -283l-1 -4q0 -9 9 -9q25 0 139 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 519,
    d: "M238 757q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM406 757q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM485 120l-20 -130h-31 q-42 -1 -75 20t-48 56q-44 -23 -112 -50q-67 -27 -98 -27q-36 0 -59 23.5t-23 59.5q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-47 -292q-2 -11 4 -18.5t19 -7.5h28zM309 185l41 247v2q0 7 -7 7h-126q-9 0 -12 -10l-43 -283l-1 -4 q0 -9 9 -9q25 0 139 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 519,
    d: "M340 835q47 0 76.5 -31.5t29.5 -77.5t-40 -93q-39 -47 -105 -47q-48 0 -78 31.5t-30 79.5q0 45 38 92q39 46 109 46zM327 756q-20 0 -37 -16.5t-17 -35.5q0 -16 11.5 -28t28.5 -12q20 0 37 16.5t17 35.5q0 16 -11.5 28t-28.5 12zM485 120l-20 -130h-31q-42 -1 -75 20 t-48 56q-44 -23 -112 -50q-67 -27 -98 -27q-36 0 -59 23.5t-23 59.5q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-47 -292q-2 -11 4 -18.5t19 -7.5h28zM309 185l41 247v2q0 7 -7 7h-126q-9 0 -12 -10l-43 -283l-1 -4q0 -9 9 -9 q25 0 139 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 766,
    d: "M505 570h138q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-5 -29 -58 -55l-242 -107l-7 -42v-3q0 -11 7 -11h126q9 0 12 14l9 61h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-138q-39 0 -67.5 19.5t-39.5 52.5q-47 -23 -114 -49q-63 -23 -91 -23q-36 0 -59 23.5t-23 58.5 q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139q37 0 65 -15q36 14 71 14zM311 193l39 239v3q0 6 -6 6h-129q-9 0 -10 -9l-46 -288q0 -1 -1 -2v-2q0 -8 10 -8q22 0 143 61zM620 401l4 31q2 8 -5 8h-131q-7 0 -9 -8l-18 -117l135 55q23 14 24 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 481,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-12 -75h-130l11 70v2q0 6 -8 6h-125q-9 0 -11 -8l-48 -298v-2q-1 -2 -1 -3q0 -9 8 -9h125q10 0 13 14l9 61h130l-11 -72q-9 -55 -54 -94t-100 -39h-33l-6 -17q32 -12 52 -40.5t20 -63.5q0 -57 -47 -101t-111 -44 q-38 0 -91 38l60 79q36 -17 47 -17q40 0 40 31q0 21 -21 21h-75l31 114h-5q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 492,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-139q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM344 440h-129 q-9 0 -10 -9l-18 -116l134 55q23 11 24 31l5 30q0 9 -6 9zM278 765l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 492,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-139q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM344 440h-129 q-9 0 -10 -9l-18 -116l134 55q23 11 24 31l5 30q0 9 -6 9zM488 765l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 492,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-139q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM344 440h-129 q-9 0 -10 -9l-18 -116l134 55q23 11 24 31l5 30q0 9 -6 9zM354 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 492,
    d: "M238 757q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM406 757q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM230 570h139q50 0 82 -32 t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-139q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM344 440h-129q-9 0 -10 -9l-18 -116l134 55 q23 11 24 31l5 30q0 9 -6 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 298,
    d: "M241 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44t-27 108l66 418h132zM157 765l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 298,
    d: "M252 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l66 418h132zM378 765l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 298,
    d: "M241 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44t-27 108l66 418h132zM234 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 298,
    d: "M126 757q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM294 757q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM250 560l-66 -418v-6q0 -16 20 -16 h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l66 418h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 526,
    d: "M505 585h57l-18 -120h-58l-54 -340q-7 -54 -54 -95q-45 -39 -100 -39h-138q-50 0 -82 32.5t-32 81.5q0 2 2 20l28 176q9 55 54 94t100 39h138h4l4 31h-76l19 120h76l10 62v2q0 7 -7 7h-129q-7 0 -9 -9l-13 -78h-130l15 90q9 53 52 90t96 37h138q52 0 85.5 -32.5 t33.5 -82.5q0 -2 -2 -24zM303 132l26 160v4q0 8 -5 8h-131q-6 0 -8 -11l-26 -161v-3q0 -7 4 -7h131q8 0 9 10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 522,
    d: "M235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h130zM179 624l13 111q31 31 67 31q25 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-41 18 -64 18 q-32 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 507,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39zM345 440h-131q-6 0 -9 -8l-47 -298q-1 -1 -1 -6q0 -8 5 -8h130q8 0 11 14l47 298q2 8 -5 8zM283 765l80 -131h-125 l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 507,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39zM345 440h-131q-6 0 -9 -8l-47 -298q-1 -1 -1 -6q0 -8 5 -8h130q8 0 11 14l47 298q2 8 -5 8zM493 765l-122 -131h-126 l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 507,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39zM345 440h-131q-6 0 -9 -8l-47 -298q-1 -1 -1 -6q0 -8 5 -8h130q8 0 11 14l47 298q2 8 -5 8zM360 795l108 -158h-115 l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 507,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39zM345 440h-131q-6 0 -9 -8l-47 -298q-1 -1 -1 -6q0 -8 5 -8h130q8 0 11 14l47 298q2 8 -5 8zM178 624l13 111 q31 31 67 31q26 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-41 18 -64 18q-33 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 507,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39zM345 440h-131q-6 0 -9 -8l-47 -298q-1 -1 -1 -6q0 -8 5 -8h130q8 0 11 14l47 298q2 8 -5 8zM243 757q24 0 40 -16.5 t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM411 757q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    d: "M307 570q25 0 42.5 -17t17.5 -41q0 -32 -24.5 -55.5t-56.5 -23.5q-26 0 -42.5 16.5t-16.5 42.5q0 2 1 6v3q5 28 28.5 48.5t50.5 20.5zM459 416l-20 -129h-350l20 129h350zM260 273q25 0 42.5 -17t17.5 -41q0 -32 -26 -56q-26 -23 -56 -23q-26 0 -42 16.5t-16 41.5 q0 2 0.5 5t0.5 5q5 28 28.5 48.5t50.5 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 563,
    d: "M560 584l-56 -85q7 -21 7 -42q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-19 0 -30 4l-16 -25h-118l58 90q-8 22 -8 43q0 3 2 21l50 314q7 54 53 94q45 39 101 39h139q14 0 34 -4l12 18h117zM333 440h-91q-6 0 -9 -8l-30 -187zM226 120h94q8 0 11 14l30 188z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 522,
    d: "M287 0l8 47q-137 -57 -189 -57q-36 0 -58.5 23t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130l-88 -560h-130zM280 765l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 522,
    d: "M287 0l8 47q-137 -57 -189 -57q-36 0 -58.5 23t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130l-88 -560h-130zM490 765l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 522,
    d: "M287 0l8 47q-137 -57 -189 -57q-36 0 -58.5 23t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130l-88 -560h-130zM356 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 522,
    d: "M287 0l8 47q-137 -57 -189 -57q-36 0 -58.5 23t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130l-88 -560h-130zM239 757q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM407 757 q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 527,
    d: "M511 560l-92 -582q-9 -57 -54 -94q-43 -39 -100 -39h-261l20 130h254q9 0 11 11l12 70q-135 -59 -187 -59q-36 0 -59 23.5t-23 58.5q0 12 1 15l74 466h130l-65 -406q-1 -2 -1 -8q0 -7 7 -7q16 0 144 45l59 376h130zM514 765l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 517,
    d: "M230 524l-2 -11l37 13q10 4 47 16q86 28 113 28q34 0 53.5 -19.5t19.5 -54.5q0 -1 -2 -23l-56 -350q-8 -56 -53 -95q-46 -39 -100 -38h-142l-22 -137h-130l88 556l6 37l18 114l33 204h130zM312 133l44 277v3q0 11 -8 11q-16 0 -140 -40l-40 -251v-3q0 -11 10 -12h119 q13 0 15 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 527,
    d: "M264 757q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM432 757q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM511 560l-92 -582 q-9 -57 -54 -94q-43 -39 -100 -39h-261l20 130h254q9 0 11 11l12 70q-135 -59 -187 -59q-36 0 -59 23.5t-23 58.5q0 12 1 15l74 466h130l-65 -406q-1 -2 -1 -8q0 -7 7 -7q16 0 144 45l59 376h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 568,
    d: "M377 0v174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185zM501 976l-15 -99h-220l15 99h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 519,
    d: "M436 736l-15 -99h-220l15 99h220zM485 120l-20 -130h-31q-42 -1 -75 20t-48 56q-44 -23 -112 -50q-67 -27 -98 -27q-36 0 -59 23.5t-23 59.5q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-47 -292q-2 -11 4 -18.5t19 -7.5h28z M309 185l41 247v2q0 7 -7 7h-126q-9 0 -12 -10l-43 -283l-1 -4q0 -9 9 -9q25 0 139 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 568,
    d: "M377 0v174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185zM410 990h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75l-1 -2v-3q0 -15 19 -15 q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 519,
    d: "M344 750h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75l-1 -2v-3q0 -15 19 -15q20 0 25 20zM485 120l-20 -130h-31q-42 -1 -75 20t-48 56q-44 -23 -112 -50q-67 -27 -98 -27q-36 0 -59 23.5t-23 59.5q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139 q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-47 -292q-2 -11 4 -18.5t19 -7.5h28zM309 185l41 247v2q0 7 -7 7h-126q-9 0 -12 -10l-43 -283l-1 -4q0 -9 9 -9q25 0 139 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 568,
    d: "M534 -42l38 -64q-64 -48 -129 -48q-40 0 -65.5 25.5t-25.5 66.5t25 75v161h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22zM196 304h185v355q0 11 -6 11h-61q-6 0 -9 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 519,
    d: "M494 -52l38 -64q-64 -48 -129 -48q-40 0 -65.5 25.5t-25.5 66.5q0 48 36 90q-25 18 -37 48q-44 -23 -112 -50q-67 -27 -98 -27q-36 0 -59 23.5t-23 59.5q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-47 -292q-2 -11 4 -18.5 t19 -7.5h28l-20 -128l1 -2q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22zM309 185l41 247v2q0 7 -7 7h-126q-9 0 -12 -10l-43 -283l-1 -4q0 -9 9 -9q25 0 139 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 546,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l19 124v3l1 2q-2 11 -13 11h-148q-14 0 -17 -16l-83 -525q0 -1 -0.5 -3t-0.5 -3q0 -9 12 -9h153q11 0 14 15l25 157h130l-25 -158q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM549 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 481,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-12 -75h-130l11 70v2q0 6 -8 6h-125q-9 0 -11 -8l-48 -298v-2q-1 -2 -1 -3q0 -9 8 -9h125q10 0 13 14l9 61h130l-11 -72q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39z M484 765l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 546,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l19 124v3l1 2q-2 11 -13 11h-148q-14 0 -17 -16l-83 -525q0 -1 -0.5 -3t-0.5 -3q0 -9 12 -9h153q11 0 14 15l25 157h130l-25 -158q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM415 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 481,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-12 -75h-130l11 70v2q0 6 -8 6h-125q-9 0 -11 -8l-48 -298v-2q-1 -2 -1 -3q0 -9 8 -9h125q10 0 13 14l9 61h130l-11 -72q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39z M350 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 546,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l19 124v3l1 2q-2 11 -13 11h-148q-14 0 -17 -16l-83 -525q0 -1 -0.5 -3t-0.5 -3q0 -9 12 -9h153q11 0 14 15l25 157h130l-25 -158q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM388 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 481,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-12 -75h-130l11 70v2q0 6 -8 6h-125q-9 0 -11 -8l-48 -298v-2q-1 -2 -1 -3q0 -9 8 -9h125q10 0 13 14l9 61h130l-11 -72q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39z M323 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 546,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l19 124v3l1 2q-2 11 -13 11h-148q-14 0 -17 -16l-83 -525q0 -1 -0.5 -3t-0.5 -3q0 -9 12 -9h153q11 0 14 15l25 157h130l-25 -158q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM550 1014l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 481,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-12 -75h-130l11 70v2q0 6 -8 6h-125q-9 0 -11 -8l-48 -298v-2q-1 -2 -1 -3q0 -9 8 -9h125q10 0 13 14l9 61h130l-11 -72q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39z M486 774l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 565,
    d: "M536 1014l-158 -158h-69l-110 158h115l43 -58h3l61 58h115zM153 800h294q54 0 89 -32t35 -83q0 -1 -2 -23l-82 -518q-9 -60 -58 -102q-48 -42 -108 -42h-294zM263 670l-85 -540h164q12 0 15 14l82 518v2q0 6 -12 6h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 626,
    d: "M703 766l-27 -169h-115l27 169h115zM523 707h1l-112 -707h-130l7 47l-38 -13q-25 -9 -47 -16q-82 -28 -112 -28q-34 0 -53.5 19.5t-19.5 54.5q0 1 2 23l56 350q8 56 53 95q46 39 100 38h142l22 137l9 57h130zM309 176l40 251v3q0 11 -10 12h-119q-14 0 -15 -15l-44 -277 v-3q0 -11 8 -11q16 0 140 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 565,
    d: "M153 800h294q54 0 89 -32t35 -83q0 -1 -2 -23l-82 -518q-9 -60 -58 -102q-48 -42 -108 -42h-294l58 368h-51l20 129h51zM439 662v2q0 6 -12 6h-164l-27 -173h94l-20 -129h-95l-37 -238h164q12 0 15 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dslash",
    unicode: "\u0111",
    horizAdvX: 518,
    d: "M587 714l-19 -114h-61l-95 -600h-130l7 47l-38 -13q-25 -9 -47 -16q-82 -28 -112 -28q-34 0 -53.5 19.5t-19.5 54.5q0 1 2 23l56 350q8 56 53 95q46 39 100 38h142l5 30h-132l19 114h131l8 50h130l-9 -50h63zM309 176l40 251v3q0 11 -10 12h-119q-14 0 -15 -15l-44 -277 v-3q0 -11 8 -11q16 0 140 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378zM482 976l-15 -99h-220l15 99h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 492,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-139q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM344 440h-129 q-9 0 -10 -9l-18 -116l134 55q23 11 24 31l5 30q0 9 -6 9zM435 736l-15 -99h-220l15 99h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378zM390 990h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75l-1 -2v-3q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 492,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-139q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM344 440h-129 q-9 0 -10 -9l-18 -116l134 55q23 11 24 31l5 30q0 9 -6 9zM344 750h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75l-1 -2v-3q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378zM373 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 492,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-139q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM344 440h-129 q-9 0 -10 -9l-18 -116l134 55q23 11 24 31l5 30q0 9 -6 9zM327 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22l38 -64q-65 -48 -129 -48q-40 0 -65.5 25.5t-25.5 66.5q0 31 17 62h-241l126 800h378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 492,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22l38 -64q-65 -48 -129 -48q-40 0 -65.5 25.5 t-25.5 66.5q0 31 17 62h-2q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM345 401l5 30q0 9 -6 9h-129q-9 0 -10 -9l-18 -116l134 55q23 11 24 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378zM536 1014l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 492,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-139q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM344 440h-129 q-9 0 -10 -9l-18 -116l134 55q23 11 24 31l5 30q0 9 -6 9zM490 774l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 541,
    d: "M284 806h145q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l20 126v2q0 12 -11 12h-145q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h145q15 0 17 14l26 168h-122l22 130h252l-48 -298q-11 -61 -59 -102q-48 -42 -108 -42h-145q-54 0 -88.5 34.5t-34.5 86.5 q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM400 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 512,
    d: "M230 571h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-74 -463q-9 -55 -53 -93t-100 -38h-138q-49 0 -82 31t-33 76q0 13 3 26l7 32h130l-5 -21v-3l-1 -2q0 -9 7 -9h129q7 0 9 11l21 129q-145 -63 -189 -63q-36 0 -59 23t-23 57q0 13 1 16l45 291q7 54 53 94q47 39 101 39z M343 441h-128q-7 0 -10 -9l-38 -236v-4q0 -8 7 -8q38 0 148 70l28 178v3q0 6 -7 6zM356 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 541,
    d: "M284 806h145q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l20 126v2q0 12 -11 12h-145q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h145q15 0 17 14l26 168h-122l22 130h252l-48 -298q-11 -61 -59 -102q-48 -42 -108 -42h-145q-54 0 -88.5 34.5t-34.5 86.5 q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM390 990h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75l-1 -2v-3q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 512,
    d: "M230 571h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-74 -463q-9 -55 -53 -93t-100 -38h-138q-49 0 -82 31t-33 76q0 13 3 26l7 32h130l-5 -21v-3l-1 -2q0 -9 7 -9h129q7 0 9 11l21 129q-145 -63 -189 -63q-36 0 -59 23t-23 57q0 13 1 16l45 291q7 54 53 94q47 39 101 39z M343 441h-128q-7 0 -10 -9l-38 -236v-4q0 -8 7 -8q38 0 148 70l28 178v3q0 6 -7 6zM346 750h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75l-1 -2v-3q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 541,
    d: "M284 806h145q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l20 126v2q0 12 -11 12h-145q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h145q15 0 17 14l26 168h-122l22 130h252l-48 -298q-11 -61 -59 -102q-48 -42 -108 -42h-145q-54 0 -88.5 34.5t-34.5 86.5 q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM373 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 512,
    d: "M230 571h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-74 -463q-9 -55 -53 -93t-100 -38h-138q-49 0 -82 31t-33 76q0 13 3 26l7 32h130l-5 -21v-3l-1 -2q0 -9 7 -9h129q7 0 9 11l21 129q-145 -63 -189 -63q-36 0 -59 23t-23 57q0 13 1 16l45 291q7 54 53 94q47 39 101 39z M343 441h-128q-7 0 -10 -9l-38 -236v-4q0 -8 7 -8q38 0 148 70l28 178v3q0 6 -7 6zM329 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 541,
    d: "M284 806h145q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l20 126v2q0 12 -11 12h-145q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h145q15 0 17 14l26 168h-122l22 130h252l-48 -298q-11 -61 -59 -102q-48 -42 -108 -42h-145q-54 0 -88.5 34.5t-34.5 86.5 q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM280 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 512,
    d: "M249 631l25 169h115l-25 -169h-115zM230 571h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-74 -463q-9 -55 -53 -93t-100 -38h-138q-49 0 -82 31t-33 76q0 13 3 26l7 32h130l-5 -21v-3l-1 -2q0 -9 7 -9h129q7 0 9 11l21 129q-145 -63 -189 -63q-36 0 -59 23t-23 57 q0 13 1 16l45 291q7 54 53 94q47 39 101 39zM343 441h-128q-7 0 -10 -9l-38 -236v-4q0 -8 7 -8q38 0 148 70l28 178v3q0 6 -7 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 577,
    d: "M462 0h-130l59 378h-175l-59 -378h-130l126 800h130l-47 -294h175l47 294h130zM428 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 522,
    d: "M235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h1l32 205h130zM260 1000l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 576,
    d: "M627 735l-20 -130h-50l-95 -605h-130l59 378h-175l-59 -378h-130l95 605h-50l20 130h51l10 65h130l-10 -65h175l10 65h130l-10 -65h49zM411 506l16 99h-175l-16 -99h175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 523,
    d: "M236 560l-8 -47q136 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q2 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h1l6 40h-62l19 114h61l8 51h130l-8 -51h132l-19 -114h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 283,
    d: "M102 864l13 111q31 31 67 31q26 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-40 18 -64 18q-33 0 -61 -27zM162 0h-130l126 800h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 298,
    d: "M63 624l13 111q31 31 67 31q25 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-41 18 -64 18q-32 0 -61 -27zM252 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l66 418h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 283,
    d: "M162 0h-130l126 800h130zM364 976l-15 -99h-220l15 99h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 298,
    d: "M252 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l66 418h132zM325 736l-15 -99h-220l15 99h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 283,
    d: "M273 990h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75v-2q-1 -2 -1 -3q0 -15 19 -15q20 0 25 20zM162 0h-130l126 800h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 298,
    d: "M234 750h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75l-1 -2v-3q0 -15 19 -15q20 0 25 20zM252 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l66 418h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 283,
    d: "M162 2l1 -2q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22l38 -64q-65 -48 -129 -48q-40 0 -65.5 25.5t-25.5 66.5q0 39 25 76l124 786h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 298,
    d: "M274 765l-17 -106h-130l17 106h130zM256 -52l38 -64q-64 -48 -129 -48q-39 -3 -65 25t-26 67t28 80q-61 34 -61 109q0 3 2 25l66 418h132l-66 -418v-6q0 -16 20 -16h54l-20 -130h-1q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idot",
    unicode: "\u0130",
    horizAdvX: 283,
    d: "M162 0h-130l126 800h130zM256 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 298,
    d: "M252 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l66 418h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 793,
    d: "M819 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-146q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l25 158h130l-25 -158v-2q0 -12 11 -12h146q15 0 17 14l105 666h130zM162 0h-130l126 800h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 576,
    d: "M268 659h-130l17 106h130zM596 765l-17 -106h-131l17 106h131zM252 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l66 418h132zM566 560l-89 -565q-11 -63 -63 -108t-115 -44h-71l19 130h70q25 0 28 22l89 565h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 510,
    d: "M536 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-146q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l25 158h130l-25 -158v-2q0 -12 11 -12h146q15 0 17 14l105 666h130zM530 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 278,
    d: "M257 560l-89 -565q-10 -63 -63 -108q-52 -45 -115 -44h-71l19 130h70q25 0 28 22l89 565h132zM255 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 595,
    d: "M423 446l-1 -9l118 -437h-137l-99 377h-89l-59 -377h-129l126 800h129l-47 -294h89l205 294h137zM319 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 543,
    d: "M234 560l-8 -47q138 56 189 56q35 0 58 -22.5t23 -56.5q0 -1 -2 -17l-24 -150q-5 -40 -33.5 -74t-67.5 -49l69 -200h-142l-63 190h-58l-28 -190h-129l87 560l33 205h129zM341 329l16 90q2 8 -5 8q-6 0 -57 -15t-90 -30l-9 -62h136q8 0 9 9zM270 -41l-25 -169h-115l25 169 h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 518,
    d: "M234 560l-8 -47q138 56 189 56q35 0 58 -22.5t23 -56.5q0 -1 -2 -17l-24 -150q-5 -40 -33.5 -74t-67.5 -49l69 -200h-142l-63 190h-58l-28 -190h-129l87 560h129zM341 329l16 90q2 8 -5 8q-6 0 -57 -15t-90 -30l-9 -62h136q8 0 9 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 455,
    d: "M409 1005l-122 -131h-126l123 131h125zM177 130h247l-21 -130h-376l126 800h129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 298,
    d: "M408 1005l-122 -131h-126l123 131h125zM186 142v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l20 129l78 493h133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 455,
    d: "M177 130h247l-21 -130h-376l126 800h129zM239 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 298,
    d: "M175 142v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44t-27 108l20 129l78 493h133zM172 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 455,
    d: "M177 130h247l-21 -130h-376l126 800h129zM488 764l-27 -169h-115l27 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 356,
    d: "M186 142v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l20 129l78 493h133zM436 764l-27 -169h-115l27 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 455,
    d: "M177 130h247l-21 -130h-376l126 800h129zM371 529q25 0 42 -16.5t17 -40.5q0 -9 -1 -12q-4 -28 -27 -48t-52 -20q-25 0 -42 16.5t-17 41.5q0 31 25 55t55 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 351,
    d: "M184 142v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l21 129l77 493h133zM336 529q25 0 42 -16.5t17 -40.5q0 -9 -1 -12q-4 -28 -27 -48t-52 -20q-25 0 -42 16.5t-17 41.5q0 31 25 55t55 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 455,
    d: "M177 130h247l-21 -130h-376l54 341l-64 -23l20 129l64 24l52 329h129l-44 -279l71 26l-20 -129l-71 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 310,
    d: "M212 387l-39 -245v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44t-27 108l21 129l10 65l-48 -18l20 129l48 18l47 299h133l-39 -248l83 31l-20 -129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 629,
    d: "M514 0h-223l-21 670h-7l-106 -670h-130l126 800h225l19 -670h8l105 670h130zM586 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 522,
    d: "M235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h130zM495 765l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 629,
    d: "M514 0h-223l-21 670h-7l-106 -670h-130l126 800h225l19 -670h8l105 670h130zM325 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 522,
    d: "M235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h130zM270 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 629,
    d: "M514 0h-223l-21 670h-7l-106 -670h-130l126 800h225l19 -670h8l105 670h130zM588 1014l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 522,
    d: "M235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h130zM496 774l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 522,
    d: "M235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h130zM110 764l-27 -169h-115l27 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 630,
    d: "M510 800h130l-126 -805q-9 -60 -62 -107q-52 -46 -115 -45h-90l20 130h88q25 0 28 22l1 5h-93l-21 670h-7l-106 -670h-130l126 800h225l19 -670h7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 522,
    d: "M235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473l-1 -8q-7 -62 -60 -106q-54 -44 -116 -43h-90l19 130h88q25 0 29 22l1 5l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11zM496 976l-15 -99h-220l15 99h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 507,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39zM345 440h-131q-6 0 -9 -8l-47 -298q-1 -1 -1 -6q0 -8 5 -8h130q8 0 11 14l47 298q2 8 -5 8zM440 736l-15 -99h-220 l15 99h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11zM405 990h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75v-2q-1 -2 -1 -3q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 507,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39zM345 440h-131q-6 0 -9 -8l-47 -298q-1 -1 -1 -6q0 -8 5 -8h130q8 0 11 14l47 298q2 8 -5 8zM349 750h74 q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75v-2q-1 -2 -1 -3q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11zM465 1005l-121 -131h-112l123 131h110zM605 1005l-121 -131h-112l123 131h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 507,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39zM345 440h-131q-6 0 -9 -8l-47 -298q-1 -1 -1 -6q0 -8 5 -8h130q8 0 11 14l47 298q2 8 -5 8zM410 765l-121 -131h-112 l123 131h110zM550 765l-121 -131h-112l123 131h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 781,
    d: "M806 670h-248l-26 -164h221l-20 -130h-221l-39 -246h248l-21 -130h-351q-20 -11 -43 -11h-151q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l84 529q11 61 58 102q50 42 109 42h151q14 0 25 -6h366zM343 135l84 527q0 2 1 3v2q0 9 -13 9h-151q-8 0 -11 -2.5t-5 -11.5l-84 -530 v-3l-1 -2q0 -9 13 -9h151q14 0 16 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 766,
    d: "M505 570h138q50 0 82 -32t32 -81q0 -2 -2 -20l-15 -97q-5 -30 -67 -61l-234 -103l-6 -42q-1 -2 -1 -7q0 -7 6 -7h127q9 0 12 14l9 61h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-138q-37 0 -65 14q-36 -14 -71 -14h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314 q7 54 53 94q45 39 101 39h139q32 0 66 -14q37 14 70 14zM166 120h122q12 0 15 14l47 298v2q0 6 -6 6h-128q-8 0 -10 -8l-48 -298v-3l-1 -2q0 -9 9 -9zM620 402l4 30v2q0 6 -7 6h-128q-7 0 -9 -8l-19 -117l125 50q31 19 34 37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 563,
    d: "M153 800h314q44 0 73.5 -29t29.5 -72q0 -1 -2 -19l-23 -144q-6 -38 -31 -70t-61 -48q29 -13 46 -40t17 -62q0 -14 -1 -18l-47 -298h-130l47 298q0 4 0.5 8t1 7t0.5 5v3q0 22 -16 32h-158l-56 -353h-130zM234 483h152q14 6 19 15.5t9 35.5l20 126q0 12 -11 12h-160z M570 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 486,
    d: "M235 560l-8 -47q138 56 189 56q36 0 58.5 -23t22.5 -57q0 -13 -1 -16l-15 -100h-130l6 43v5q0 7 -6 7t-144 -45l-60 -383h-130l88 560h130zM364 765l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 563,
    d: "M153 800h314q44 0 73.5 -29t29.5 -72q0 -1 -2 -19l-23 -144q-6 -38 -31 -70t-61 -48q29 -13 46 -40t17 -62q0 -14 -1 -18l-47 -298h-130l47 298q0 4 0.5 8t1 7t0.5 5v3q0 22 -16 32h-158l-56 -353h-130zM234 483h152q14 6 19 15.5t9 35.5l20 126q0 12 -11 12h-160z M286 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 486,
    d: "M235 560l-8 -47q138 56 189 56q36 0 58.5 -23t22.5 -57q0 -13 -1 -16l-15 -100h-130l6 43v5q0 7 -6 7t-144 -45l-60 -383h-130l88 560h130zM140 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 563,
    d: "M153 800h314q44 0 73.5 -29t29.5 -72q0 -1 -2 -19l-23 -144q-6 -38 -31 -70t-61 -48q29 -13 46 -40t17 -62q0 -14 -1 -18l-47 -298h-130l47 298q0 4 0.5 8t1 7t0.5 5v3q0 22 -16 32h-158l-56 -353h-130zM234 483h152q14 6 19 15.5t9 35.5l20 126q0 12 -11 12h-160z M571 1014l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 486,
    d: "M235 560l-8 -47q138 56 189 56q36 0 58.5 -23t22.5 -57q0 -13 -1 -16l-15 -100h-130l6 43v5q0 7 -6 7t-144 -45l-60 -383h-130l88 560h130zM366 774l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 527,
    d: "M279 806h139q54 0 88.5 -39t34.5 -98q0 -3 -2 -27h-130q1 4 1 15q0 19 -12 19h-139q-12 0 -17 -14l-8 -55q-1 -3 -1 -12q0 -36 34 -65q21 -16 32 -23l43 -26q6 -5 10 -6q114 -71 114 -210q0 -31 -4 -54l-12 -77q-11 -61 -59 -102q-48 -42 -108 -42h-139q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l23 148h130l-23 -148v-2q0 -12 11 -12h139q12 0 17 14l12 77q2 14 2 29q0 45 -26 82q-7 12 -32 31q-23 19 -34 25l-41 26q-100 61 -100 167q0 18 3 36l8 55q11 61 58 102q50 42 109 42zM529 1006l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 490,
    d: "M221 570h139q46 0 80 -33t34 -80q0 -2 -2 -20l-5 -30h-130l3 20v3l1 2q0 8 -8 8h-126q-9 0 -12 -13v-8q-5 -25 36 -47l34 -18l43 -18q122 -48 122 -150q0 -3 -2 -27l-6 -36q-10 -59 -54 -96q-43 -37 -100 -37h-139q-45 0 -80 33q-33 35 -33 82q0 14 1 18l14 89h130 l-12 -79q0 -2 -1 -3v-2q0 -8 8 -8h127q8 0 11 13l3 18l1 3v6q0 25 -27 44q-10 9 -38 19q-5 3 -23 10t-20 8q-128 53 -128 146q0 1 2 25l3 25q10 59 53.5 96t100.5 37zM477 765l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 527,
    d: "M279 806h139q54 0 88.5 -39t34.5 -98q0 -3 -2 -27h-130q1 4 1 15q0 19 -12 19h-139q-12 0 -17 -14l-8 -55q-1 -3 -1 -12q0 -36 34 -65q21 -16 32 -23l43 -26q6 -5 10 -6q114 -71 114 -210q0 -31 -4 -54l-12 -77q-11 -61 -59 -102q-48 -42 -108 -42h-139q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l23 148h130l-23 -148v-2q0 -12 11 -12h139q12 0 17 14l12 77q2 14 2 29q0 45 -26 82q-7 12 -32 31q-23 19 -34 25l-41 26q-100 61 -100 167q0 18 3 36l8 55q11 61 58 102q50 42 109 42zM395 1036l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 490,
    d: "M221 570h139q46 0 80 -33t34 -80q0 -2 -2 -20l-5 -30h-130l3 20v3l1 2q0 8 -8 8h-126q-9 0 -12 -13v-8q-5 -25 36 -47l34 -18l43 -18q122 -48 122 -150q0 -3 -2 -27l-6 -36q-10 -59 -54 -96q-43 -37 -100 -37h-139q-45 0 -80 33q-33 35 -33 82q0 14 1 18l14 89h130 l-12 -79q0 -2 -1 -3v-2q0 -8 8 -8h127q8 0 11 13l3 18l1 3v6q0 25 -27 44q-10 9 -38 19q-5 3 -23 10t-20 8q-128 53 -128 146q0 1 2 25l3 25q10 59 53.5 96t100.5 37zM343 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 527,
    d: "M539 642h-130q1 4 1 15q0 19 -12 19h-139q-12 0 -17 -14l-8 -55q-1 -3 -1 -12q0 -36 34 -65q21 -16 32 -23l43 -26q6 -5 10 -6q114 -71 114 -210q0 -31 -4 -54l-12 -77q-11 -61 -59 -102q-48 -42 -108 -42h-18l-6 -17q32 -12 52 -40.5t20 -63.5q0 -57 -47 -101t-111 -44 q-38 0 -91 38l60 79q36 -17 47 -17q40 0 40 31q0 21 -21 21h-75l31 114h-20q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l23 148h130l-23 -148v-2q0 -12 11 -12h139q12 0 17 14l12 77q2 14 2 29q0 45 -26 82q-7 12 -32 31q-23 19 -34 25l-41 26q-100 61 -100 167q0 18 3 36l8 55 q11 61 58 102q50 42 109 42h139q54 0 88.5 -39t34.5 -98q0 -3 -2 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 490,
    d: "M221 570h139q46 0 80 -33t34 -80q0 -2 -2 -20l-5 -30h-130l3 20v3l1 2q0 8 -8 8h-126q-9 0 -12 -13v-8q-5 -25 36 -47l34 -18l43 -18q122 -48 122 -150q0 -3 -2 -27l-6 -36q-10 -59 -54 -96q-43 -37 -100 -37h-21l-6 -17q32 -12 52 -40.5t20 -63.5q0 -57 -47 -101 t-111 -44q-38 0 -91 38l60 79q36 -17 47 -17q40 0 40 31q0 21 -21 21h-75l31 114h-17q-45 0 -80 33q-33 35 -33 82q0 14 1 18l14 89h130l-12 -79q0 -2 -1 -3v-2q0 -8 8 -8h127q8 0 11 13l3 18l1 3v6q0 25 -27 44q-10 9 -38 19q-5 3 -23 10t-20 8q-128 53 -128 146q0 1 2 25 l3 25q10 59 53.5 96t100.5 37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 527,
    d: "M279 806h139q54 0 88.5 -39t34.5 -98q0 -3 -2 -27h-130q1 4 1 15q0 19 -12 19h-139q-12 0 -17 -14l-8 -55q-1 -3 -1 -12q0 -36 34 -65q21 -16 32 -23l43 -26q6 -5 10 -6q114 -71 114 -210q0 -31 -4 -54l-12 -77q-11 -61 -59 -102q-48 -42 -108 -42h-139q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l23 148h130l-23 -148v-2q0 -12 11 -12h139q12 0 17 14l12 77q2 14 2 29q0 45 -26 82q-7 12 -32 31q-23 19 -34 25l-41 26q-100 61 -100 167q0 18 3 36l8 55q11 61 58 102q50 42 109 42zM531 1015l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 490,
    d: "M221 570h139q46 0 80 -33t34 -80q0 -2 -2 -20l-5 -30h-130l3 20v3l1 2q0 8 -8 8h-126q-9 0 -12 -13v-8q-5 -25 36 -47l34 -18l43 -18q122 -48 122 -150q0 -3 -2 -27l-6 -36q-10 -59 -54 -96q-43 -37 -100 -37h-139q-45 0 -80 33q-33 35 -33 82q0 14 1 18l14 89h130 l-12 -79q0 -2 -1 -3v-2q0 -8 8 -8h127q8 0 11 13l3 18l1 3v6q0 25 -27 44q-10 9 -38 19q-5 3 -23 10t-20 8q-128 53 -128 146q0 1 2 25l3 25q10 59 53.5 96t100.5 37zM478 774l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcedilla",
    unicode: "\u0162",
    horizAdvX: 474,
    d: "M90 800h458l-20 -130h-164l-106 -670h-14l-10 -27q32 -12 52 -40.5t20 -63.5q0 -57 -47 -101t-111 -44q-38 0 -91 38l60 79q36 -17 47 -17q40 0 40 31q0 21 -21 21h-75l34 124h-14l106 670h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcedilla",
    unicode: "\u0163",
    horizAdvX: 367,
    d: "M237 432l-46 -290v-6q0 -16 20 -16h54l-20 -130h-57h-9l-6 -17q32 -12 52 -40.5t20 -63.5q0 -57 -47 -101t-111 -44q-38 0 -91 38l60 79q36 -17 47 -17q40 0 40 31q0 21 -21 21h-75l38 135l5 19q-33 34 -33 87q0 3 2 25l46 290h-73l20 128h74l23 144h132l-23 -144h138 l-21 -128h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 474,
    d: "M528 670h-164l-106 -670h-130l106 670h-164l20 130h458zM513 1014l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 395,
    d: "M509 764l-27 -169h-115l27 169h115zM191 142v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44t-27 108l46 290h-73l20 128h74l23 144h132l-23 -144h138l-21 -128h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 474,
    d: "M528 670h-164l-41 -260h141l-20 -130h-142l-44 -280h-130l44 280h-127l20 130h128l41 260h-164l20 130h458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 367,
    d: "M375 432h-138l-16 -98h133l-19 -114h-132l-12 -78v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44t-27 108l12 78h-58l19 114h57l16 98h-73l20 128h74l23 144h132l-23 -144h138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 561,
    d: "M581 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149q15 0 17 14l105 666h130zM241 864l13 111q31 31 67 31q25 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32 q-24 0 -67 17q-40 18 -64 18q-32 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 522,
    d: "M287 0l8 47q-137 -57 -189 -57q-36 0 -58.5 23t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130l-88 -560h-130zM174 624l13 111q31 31 67 31q26 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-40 18 -64 18 q-33 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 561,
    d: "M581 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149q15 0 17 14l105 666h130zM504 976l-15 -99h-220l15 99h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 522,
    d: "M287 0l8 47q-137 -57 -189 -57q-36 0 -58.5 23t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130l-88 -560h-130zM437 736l-15 -99h-220l15 99h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 561,
    d: "M581 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149q15 0 17 14l105 666h130zM413 990h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75v-2q-1 -2 -1 -3 q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 522,
    d: "M287 0l8 47q-137 -57 -189 -57q-36 0 -58.5 23t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130l-88 -560h-130zM345 750h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75v-2q-1 -2 -1 -3q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 561,
    d: "M581 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149q15 0 17 14l105 666h130zM408 1075q47 0 76.5 -31.5t29.5 -77.5t-40 -93q-39 -47 -105 -47q-48 0 -78 31.5t-30 79.5 q0 45 38 92q39 46 109 46zM395 996q-20 0 -37 -16.5t-17 -35.5q0 -16 11.5 -28t28.5 -12q20 0 37 16.5t17 35.5q0 16 -11.5 28t-28.5 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 522,
    d: "M341 835q47 0 76.5 -31.5t29.5 -77.5t-40 -93q-39 -47 -105 -47q-48 0 -78 31.5t-30 79.5q0 45 38 92q39 46 109 46zM328 756q-20 0 -37 -16.5t-17 -35.5q0 -16 12 -28t28 -12q20 0 37 16.5t17 35.5q0 16 -12 28t-28 12zM287 0l8 47q-137 -57 -189 -57q-36 0 -58.5 23 t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130l-88 -560h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 561,
    d: "M581 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149q15 0 17 14l105 666h130zM473 1005l-121 -131h-112l123 131h110zM613 1005l-121 -131h-112l123 131h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 522,
    d: "M287 0l8 47q-137 -57 -189 -57q-36 0 -58.5 23t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130l-88 -560h-130zM406 765l-121 -131h-112l123 131h110zM546 765l-121 -131h-112l123 131h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 561,
    d: "M451 800h130l-105 -666q-11 -61 -58 -102q-48 -40 -108 -42q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22l38 -64q-64 -48 -129 -48q-40 0 -65.5 25.5t-25.5 66.5q0 31 17 62h-13q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149 q15 0 17 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 522,
    d: "M417 0h-3q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22l38 -64q-64 -48 -129 -48q-40 0 -65.5 25.5t-25.5 66.5q0 46 31 83l4 26q-137 -57 -189 -57q-36 0 -58.5 23t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 850,
    d: "M564 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69zM870 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-80q-49 0 -82 28t-40 74q-21 -45 -64 -73.5t-92 -28.5h-80q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h80 q33 0 59 32q25 32 30 57l93 591h130l-93 -591q-4 -25 11 -58q16 -31 48 -31h80q15 0 17 14l105 666h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 765,
    d: "M486 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69zM753 560l-66 -420q-10 -66 -53.5 -108t-103.5 -42h-66q-45 0 -75.5 25.5t-37.5 70.5q-20 -45 -59 -70.5t-84 -25.5h-65q-52 0 -81.5 32.5t-29.5 86.5q0 17 2 31l66 420h130l-66 -420v-5q0 -15 15 -15h49 q64 0 79 95l54 345h130l-54 -345q-3 -19 -3 -34q0 -61 50 -61h50q20 0 23 20l66 420h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 569,
    d: "M634 800l-209 -546q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130zM414 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 527,
    d: "M511 560l-92 -582q-9 -57 -54 -94q-43 -39 -100 -39h-261l20 130h254q9 0 11 11l12 70q-135 -59 -187 -59q-36 0 -59 23.5t-23 58.5q0 12 1 15l74 466h130l-65 -406q-1 -2 -1 -8q0 -7 7 -7q16 0 144 45l59 376h130zM380 795l108 -158h-115l-42 58h-3l-62 -58h-115 l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 569,
    d: "M298 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM466 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM634 800l-209 -546 q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 503,
    d: "M194 130h257l-21 -130h-446l364 670h-258l20 130h446zM503 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 462,
    d: "M459 765l-122 -131h-126l123 131h125zM452 434l-301 -305h256l-21 -129h-400l21 130l299 304h-249l19 126h395z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 503,
    d: "M194 130h257l-21 -130h-446l364 670h-258l20 130h446zM342 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 462,
    d: "M298 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5zM452 434l-301 -305h256l-21 -129h-400l21 130l299 304h-249l19 126h395z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 503,
    d: "M194 130h257l-21 -130h-446l364 670h-258l20 130h446zM505 1014l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 462,
    d: "M461 774l-158 -158h-69l-110 158h115l43 -58h3l61 58h115zM452 434l-301 -305h256l-21 -129h-400l21 130l299 304h-249l19 126h395z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "longs",
    unicode: "\u017F",
    horizAdvX: 315,
    d: "M392 765l-22 -130h-94q-23 0 -26 -21l-98 -618q-11 -63 -62 -107q-52 -44 -116 -44l19 130q23 0 27 21l69 435h-55l20 129h55l10 54q11 63 62 107q52 45 114 44h97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 399,
    d: "M418 760l-22 -130h-89q-23 2 -26 -21l-27 -163h66l-20 -129h-66l-50 -321q-11 -63 -62 -107q-52 -44 -116 -44l19 130q23 0 27 21l51 321h-40l20 129h40l27 163q9 62 60 107q53 45 116 44h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "DZcaron",
    unicode: "\u01C4",
    horizAdvX: 1068,
    d: "M153 800h294q54 0 89 -32t35 -83q0 -1 -2 -23l-82 -518q-9 -60 -58 -102q-48 -42 -108 -42h-294zM1121 800l-362 -670h257l-21 -130h-446l364 670h-258l20 130h446zM263 670l-85 -540h164q12 0 15 14l82 518v2q0 6 -12 6h-164zM1098 1014l-158 -158h-69l-110 158h115 l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dzcaron",
    unicode: "\u01C5",
    horizAdvX: 1026,
    d: "M153 800h294q54 0 89 -32t35 -83q0 -1 -2 -23l-82 -518q-9 -60 -58 -102q-48 -42 -108 -42h-294zM1060 774l-158 -158h-69l-110 158h115l43 -58h3l61 58h115zM263 670l-85 -540h164q12 0 15 14l82 518v2q0 6 -12 6h-164zM1036 560l-19 -126l-301 -305h256l-21 -129h-400 l21 130l299 304h-249l19 126h395z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dzcaron",
    unicode: "\u01C6",
    horizAdvX: 979,
    d: "M523 707h1l-112 -707h-130l7 47l-38 -13q-25 -9 -47 -16q-82 -28 -112 -28q-34 0 -53.5 19.5t-19.5 54.5q0 1 2 23l56 350q8 56 53 95q46 39 100 38h142l22 137l9 57h130zM988 560l-19 -126l-301 -305h256l-21 -129h-400l21 130l299 304h-249l19 126h395zM309 176l40 251 v3q0 11 -10 12h-119q-14 0 -15 -15l-44 -277v-3q0 -11 8 -11q16 0 140 40zM978 774l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "LJ",
    unicode: "\u01C7",
    horizAdvX: 965,
    d: "M177 130h247l-21 -130h-376l126 800h129zM991 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-146q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l25 158h130l-25 -158v-2q0 -12 11 -12h146q15 0 17 14l105 666h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lj",
    unicode: "\u01C8",
    horizAdvX: 733,
    d: "M177 130h247l-21 -130h-376l126 800h129zM742 765l-17 -106h-131l17 106h131zM712 560l-89 -565q-11 -63 -63 -108t-115 -44h-71l19 130h70q25 0 28 22l89 565h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lj",
    unicode: "\u01C9",
    horizAdvX: 576,
    d: "M579 659h-131l17 106h131zM186 142v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l20 129l78 493h133zM566 560l-89 -565q-11 -63 -63 -108t-115 -44h-71l19 130h70q25 0 28 22l89 565h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NJ",
    unicode: "\u01CA",
    horizAdvX: 1139,
    d: "M514 0h-223l-21 670h-7l-106 -670h-130l126 800h225l19 -670h8l105 670h130zM1165 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-146q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l25 158h130l-25 -158v-2q0 -12 11 -12h146q15 0 17 14l105 666h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nj",
    unicode: "\u01CB",
    horizAdvX: 908,
    d: "M514 0h-223l-21 670h-7l-106 -670h-130l126 800h225l19 -670h8l105 670h130zM916 765l-17 -106h-131l17 106h131zM886 560l-89 -565q-11 -63 -63 -108t-115 -44h-71l19 130h70q25 0 28 22l89 565h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nj",
    unicode: "\u01CC",
    horizAdvX: 800,
    d: "M792 659h-131l17 106h131zM235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h130zM779 560l-89 -565q-10 -63 -63 -108q-52 -45 -115 -44h-71l19 130h70q25 0 28 22l89 565h132z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22l38 -64q-65 -48 -129 -48q-40 0 -65.5 25.5t-25.5 66.5q0 31 17 62h-13q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528 q11 61 58 102q49 42 109 42zM342 134l83 528v3q0 11 -11 11h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 507,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22l38 -64q-65 -48 -129 -48q-40 0 -65.5 25.5t-25.5 66.5q0 31 17 62h-2q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39z M303 134l47 298q2 8 -5 8h-131q-6 0 -9 -8l-47 -298q-1 -1 -1 -6q0 -8 5 -8h130q8 0 11 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "DZ",
    unicode: "\u01F1",
    horizAdvX: 1068,
    d: "M153 800h294q54 0 89 -32t35 -83q0 -1 -2 -23l-82 -518q-9 -60 -58 -102q-48 -42 -108 -42h-294zM1121 800l-362 -670h257l-21 -130h-446l364 670h-258l20 130h446zM263 670l-85 -540h164q12 0 15 14l82 518v2q0 6 -12 6h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dz",
    unicode: "\u01F2",
    horizAdvX: 1026,
    d: "M153 800h294q54 0 89 -32t35 -83q0 -1 -2 -23l-82 -518q-9 -60 -58 -102q-48 -42 -108 -42h-294zM263 670l-85 -540h164q12 0 15 14l82 518v2q0 6 -12 6h-164zM1036 560l-19 -126l-301 -305h256l-21 -129h-400l21 130l299 304h-249l19 126h395z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dz",
    unicode: "\u01F3",
    horizAdvX: 979,
    d: "M523 707h1l-112 -707h-130l7 47l-38 -13q-25 -9 -47 -16q-82 -28 -112 -28q-34 0 -53.5 19.5t-19.5 54.5q0 1 2 23l56 350q8 56 53 95q46 39 100 38h142l22 137l9 57h130zM988 560l-19 -126l-301 -305h256l-21 -129h-400l21 130l299 304h-249l19 126h395zM309 176l40 251 v3q0 11 -10 12h-119q-14 0 -15 -15l-44 -277v-3q0 -11 8 -11q16 0 140 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 568,
    d: "M606 1138l-122 -131h-126l123 131h125zM-28 0l246 766q9 25 36 32q-6 18 -6 39q0 45 38 92q39 46 109 46q47 0 76.5 -31.5t29.5 -77.5q0 -31 -23 -69q21 -9 28 -31v-766h-129v174h-221l-54 -174h-130zM328 844q0 -16 12 -28t28 -12q20 0 37 16.5t17 35.5q0 16 -12 28 t-28 12q-20 0 -37 -16.5t-17 -35.5zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 519,
    d: "M340 835q47 0 76.5 -31.5t29.5 -77.5t-40 -93q-39 -47 -105 -47q-48 0 -78 31.5t-30 79.5q0 45 38 92q39 46 109 46zM327 756q-20 0 -37 -16.5t-17 -35.5q0 -16 11.5 -28t28.5 -12q20 0 37 16.5t17 35.5q0 16 -11.5 28t-28.5 12zM485 120l-20 -130h-31q-42 -1 -75 20 t-48 56q-44 -23 -112 -50q-67 -27 -98 -27q-36 0 -59 23.5t-23 59.5q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139q50 0 82 -32.5t32 -80.5q0 -2 -2 -20l-47 -292q-2 -11 4 -18.5t19 -7.5h28zM309 185l41 247v2q0 7 -7 7h-126q-9 0 -12 -10l-43 -283l-1 -4q0 -9 9 -9 q25 0 139 50zM530 985l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 794,
    d: "M694 1005l-122 -131h-126l123 131h125zM819 667h-247l-26 -161h220l-20 -130h-221l-38 -246h248l-21 -130h-377l26 174h-202l-58 -174h-131l247 766q4 13 18.5 23.5t29.5 10.5h574zM443 676h-125q-4 0 -6 -6l-112 -366h184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 766,
    d: "M505 570h138q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-5 -29 -58 -55l-242 -107l-7 -42v-3q0 -11 7 -11h126q9 0 12 14l9 61h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-138q-39 0 -67.5 19.5t-39.5 52.5q-47 -23 -114 -49q-63 -23 -91 -23q-36 0 -59 23.5t-23 58.5 q0 12 1 15l56 351q7 54 53 94q47 39 101 39h139q37 0 65 -15q36 14 71 14zM311 193l39 239v3q0 6 -6 6h-129q-9 0 -10 -9l-46 -288q0 -1 -1 -2v-2q0 -8 10 -8q22 0 143 61zM620 401l4 31q2 8 -5 8h-131q-7 0 -9 -8l-18 -117l135 55q23 14 24 31zM626 765l-122 -131h-126 l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 576,
    d: "M547 1005l-122 -131h-126l123 131h125zM616 860l-64 -115q15 -25 15 -60q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-16 0 -31 3l-30 -53h-106l60 108q-16 28 -16 63q0 1 2 23l83 528q11 61 58 102q50 42 109 42h150q22 0 35 -4l32 58h105zM201 303 l207 373h-134q-14 0 -17 -14zM407 485l-203 -365h131q15 0 17 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 563,
    d: "M560 584l-56 -85q7 -21 7 -42q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-19 0 -30 4l-16 -25h-118l58 90q-8 22 -8 43q0 3 2 21l50 314q7 54 53 94q45 39 101 39h139q14 0 34 -4l12 18h117zM333 440h-91q-6 0 -9 -8l-30 -187zM226 120h94q8 0 11 14l30 188z M551 765l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scommaaccent",
    unicode: "\u0218",
    horizAdvX: 527,
    d: "M279 806h139q54 0 88.5 -39t34.5 -98q0 -3 -2 -27h-130q1 4 1 15q0 19 -12 19h-139q-12 0 -17 -14l-8 -55q-1 -3 -1 -12q0 -36 34 -65q21 -16 32 -23l43 -26q6 -5 10 -6q114 -71 114 -210q0 -31 -4 -54l-12 -77q-11 -61 -59 -102q-48 -42 -108 -42h-139q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l23 148h130l-23 -148v-2q0 -12 11 -12h139q12 0 17 14l12 77q2 14 2 29q0 45 -26 82q-7 12 -32 31q-23 19 -34 25l-41 26q-100 61 -100 167q0 18 3 36l8 55q11 61 58 102q50 42 109 42zM271 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scommaaccent",
    unicode: "\u0219",
    horizAdvX: 490,
    d: "M221 570h139q46 0 80 -33t34 -80q0 -2 -2 -20l-5 -30h-130l3 20v3l1 2q0 8 -8 8h-126q-9 0 -12 -13v-8q-5 -25 36 -47l34 -18l43 -18q122 -48 122 -150q0 -3 -2 -27l-6 -36q-10 -59 -54 -96q-43 -37 -100 -37h-139q-45 0 -80 33q-33 35 -33 82q0 14 1 18l14 89h130 l-12 -79q0 -2 -1 -3v-2q0 -8 8 -8h127q8 0 11 13l3 18l1 3v6q0 25 -27 44q-10 9 -38 19q-5 3 -23 10t-20 8q-128 53 -128 146q0 1 2 25l3 25q10 59 53.5 96t100.5 37zM254 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 474,
    d: "M528 670h-164l-106 -670h-130l106 670h-164l20 130h458zM246 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 359,
    d: "M191 142v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44t-27 108l46 290h-73l20 128h74l23 144h132l-23 -144h138l-21 -128h-138zM191 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 278,
    d: "M257 560l-89 -565q-10 -63 -63 -108q-52 -45 -115 -44h-71l19 130h70q25 0 28 22l89 565h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02BC",
    unicode: "\u02BC",
    horizAdvX: 424,
    d: "M347 764l-27 -169h-115l27 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 398,
    d: "M364 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 480,
    d: "M532 774l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 247,
    d: "M264 750h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75l-1 -2v-3q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 253,
    d: "M239 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 304,
    d: "M268 835q47 0 76.5 -31.5t29.5 -77.5t-40 -93q-39 -47 -105 -47q-48 0 -78 31.5t-30 79.5q0 45 38 92q39 46 109 46zM255 756q-20 0 -37 -16.5t-17 -35.5q0 -16 11.5 -28t28.5 -12q20 0 37 16.5t17 35.5q0 16 -11.5 28t-28.5 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 577,
    d: "M229 86l22 -77q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22l38 -64q-65 -48 -129 -48q-40 0 -65.5 25.5t-25.5 66.5q0 46 34 87q34 43 98 52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 322,
    d: "M136 624l13 111q31 31 67 31q26 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-41 18 -64 18q-33 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 428,
    d: "M391 765l-121 -131h-112l123 131h110zM531 765l-121 -131h-112l123 131h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelowcomb",
    unicode: "\u0323",
    horizAdvX: 0,
    d: "M86 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccentcomb",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M202 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tonos",
    unicode: "\u0384",
    horizAdvX: 0,
    d: "M420 802l-81 -163h-124l81 163h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresistonos",
    unicode: "\u0385",
    horizAdvX: 0,
    d: "M413 639h-124l81 163h124zM225 757q24 0 40.5 -17t16.5 -41v-3q-1 -4 -1 -6q-5 -26 -27 -44.5t-49 -18.5q-23 0 -39 15.5t-16 37.5q0 8 1 10q4 27 26 47t48 20zM550 757q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15t-16 38q0 8 1 10 q4 27 26.5 47t49.5 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Alphatonos",
    unicode: "\u0386",
    horizAdvX: 568,
    d: "M182 801l-81 -163h-124l81 163h124zM377 174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129v174zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Epsilontonos",
    unicode: "\u0388",
    horizAdvX: 478,
    d: "M137 801l-81 -163h-125l82 163h124zM263 670l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378l-21 -130h-247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etatonos",
    unicode: "\u0389",
    horizAdvX: 577,
    d: "M332 0l59 378h-175l-59 -378h-130l126 800h130l-47 -294h175l47 294h130l-126 -800h-130zM138 801l-81 -163h-124l81 163h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iotatonos",
    unicode: "\u038A",
    horizAdvX: 283,
    d: "M32 0l126 800h130l-126 -800h-130zM139 801l-81 -163h-124l81 163h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omicrontonos",
    unicode: "\u038C",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM150 801l-81 -163h-124l81 163h124zM414 676h-150q-14 0 -17 -14l-83 -528v-2 q0 -12 11 -12h150q15 0 17 14l83 528v3q0 11 -11 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Upsilontonos",
    unicode: "\u038E",
    horizAdvX: 569,
    d: "M634 800l-209 -546q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130zM92 801l-81 -163h-124l81 163h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omegatonos",
    unicode: "\u038F",
    horizAdvX: 566,
    d: "M289 806h154q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-60 -378q-8 -53 -56 -95l-9 -59h47l-21 -130h-162l43 270q27 6 31 34l56 356l1 2v4q0 10 -12 10h-154q-13 0 -16 -16l-56 -356q-2 -12 4.5 -22.5t16.5 -12.5l-43 -269h-162l21 130h47l9 59q-28 34 -28 77q0 14 1 18 l60 378q11 61 58 102q50 42 109 42zM150 801l-81 -163h-124l81 163h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresistonos",
    unicode: "\u0390",
    horizAdvX: 283,
    d: "M369 1042l-81 -163h-124l81 163h124zM99 997q24 0 40.5 -17t16.5 -41v-3q-1 -4 -1 -6q-5 -26 -27 -44.5t-49 -18.5q-23 0 -39 15.5t-16 37.5q0 8 1 10q4 27 26 47t48 20zM424 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15t-16 38 q0 8 1 10q4 27 26.5 47t49.5 20zM158 800h130l-126 -800h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Alpha",
    unicode: "\u0391",
    horizAdvX: 568,
    d: "M377 0v174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Beta",
    unicode: "\u0392",
    horizAdvX: 560,
    d: "M153 800h311q44 0 73.5 -29t29.5 -72q0 -1 -2 -19l-23 -144q-5 -38 -30 -70t-61 -48q29 -13 45.5 -40t16.5 -61q0 -14 -1 -19l-28 -178q-8 -50 -49 -85t-90 -35h-318zM234 483h157q19 8 19 44l1 7l19 124v3l1 3q0 8 -8 8h-160zM356 137l26 161v5q1 5 1 7q0 34 -14 43 h-156l-35 -223h172q5 0 6 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gamma",
    unicode: "\u0393",
    horizAdvX: 455,
    d: "M509 670h-246l-106 -670h-130l126 800h376z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "increment",
    unicode: "\u0394",
    horizAdvX: 568,
    d: "M501 766v-766h-529l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 26.5 -10.5t11.5 -23.5zM142 130h239v529q0 11 -6 11h-61q-6 0 -9 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Epsilon",
    unicode: "\u0395",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zeta",
    unicode: "\u0396",
    horizAdvX: 503,
    d: "M194 130h257l-21 -130h-446l364 670h-258l20 130h446z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eta",
    unicode: "\u0397",
    horizAdvX: 577,
    d: "M462 0h-130l59 378h-175l-59 -378h-130l126 800h130l-47 -294h175l47 294h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Theta",
    unicode: "\u0398",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11zM372 461l-16 -99h-136l16 99h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iota",
    unicode: "\u0399",
    horizAdvX: 283,
    d: "M162 0h-130l126 800h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kappa",
    unicode: "\u039A",
    horizAdvX: 595,
    d: "M423 446l-1 -9l118 -437h-137l-99 377h-89l-59 -377h-129l126 800h129l-47 -294h89l205 294h137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lambda",
    unicode: "\u039B",
    horizAdvX: 568,
    d: "M266 800h197q15 0 27 -10t16 -24v-766h-125v659q0 11 -6 11h-61q-6 0 -9 -11l-203 -659h-130l246 766q5 13 19.5 23.5t28.5 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Mu",
    unicode: "\u039C",
    horizAdvX: 802,
    d: "M792 800l-96 -800h-130l78 670h-8l-219 -660h-119l-8 660h-9l-134 -670h-130l157 800h245l-20 -522l144 522h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nu",
    unicode: "\u039D",
    horizAdvX: 629,
    d: "M514 0h-223l-21 670h-7l-106 -670h-130l126 800h225l19 -670h8l105 670h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Xi",
    unicode: "\u039E",
    horizAdvX: 656,
    d: "M624 800l-31 -200h-130l11 71h-174l-11 -71h-130l31 200h434zM536 514l-21 -129h-349l21 129h349zM590 314l-50 -314h-514l51 314h130l-30 -185h254l29 185h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omicron",
    unicode: "\u039F",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Pi",
    unicode: "\u03A0",
    horizAdvX: 575,
    d: "M459 0h-130l106 672h-172l-106 -672h-130l126 800h432z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rho",
    unicode: "\u03A1",
    horizAdvX: 530,
    d: "M153 800h290q54 0 89 -32t35 -83q0 -1 -2 -23l-30 -186q-7 -60 -57 -102q-48 -42 -108 -42h-160l-53 -332h-130zM263 670l-33 -208h160q13 0 15 14l30 187q0 7 -12 7h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sigma",
    unicode: "\u03A3",
    horizAdvX: 532,
    d: "M586 800l-20 -130h-259l53 -265l-138 -275h256l-21 -130h-445l208 403l-79 397h445z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tau",
    unicode: "\u03A4",
    horizAdvX: 474,
    d: "M528 670h-164l-106 -670h-130l106 670h-164l20 130h458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Upsilon",
    unicode: "\u03A5",
    horizAdvX: 569,
    d: "M634 800l-209 -546q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Phi",
    unicode: "\u03A6",
    horizAdvX: 652,
    d: "M458 706h53q57 0 94 -35t37 -88q0 -3 -2 -21l-52 -328q-10 -60 -60 -102t-114 -42h-53l-14 -90h-130l14 90h-53q-57 0 -94 34.5t-37 87.5l2 22l52 328q9 60 59 102q51 42 115 42h53l15 94h130zM252 220l56 356h-49q-15 0 -21.5 -5t-8.5 -19l-49 -308q-1 -3 -1 -9 q0 -15 23 -15h50zM459 244l49 308q1 3 1 9q0 15 -22 15h-49l-56 -356h48q15 0 21 5t8 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Chi",
    unicode: "\u03A7",
    horizAdvX: 543,
    d: "M370 437l110 -437h-132l-70 319l-172 -319h-134l248 435l-93 365h135l48 -275l136 275h135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Psi",
    unicode: "\u03A8",
    horizAdvX: 649,
    d: "M545 801h130l-47 -300q-25 -144 -167 -144h-60l-56 -357h-130l56 357h-59q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l47 300h130l-47 -300q0 -2 -1 -3v-2q0 -9 13 -9h59l49 313h130l-49 -313h59q14 0 17 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u03A9",
    horizAdvX: 566,
    d: "M289 806h154q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-60 -378q-8 -53 -56 -95l-9 -59h47l-21 -130h-162l43 270q27 6 31 34l56 356l1 2v4q0 10 -12 10h-154q-13 0 -16 -16l-56 -356q-2 -12 4.5 -22.5t16.5 -12.5l-43 -269h-162l21 130h47l9 59q-28 34 -28 77q0 14 1 18 l60 378q11 61 58 102q50 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iotadieresis",
    unicode: "\u03AA",
    horizAdvX: 283,
    d: "M160 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM328 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM32 0l126 800h130l-126 -800 h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Upsilondieresis",
    unicode: "\u03AB",
    horizAdvX: 569,
    d: "M300 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM468 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM634 800l-209 -546 q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alphatonos",
    unicode: "\u03AC",
    horizAdvX: 568,
    d: "M182 801l-81 -163h-124l81 163h124zM377 174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129v174zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilontonos",
    unicode: "\u03AD",
    horizAdvX: 478,
    d: "M132 801l-81 -163h-125l82 163h124zM232 476h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378l-21 -130h-247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etatonos",
    unicode: "\u03AE",
    horizAdvX: 577,
    d: "M127 801l-81 -163h-125l82 163h124zM391 378h-175l-59 -378h-130l126 800h130l-47 -294h175l47 294h130l-126 -800h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotatonos",
    unicode: "\u03AF",
    horizAdvX: 283,
    d: "M157 801l-81 -163h-125l82 163h124zM158 800h130l-126 -800h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresistonos",
    unicode: "\u03B0",
    horizAdvX: 569,
    d: "M508 1042l-81 -163h-124l81 163h124zM238 997q24 0 40.5 -17t16.5 -41l-1 -3v-6q-5 -26 -27 -44.5t-49 -18.5q-23 0 -39 15.5t-16 37.5q0 8 1 10q4 27 26 47t48 20zM563 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15t-16 38q0 8 1 10 q4 27 26.5 47t49.5 20zM634 800l-209 -546q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alpha",
    unicode: "\u03B1",
    horizAdvX: 568,
    d: "M377 174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129v174zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "beta",
    unicode: "\u03B2",
    horizAdvX: 572,
    d: "M153 800h311q44 0 73.5 -29t29.5 -72q0 -1 -2 -19l-23 -144q-5 -38 -30 -70t-61 -48q29 -13 45.5 -40t16.5 -61q0 -14 -1 -19l-28 -178q-8 -50 -49 -85t-90 -35h-318zM234 483h157q19 8 19 44l1 7l19 124v3l1 3q0 8 -8 8h-160zM356 137l26 161v5q1 5 1 7q0 34 -14 43 h-156l-35 -223h172q5 0 6 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gamma",
    unicode: "\u03B3",
    horizAdvX: 461,
    d: "M263 670l-106 -670h-130l126 800h376l-20 -130h-246z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "delta",
    unicode: "\u03B4",
    horizAdvX: 568,
    d: "M501 0h-529l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 26.5 -10.5t11.5 -23.5v-766zM381 130v529q0 11 -6 11h-61q-6 0 -9 -11l-163 -529h239z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilon",
    unicode: "\u03B5",
    horizAdvX: 478,
    d: "M263 670l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378l-21 -130h-247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeta",
    unicode: "\u03B6",
    horizAdvX: 491,
    d: "M451 130l-21 -130h-446l364 670h-258l20 130h446l-362 -670h257z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eta",
    unicode: "\u03B7",
    horizAdvX: 577,
    d: "M332 0l59 378h-175l-59 -378h-130l126 800h130l-47 -294h175l47 294h130l-126 -800h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "theta",
    unicode: "\u03B8",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11zM356 362h-136l16 99h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iota",
    unicode: "\u03B9",
    horizAdvX: 283,
    d: "M32 0l126 800h130l-126 -800h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kappa",
    unicode: "\u03BA",
    horizAdvX: 601,
    d: "M422 437l118 -437h-137l-99 377h-89l-59 -377h-129l126 800h129l-47 -294h89l205 294h137l-243 -354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lambda",
    unicode: "\u03BB",
    horizAdvX: 568,
    d: "M266 800h197q15 0 27 -10t16 -24v-766h-125v659q0 11 -6 11h-61q-6 0 -9 -11l-203 -659h-130l246 766q5 13 19.5 23.5t28.5 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\u03BC",
    horizAdvX: 803,
    d: "M696 0h-130l78 670h-8l-219 -660h-119l-8 660h-9l-134 -670h-130l157 800h245l-20 -522l144 522h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nu",
    unicode: "\u03BD",
    horizAdvX: 629,
    d: "M291 0l-21 670h-7l-106 -670h-130l126 800h225l19 -670h8l105 670h130l-126 -800h-223z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "xi",
    unicode: "\u03BE",
    horizAdvX: 656,
    d: "M593 600h-130l11 71h-174l-11 -71h-130l31 200h434zM515 385h-349l21 129h349zM540 0h-514l51 314h130l-30 -185h254l29 185h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omicron",
    unicode: "\u03BF",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 587,
    d: "M329 0l106 672h-172l-106 -672h-130l126 800h432l-126 -800h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rho",
    unicode: "\u03C1",
    horizAdvX: 548,
    d: "M153 800h290q54 0 89 -32t35 -83q0 -1 -2 -23l-30 -186q-7 -60 -57 -102q-48 -42 -108 -42h-160l-53 -332h-130zM230 462h160q13 0 15 14l30 187q0 7 -12 7h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigmafinal",
    unicode: "\u03C2",
    horizAdvX: 532,
    d: "M566 670h-259l53 -265l-138 -275h256l-21 -130h-445l208 403l-79 397h445z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigma",
    unicode: "\u03C3",
    horizAdvX: 532,
    d: "M566 670h-259l53 -265l-138 -275h256l-21 -130h-445l208 403l-79 397h445z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tau",
    unicode: "\u03C4",
    horizAdvX: 474,
    d: "M364 670l-106 -670h-130l106 670h-164l20 130h458l-20 -130h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilon",
    unicode: "\u03C5",
    horizAdvX: 569,
    d: "M634 800l-209 -546q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "phi",
    unicode: "\u03C6",
    horizAdvX: 639,
    d: "M458 706h53q57 0 94 -35t37 -88q0 -3 -2 -21l-52 -328q-10 -60 -60 -102t-114 -42h-53l-14 -90h-130l14 90h-53q-57 0 -94 34.5t-37 87.5l2 22l52 328q9 60 59 102q51 42 115 42h53l15 94h130zM308 576h-49q-15 0 -21.5 -5t-8.5 -19l-49 -308q-1 -3 -1 -9q0 -15 23 -15 h50zM459 244l49 308q1 3 1 9q0 15 -22 15h-49l-56 -356h48q15 0 21 5t8 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "chi",
    unicode: "\u03C7",
    horizAdvX: 563,
    d: "M480 0h-132l-70 319l-172 -319h-134l248 435l-93 365h135l48 -275l136 275h135l-211 -363z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "psi",
    unicode: "\u03C8",
    horizAdvX: 649,
    d: "M675 801l-47 -300q-25 -144 -167 -144h-60l-56 -357h-130l56 357h-59q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l47 300h130l-47 -300q0 -2 -1 -3v-2q0 -9 13 -9h59l49 313h130l-49 -313h59q14 0 17 14l47 300h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omega",
    unicode: "\u03C9",
    horizAdvX: 566,
    d: "M289 806h154q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-60 -378q-8 -53 -56 -95l-9 -59h47l-21 -130h-162l43 270q27 6 31 34l56 356l1 2v4q0 10 -12 10h-154q-13 0 -16 -16l-56 -356q-2 -12 4.5 -22.5t16.5 -12.5l-43 -269h-162l21 130h47l9 59q-28 34 -28 77q0 14 1 18 l60 378q11 61 58 102q50 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresis",
    unicode: "\u03CA",
    horizAdvX: 283,
    d: "M163 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM331 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM158 800h130l-126 -800h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresis",
    unicode: "\u03CB",
    horizAdvX: 569,
    d: "M302 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM470 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM634 800l-209 -546 q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omicrontonos",
    unicode: "\u03CC",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM157 801l-81 -163h-125l82 163h124zM414 676h-150q-14 0 -17 -14l-83 -528v-2 q0 -12 11 -12h150q15 0 17 14l83 528v3q0 11 -11 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilontonos",
    unicode: "\u03CD",
    horizAdvX: 569,
    d: "M634 800l-209 -546q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130zM82 801l-81 -163h-124l81 163h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omegatonos",
    unicode: "\u03CE",
    horizAdvX: 566,
    d: "M289 806h154q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-60 -378q-8 -53 -56 -95l-9 -59h47l-21 -130h-162l43 270q27 6 31 34l56 356l1 2v4q0 10 -12 10h-154q-13 0 -16 -16l-56 -356q-2 -12 4.5 -22.5t16.5 -12.5l-43 -269h-162l21 130h47l9 59q-28 34 -28 77q0 14 1 18 l60 378q11 61 58 102q50 42 109 42zM156 801l-81 -163h-124l81 163h124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0401",
    unicode: "\u0401",
    horizAdvX: 478,
    d: "M263 670l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378l-21 -130h-247zM287 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM455 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5 t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 638,
    d: "M346 560l-8 -47q136 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473l-1 -5q-10 -63 -63 -108q-52 -45 -114 -44h-91l20 130h88q25 -1 30 22l31 201l35 222q2 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560l18 110h-164l20 130h459l-20 -130h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 455,
    d: "M509 670h-246l-106 -670h-130l126 800h376zM517 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    horizAdvX: 523,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -87.5l-2 -22l-14 -85h-130l13 80v4l1 3q0 12 -12 12h-150q-14 0 -17 -19l-29 -181h256l-20 -130h-256l-34 -212q0 -2 -1 -3v-2q0 -9 13 -9h150q8 0 11 2.5t5 11.5l19 116h130l-19 -116q-9 -60 -58 -102t-109 -42h-150 q-54 0 -88.5 34.5t-34.5 87.5v3.5t0.5 5t1 6.5t0.5 7l84 528q9 60 58 102t109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0405",
    unicode: "\u0405",
    horizAdvX: 527,
    d: "M279 806h139q54 0 88.5 -39t34.5 -98q0 -3 -2 -27h-130q1 4 1 15q0 19 -12 19h-139q-12 0 -17 -14l-8 -55q-1 -3 -1 -12q0 -36 34 -65q21 -16 32 -23l43 -26q6 -5 10 -6q114 -71 114 -210q0 -31 -4 -54l-12 -77q-11 -61 -59 -102q-48 -42 -108 -42h-139q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l23 148h130l-23 -148v-2q0 -12 11 -12h139q12 0 17 14l12 77q2 14 2 29q0 45 -26 82q-7 12 -32 31q-23 19 -34 25l-41 26q-100 61 -100 167q0 18 3 36l8 55q11 61 58 102q50 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0406",
    unicode: "\u0406",
    horizAdvX: 283,
    d: "M162 0h-130l126 800h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0407",
    unicode: "\u0407",
    horizAdvX: 283,
    d: "M167 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM335 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM32 0l126 800h130l-126 -800h-130z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0408",
    unicode: "\u0408",
    horizAdvX: 510,
    d: "M536 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-146q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l25 158h130l-25 -158v-2q0 -12 11 -12h146q15 0 17 14l105 666h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 905,
    d: "M630 626l-18 -113q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l86 543l1 5h-150l-96 -465q-25 -136 -101 -185q-20 -13 -51 -21q-48 -9 -124 -9h-10l20 130h10q65 0 88 15 t34 66l121 599h409l-14 -93l-12 -74zM696 133l43 277l1 2v3q0 9 -9 9q-13 0 -140 -40l-39 -251q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 837,
    d: "M576 708l-31 -195q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l41 258l-3 -3h-175l-59 -378h-130l126 800h130l-47 -294h176l37 229l5 30l6 36h130zM629 133l43 277v2 q1 2 1 3q0 9 -9 9q-13 0 -140 -40l-39 -251q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 638,
    d: "M346 560l-8 -47q136 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q2 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560l18 110h-164l20 130h459l-20 -130h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 617,
    d: "M683 799l-20 -129q-2 0 -13 -2.5t-21.5 -5.5t-24.5 -8.5t-27.5 -15.5t-24.5 -24l-131 -168l-1 -8l143 -438h-137l-124 378h-87l-59 -378h-129l126 800h129l-47 -294h88l86 106q132 172 274 187zM565 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 569,
    d: "M634 800l-310 -800h-130l83 218h-96q-15 0 -26 10.5t-12 23.5l-43 548h133l26 -445q0 -7 5 -7h62q6 0 7 7l171 445h130zM411 990h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75v-2q-1 -2 -1 -3q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 575,
    d: "M586 800l-126 -800h-150l-25 -156h-130l25 156h-152l126 800h130l-106 -672h172l106 672h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0410",
    unicode: "\u0410",
    horizAdvX: 568,
    d: "M377 0v174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 532,
    d: "M264 671l-25 -158q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l77 485h-1l30 193h366l-20 -130h-235zM323 133l43 277v2q1 2 1 3q0 9 -9 9q-13 0 -140 -40l-39 -251 q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0412",
    unicode: "\u0412",
    horizAdvX: 560,
    d: "M153 800h311q44 0 73.5 -29t29.5 -72q0 -1 -2 -19l-23 -144q-5 -38 -30 -70t-61 -48q29 -13 45.5 -40t16.5 -61q0 -14 -1 -19l-28 -178q-8 -50 -49 -85t-90 -35h-318zM234 483h157q19 8 19 44l1 7l19 124v3l1 3q0 8 -8 8h-160zM356 137l26 161v5q1 5 1 7q0 34 -14 43 h-156l-35 -223h172q5 0 6 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 455,
    d: "M529 800l-20 -130h-246l-106 -670h-130l126 800h376z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 745,
    d: "M571 129h143l-35 -220h-130l14 91h-591l21 126h9q56 0 85.5 25.5t41.5 79.5l116 570h432zM441 129l85 542h-174l-91 -442q-15 -74 -40 -100h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0415",
    unicode: "\u0415",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 870,
    d: "M928 799l-20 -129q-2 0 -13 -2.5t-21.5 -5.5t-24.5 -8.5t-27.5 -15.5t-24.5 -24l-131 -168l-1 -8l143 -438h-137l-120 378h-33l-59 -378h-130l59 378h-37l-241 -378h-138l282 438l1 8l-78 168q-13 33 -50 44q-27 12 -43 12l20 129q68 -7 121 -50.5t94 -136.5l52 -106h37 l47 294h130l-47 -294h34l82 106q132 172 274 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0417",
    unicode: "\u0417",
    horizAdvX: 496,
    d: "M114 800h274q55 0 85 -24.5t30 -71.5q0 -2 -2 -26l-18 -116q-17 -99 -66 -118q39 -15 39 -77q0 -16 -4 -43l-33 -208q-9 -58 -49 -89t-103 -31h-146q-56 0 -88 25t-32 71q0 2 2 24l27 166h130l-22 -137v-5l-1 -3q0 -11 11 -11h131q12 0 15 19l26 169q2 18 2 19 q0 31 -36 31h-182l20 130h182q36 0 47 68l15 94v3q0 9 -9 9h-265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 620,
    d: "M631 800l-126 -800h-130l78 492l-291 -459l-5 -33h-130l126 800h130l-77 -492l290 460l5 32h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 620,
    d: "M505 0h-130l78 492l-291 -459l-5 -33h-130l126 800h130l-77 -492l290 460l5 32h130zM439 990h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75v-2q-1 -2 -1 -3q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041A",
    unicode: "\u041A",
    horizAdvX: 617,
    d: "M683 799l-20 -129q-2 0 -13 -2.5t-21.5 -5.5t-24.5 -8.5t-27.5 -15.5t-24.5 -24l-131 -168l-1 -8l143 -438h-137l-124 378h-87l-59 -378h-129l126 800h129l-47 -294h88l86 106q132 172 274 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 650,
    d: "M662 801l-127 -801h-130l107 671h-155l-96 -465q-25 -136 -101 -185q-20 -13 -51 -21q-48 -9 -124 -9h-10l20 130h10q65 0 88 15t34 66l121 599h414z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041C",
    unicode: "\u041C",
    horizAdvX: 802,
    d: "M792 800l-96 -800h-130l78 670h-8l-219 -660h-119l-8 660h-9l-134 -670h-130l157 800h245l-20 -522l144 522h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041D",
    unicode: "\u041D",
    horizAdvX: 577,
    d: "M462 0h-130l59 378h-175l-59 -378h-130l126 800h130l-47 -294h175l47 294h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041E",
    unicode: "\u041E",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 575,
    d: "M585 800l-126 -800h-130l106 672h-172l-106 -672h-130l126 800h432z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0420",
    unicode: "\u0420",
    horizAdvX: 530,
    d: "M153 800h290q54 0 89 -32t35 -83q0 -1 -2 -23l-30 -186q-7 -60 -57 -102q-48 -42 -108 -42h-160l-53 -332h-130zM263 670l-33 -208h160q13 0 15 14l30 187q0 7 -12 7h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0421",
    unicode: "\u0421",
    horizAdvX: 546,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l19 124v3l1 2q-2 11 -13 11h-148q-14 0 -17 -16l-83 -525q0 -1 -0.5 -3t-0.5 -3q0 -9 12 -9h153q11 0 14 15l25 157h130l-25 -158q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0422",
    unicode: "\u0422",
    horizAdvX: 474,
    d: "M528 670h-164l-106 -670h-130l106 670h-164l20 130h458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 569,
    d: "M504 800h130l-310 -800h-130l83 218h-8h-88q-15 0 -26 10.5t-12 23.5l-43 548h133l26 -445q0 -7 5 -7h62q6 0 7 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 652,
    d: "M458 706h53q57 0 94 -35t37 -88q0 -3 -2 -21l-52 -328q-10 -60 -60 -102t-114 -42h-53l-14 -90h-130l14 90h-53q-57 0 -94 34.5t-37 87.5l2 22l52 328q9 60 59 102q51 42 115 42h53l15 94h130zM202 220h50l56 356h-49q-15 0 -21.5 -5t-8.5 -19l-49 -308q-1 -3 -1 -9 q0 -15 23 -15zM459 244l49 308q1 3 1 9q0 15 -22 15h-49l-56 -356h48q15 0 21 5t8 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0425",
    unicode: "\u0425",
    horizAdvX: 543,
    d: "M370 437l110 -437h-132l-70 319l-172 -319h-134l248 435l-93 365h135l48 -275l136 275h135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 600,
    d: "M586 800l-106 -671h89l-36 -220h-130l15 91h-390l126 800h130l-106 -672h172l106 672h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 543,
    d: "M555 801l-128 -801h-130l53 332q-147 -57 -194 -57q-36 0 -59 23t-23 58q0 12 1 15l69 430h130l-58 -360v-4q0 -23 15 -23q38 0 140 47l54 340h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 772,
    d: "M783 800l-126 -800h-630l126 800h130l-105 -671h120l105 671h130l-105 -671h120l105 671h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 796,
    d: "M783 800l-106 -671h87l-36 -220h-130l15 91h-586l126 800h130l-105 -671h120l105 671h130l-105 -671h120l105 671h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 673,
    d: "M411 708l-31 -195q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l82 522l4 21l2 8h-206l20 127h335l-15 -93h1zM464 133l43 277l1 2v3q0 9 -9 9q-13 0 -140 -40l-39 -251 q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 766,
    d: "M270 708l-31 -195q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l93 585h-1l5 32l1 9l3 16l6 36h130l-9 -52l-6 -41h1zM646 800h130l-126 -800h-130zM323 133l43 277v2 q1 2 1 3q0 9 -9 9q-13 0 -140 -40l-39 -251q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 532,
    d: "M270 708l-31 -195q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l93 585h-1l5 32l1 9l3 16l6 36h130l-9 -52l-6 -41h1zM323 133l43 277v2q1 2 1 3q0 9 -9 9q-13 0 -140 -40 l-39 -251q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 522,
    d: "M257 806h149q54 0 88.5 -34.5t34.5 -87.5l-2 -22l-84 -528q-9 -60 -58 -102t-109 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l19 116h130l-19 -116v-3l-1 -2q0 -9 13 -9h149q8 0 11 2.5t5 11.5l34 212h-255l20 130h255l29 181v4l1 3q0 12 -12 12h-149q-14 0 -17 -19 l-13 -80h-130l14 85q9 60 58 102q50 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 838,
    d: "M571 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l38 244h-143l-59 -378h-130l126 800h130l-47 -294h143l25 156q11 61 58 102q50 42 109 42zM629 134l83 528v3q0 11 -11 11 h-150q-12 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 550,
    d: "M272 800h290l-127 -800h-130l61 382h-71l-187 -382h-133l193 387q-39 10 -62 41.5t-23 73.5q0 2 2 24l21 136q11 59 57 98q47 40 109 40zM386 512l25 158h-160h-5q-8 0 -10 -8l-21 -136l-1 -3v-3q0 -8 12 -8h160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0430",
    unicode: "\u0430",
    horizAdvX: 568,
    d: "M377 174h-221l-54 -174h-130l246 766q5 13 19.5 23.5t28.5 10.5h197q15 0 27 -10t16 -24v-766h-129v174zM381 304v355q0 11 -6 11h-61q-6 0 -9 -11l-109 -355h185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 532,
    d: "M264 671l-25 -158q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l77 485h-1l30 193h366l-20 -130h-235zM323 133l43 277v2q1 2 1 3q0 9 -9 9q-13 0 -140 -40l-39 -251 q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 560,
    d: "M153 800h311q44 0 73.5 -29t29.5 -72q0 -1 -2 -19l-23 -144q-5 -38 -30 -70t-61 -48q29 -13 45.5 -40t16.5 -61q0 -14 -1 -19l-28 -178q-8 -50 -49 -85t-90 -35h-318zM234 483h157q19 8 19 44l1 7l19 124v3l1 3q0 8 -8 8h-160zM356 137l26 161v5q1 5 1 7q0 34 -14 43 h-156l-35 -223h172q5 0 6 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 455,
    d: "M509 670h-246l-106 -670h-130l126 800h376z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 745,
    d: "M571 129h143l-35 -220h-130l14 91h-591l21 126h9q56 0 85.5 25.5t41.5 79.5l116 570h432zM441 129l85 542h-174l-91 -442q-15 -74 -40 -100h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0435",
    unicode: "\u0435",
    horizAdvX: 478,
    d: "M263 670l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378l-21 -130h-247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 870,
    d: "M928 799l-20 -129q-2 0 -13 -2.5t-21.5 -5.5t-24.5 -8.5t-27.5 -15.5t-24.5 -24l-131 -168l-1 -8l143 -438h-137l-120 378h-33l-59 -378h-130l59 378h-37l-241 -378h-138l282 438l1 8l-78 168q-13 33 -50 44q-27 12 -43 12l20 129q68 -7 121 -50.5t94 -136.5l52 -106h37 l47 294h130l-47 -294h34l82 106q132 172 274 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 496,
    d: "M114 800h274q55 0 85 -24.5t30 -71.5q0 -2 -2 -26l-18 -116q-17 -99 -66 -118q39 -15 39 -77q0 -16 -4 -43l-33 -208q-9 -58 -49 -89t-103 -31h-146q-56 0 -88 25t-32 71q0 2 2 24l27 166h130l-22 -137v-5l-1 -3q0 -11 11 -11h131q12 0 15 19l26 169q2 18 2 19 q0 31 -36 31h-182l20 130h182q36 0 47 68l15 94v3q0 9 -9 9h-265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 620,
    d: "M505 0h-130l78 492l-291 -459l-5 -33h-130l126 800h130l-77 -492l290 460l5 32h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 620,
    d: "M431 991h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75q0 -1 -0.5 -3l-0.5 -2q0 -15 19 -15q20 0 25 20zM375 0l78 492l-291 -459l-5 -33h-130l126 800h130l-77 -492l290 460l5 32h130l-126 -800h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 617,
    d: "M683 799l-20 -129q-2 0 -13 -2.5t-21.5 -5.5t-24.5 -8.5t-27.5 -15.5t-24.5 -24l-131 -168l-1 -8l143 -438h-137l-124 378h-87l-59 -378h-129l126 800h129l-47 -294h88l86 106q132 172 274 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 650,
    d: "M535 0h-130l107 671h-155l-96 -465q-25 -136 -101 -185q-20 -13 -51 -21q-48 -9 -124 -9h-10l20 130h10q65 0 88 15t34 66l121 599h414z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 802,
    d: "M696 0h-130l78 670h-8l-219 -660h-119l-8 660h-9l-134 -670h-130l157 800h245l-20 -522l144 522h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 584,
    d: "M332 0l59 378h-175l-59 -378h-130l126 800h130l-47 -294h175l47 294h130l-126 -800h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043E",
    unicode: "\u043E",
    horizAdvX: 562,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 575,
    d: "M459 0h-130l106 672h-172l-106 -672h-130l126 800h432z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0440",
    unicode: "\u0440",
    horizAdvX: 530,
    d: "M153 800h290q54 0 89 -32t35 -83q0 -1 -2 -23l-30 -186q-7 -60 -57 -102q-48 -42 -108 -42h-160l-53 -332h-130zM230 462h160q13 0 15 14l30 187q0 7 -12 7h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0441",
    unicode: "\u0441",
    horizAdvX: 557,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-20 -126h-130l19 124v3l1 2q-2 11 -13 11h-148q-14 0 -17 -16l-83 -525q0 -1 -0.5 -3t-0.5 -3q0 -9 12 -9h153q11 0 14 15l25 157h130l-25 -158q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 474,
    d: "M364 670l-106 -670h-130l106 670h-164l20 130h458l-20 -130h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0443",
    unicode: "\u0443",
    horizAdvX: 569,
    d: "M634 800l-310 -800h-130l83 218h-96q-15 0 -26 10.5t-12 23.5l-43 548h133l26 -445q0 -7 5 -7h62q6 0 7 7l171 445h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 652,
    d: "M458 706h53q57 0 94 -35t37 -88q0 -3 -2 -21l-52 -328q-10 -60 -60 -102t-114 -42h-53l-14 -90h-130l14 90h-53q-57 0 -94 34.5t-37 87.5l2 22l52 328q9 60 59 102q51 42 115 42h53l15 94h130zM252 220l56 356h-49q-15 0 -21.5 -5t-8.5 -19l-49 -308q-1 -3 -1 -9 q0 -15 23 -15h50zM459 244l49 308q1 3 1 9q0 15 -22 15h-49l-56 -356h48q15 0 21 5t8 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0445",
    unicode: "\u0445",
    horizAdvX: 560,
    d: "M480 0h-132l-70 319l-172 -319h-134l248 435l-93 365h135l48 -275l136 275h135l-211 -363z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 600,
    d: "M480 129h89l-36 -220h-130l15 91h-390l126 800h130l-106 -672h172l106 672h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 543,
    d: "M427 0h-130l53 332q-147 -57 -194 -57q-36 0 -59 23t-23 58q0 12 1 15l69 430h130l-58 -360v-4q0 -23 15 -23q38 0 140 47l54 340h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 772,
    d: "M657 0h-630l126 800h130l-105 -671h120l105 671h130l-105 -671h120l105 671h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 796,
    d: "M677 129h87l-36 -220h-130l15 91h-586l126 800h130l-105 -671h120l105 671h130l-105 -671h120l105 671h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 673,
    d: "M411 708l-31 -195q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l82 522l4 21l2 8h-206l20 127h335l-15 -93h1zM464 133l43 277l1 2v3q0 9 -9 9q-13 0 -140 -40l-39 -251 q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 766,
    d: "M270 708l-31 -195q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l93 585h-1l5 32l1 9l3 16l6 36h130l-9 -52l-6 -41h1zM776 800l-126 -800h-130l126 800h130zM323 133l43 277 v2q1 2 1 3q0 9 -9 9q-13 0 -140 -40l-39 -251q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 532,
    d: "M270 708l-31 -195q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l93 585h-1l5 32l1 9l3 16l6 36h130l-9 -52l-6 -41h1zM323 133l43 277v2q1 2 1 3q0 9 -9 9q-13 0 -140 -40 l-39 -251q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 522,
    d: "M257 806h149q54 0 88.5 -34.5t34.5 -87.5l-2 -22l-84 -528q-9 -60 -58 -102t-109 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l19 116h130l-19 -116v-3l-1 -2q0 -9 13 -9h149q8 0 11 2.5t5 11.5l34 212h-255l20 130h255l29 181l1 7q0 12 -12 12h-149q-14 0 -17 -19 l-13 -80h-130l14 85q9 60 58 102q50 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 838,
    d: "M571 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l38 244h-143l-59 -378h-130l126 800h130l-47 -294h143l25 156q11 61 58 102q50 42 109 42zM712 662v3q0 11 -11 11h-150 q-12 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 550,
    d: "M562 800l-127 -800h-130l61 382h-71l-187 -382h-133l193 387q-39 10 -62 41.5t-23 73.5q0 2 2 24l21 136q11 59 57 98q47 40 109 40h290zM411 670h-160h-5q-8 0 -10 -8l-21 -136l-1 -3v-3q0 -8 12 -8h160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0451",
    unicode: "\u0451",
    horizAdvX: 478,
    d: "M298 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM466 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM232 476h221l-20 -130h-221 l-34 -216h248l-21 -130h-378l126 800h378l-21 -130h-247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    horizAdvX: 638,
    d: "M346 560l-8 -47q136 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473l-1 -5q-10 -63 -63 -108q-52 -45 -114 -44h-91l20 130h88q25 -1 30 22l31 201l35 222q2 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560l18 110h-164l20 130h459l-20 -130h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 455,
    d: "M263 670l-106 -670h-130l126 800h376l-20 -130h-246zM529 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 523,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -87.5l-2 -22l-14 -85h-130l13 80l1 7q0 12 -12 12h-150q-14 0 -17 -19l-29 -181h256l-20 -130h-256l-34 -212q0 -2 -1 -3v-2q0 -9 13 -9h150q8 0 11 2.5t5 11.5l19 116h130l-19 -116q-9 -60 -58 -102t-109 -42h-150q-54 0 -88.5 34.5 t-34.5 87.5v3.5t0.5 5t1 6.5t0.5 7l84 528q9 60 58 102t109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0455",
    unicode: "\u0455",
    horizAdvX: 527,
    d: "M279 806h139q54 0 88.5 -39t34.5 -98q0 -3 -2 -27h-130q1 4 1 15q0 19 -12 19h-139q-12 0 -17 -14l-8 -55q-1 -3 -1 -12q0 -36 34 -65q21 -16 32 -23l43 -26q6 -5 10 -6q114 -71 114 -210q0 -31 -4 -54l-12 -77q-11 -61 -59 -102q-48 -42 -108 -42h-139q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l23 148h130l-23 -148v-2q0 -12 11 -12h139q12 0 17 14l12 77q2 14 2 29q0 45 -26 82q-7 12 -32 31q-23 19 -34 25l-41 26q-100 61 -100 167q0 18 3 36l8 55q11 61 58 102q50 42 109 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0456",
    unicode: "\u0456",
    horizAdvX: 283,
    d: "M32 0l126 800h130l-126 -800h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0457",
    unicode: "\u0457",
    horizAdvX: 283,
    d: "M165 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM333 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM158 800h130l-126 -800h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0458",
    unicode: "\u0458",
    horizAdvX: 510,
    d: "M536 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-146q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l25 158h130l-25 -158v-2q0 -12 11 -12h146q15 0 17 14l105 666h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 905,
    d: "M630 626l-18 -113q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l86 543l1 5h-150l-96 -465q-25 -136 -101 -185q-20 -13 -51 -21q-48 -9 -124 -9h-10l20 130h10q65 0 88 15 t34 66l121 599h409l-14 -93l-12 -74zM696 133l43 277l1 2v3q0 9 -9 9q-13 0 -140 -40l-39 -251q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 837,
    d: "M576 708l-31 -195q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l41 258l-3 -3h-175l-59 -378h-130l126 800h130l-47 -294h176l37 229l11 66h130zM629 133l43 277v2q1 2 1 3 q0 9 -9 9q-13 0 -140 -40l-39 -251q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045B",
    unicode: "\u045B",
    horizAdvX: 638,
    d: "M346 560l-8 -47q136 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q2 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560l18 110h-164l20 130h459l-20 -130h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 617,
    d: "M683 799l-20 -129q-2 0 -13 -2.5t-21.5 -5.5t-24.5 -8.5t-27.5 -15.5t-24.5 -24l-131 -168l-1 -8l143 -438h-137l-124 378h-87l-59 -378h-129l126 800h129l-47 -294h88l86 106q132 172 274 187zM584 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    horizAdvX: 569,
    d: "M414 990h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75l-1 -2v-3q0 -15 19 -15q20 0 25 20zM324 0h-130l83 218h-96q-15 0 -26 10.5t-12 23.5l-43 548h133l26 -445q0 -7 5 -7h62q6 0 7 7l171 445h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 575,
    d: "M460 0h-150l-25 -156h-130l25 156h-152l126 800h130l-106 -672h172l106 672h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Bdotaccent",
    unicode: "\u1E02",
    horizAdvX: 560,
    d: "M153 800h311q44 0 73.5 -29t29.5 -72q0 -1 -2 -19l-23 -144q-5 -38 -30 -70t-61 -48q29 -13 45.5 -40t16.5 -61q0 -14 -1 -19l-28 -178q-8 -50 -49 -85t-90 -35h-318zM234 483h157q19 8 19 44l1 7l19 124v3l1 3q0 8 -8 8h-160zM356 137l26 161v5q1 5 1 7q0 34 -14 43 h-156l-35 -223h172q5 0 6 7zM388 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bdotaccent",
    unicode: "\u1E03",
    horizAdvX: 512,
    d: "M255 708l-31 -195q168 57 196 57q35 0 54.5 -19.5t19.5 -54.5q0 -1 -2 -23l-57 -350q-8 -56 -53 -95q-44 -40 -100 -38h-138q-50 0 -82 31.5t-32 79.5q0 4 2 22l93 585h-1l9 57h130l-9 -57h1zM395 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16 t-16.5 41q0 31 24.5 55.5t55.5 24.5zM308 133l43 277l1 2v3q0 9 -9 9q-13 0 -140 -40l-39 -251q0 -1 -0.5 -3l-0.5 -2q0 -10 11 -10h118q13 0 16 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotaccent",
    unicode: "\u1E0A",
    horizAdvX: 565,
    d: "M374 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5zM153 800h294q54 0 89 -32t35 -83q0 -1 -2 -23l-82 -518q-9 -60 -58 -102q-48 -42 -108 -42h-294zM263 670l-85 -540h164q12 0 15 14l82 518v2q0 6 -12 6h-164z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotaccent",
    unicode: "\u1E0B",
    horizAdvX: 517,
    d: "M523 707h1l-112 -707h-130l7 47l-38 -13q-25 -9 -47 -16q-82 -28 -112 -28q-34 0 -53.5 19.5t-19.5 54.5q0 1 2 23l56 350q8 56 53 95q46 39 100 38h142l22 137l9 57h130zM250 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5 t55.5 24.5zM309 176l40 251v3q0 11 -10 12h-119q-14 0 -15 -15l-44 -277v-3q0 -11 8 -11q16 0 140 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 565,
    d: "M153 800h294q54 0 89 -32t35 -83q0 -1 -2 -23l-82 -518q-9 -60 -58 -102q-48 -42 -108 -42h-294zM263 670l-85 -540h164q12 0 15 14l82 518v2q0 6 -12 6h-164zM222 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    horizAdvX: 517,
    d: "M523 707h1l-112 -707h-130l7 47l-38 -13q-25 -9 -47 -16q-82 -28 -112 -28q-34 0 -53.5 19.5t-19.5 54.5q0 1 2 23l56 350q8 56 53 95q46 39 100 38h142l22 137l9 57h130zM309 176l40 251v3q0 11 -10 12h-119q-14 0 -15 -15l-44 -277v-3q0 -11 8 -11q16 0 140 40z M212 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Fdotaccent",
    unicode: "\u1E1E",
    horizAdvX: 460,
    d: "M369 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5zM509 655h-249l-24 -149h221l-20 -130h-221l-59 -376h-130l126 800h379z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fdotaccent",
    unicode: "\u1E1F",
    horizAdvX: 315,
    d: "M370 635h-94q-23 0 -26 -21l-9 -54h80l-20 -129h-80l-69 -435q-11 -63 -62 -107q-52 -44 -116 -44l19 130q23 0 27 21l69 435h-55l20 129h55l10 54q11 63 62 107q52 45 114 44h97zM287 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41 q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 577,
    d: "M462 0h-130l59 378h-175l-59 -378h-130l126 800h130l-47 -294h175l47 294h130zM243 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 522,
    d: "M235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h1l32 205h130zM217 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Mdotaccent",
    unicode: "\u1E40",
    horizAdvX: 802,
    d: "M792 800l-96 -800h-130l78 670h-8l-219 -660h-119l-8 660h-9l-134 -670h-130l157 800h245l-20 -522l144 522h249zM509 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mdotaccent",
    unicode: "\u1E41",
    horizAdvX: 739,
    d: "M467 507v-1q112 64 166 64q35 0 58 -23t23 -56q0 -2 -2 -18l-73 -473h-129l65 412v3q0 8 -5 8q-16 0 -118 -40l-60 -383h-129l63 407q1 1 1 5q0 8 -6 8q-8 0 -115 -43l-59 -377h-130l88 560h130l-8 -53q106 60 160 60q32 0 56 -17t24 -43zM446 756q25 0 42 -17t17 -41 q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 629,
    d: "M514 0h-223l-21 670h-7l-106 -670h-130l126 800h225l19 -670h8l105 670h130zM425 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 522,
    d: "M235 560l-8 -47q137 57 189 57q36 0 58.5 -23t22.5 -58q0 -13 -1 -16l-74 -473h-130l65 418q1 9 -4 9q-9 0 -146 -44l-60 -383h-130l88 560h130zM334 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Pdotaccent",
    unicode: "\u1E56",
    horizAdvX: 530,
    d: "M153 800h290q54 0 89 -32t35 -83q0 -1 -2 -23l-30 -186q-7 -60 -57 -102q-48 -42 -108 -42h-160l-53 -332h-130zM263 670l-33 -208h160q13 0 15 14l30 187q0 7 -12 7h-160zM375 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41 q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pdotaccent",
    unicode: "\u1E57",
    horizAdvX: 517,
    d: "M335 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5zM235 560l-7 -47l37 13q10 4 47 16q86 28 113 28q34 0 53.5 -19.5t19.5 -54.5q0 -1 -2 -23l-56 -350q-8 -56 -53 -95q-46 -39 -100 -38h-142l-22 -137h-130 l112 707h130zM312 133l44 277v3q0 11 -8 11q-16 0 -140 -40l-40 -251v-3q0 -11 10 -12h119q13 0 15 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 563,
    d: "M153 800h314q44 0 73.5 -29t29.5 -72q0 -1 -2 -19l-23 -144q-6 -38 -31 -70t-61 -48q29 -13 46 -40t17 -62q0 -14 -1 -18l-47 -298h-130l47 298q0 4 0.5 8t1 7t0.5 5v3q0 22 -16 32h-158l-56 -353h-130zM234 483h152q14 6 19 15.5t9 35.5l20 126q0 12 -11 12h-160z M225 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 486,
    d: "M235 560l-8 -47q138 56 189 56q36 0 58.5 -23t22.5 -57q0 -13 -1 -16l-15 -100h-130l6 43v5q0 7 -6 7t-144 -45l-60 -383h-130l88 560h130zM79 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotaccent",
    unicode: "\u1E60",
    horizAdvX: 527,
    d: "M279 806h139q54 0 88.5 -39t34.5 -98q0 -3 -2 -27h-130q1 4 1 15q0 19 -12 19h-139q-12 0 -17 -14l-8 -55q-1 -3 -1 -12q0 -36 34 -65q21 -16 32 -23l43 -26q6 -5 10 -6q114 -71 114 -210q0 -31 -4 -54l-12 -77q-11 -61 -59 -102q-48 -42 -108 -42h-139q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l23 148h130l-23 -148v-2q0 -12 11 -12h139q12 0 17 14l12 77q2 14 2 29q0 45 -26 82q-7 12 -32 31q-23 19 -34 25l-41 26q-100 61 -100 167q0 18 3 36l8 55q11 61 58 102q50 42 109 42zM368 997q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5 q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotaccent",
    unicode: "\u1E61",
    horizAdvX: 490,
    d: "M221 570h139q46 0 80 -33t34 -80q0 -2 -2 -20l-5 -30h-130l3 20v3l1 2q0 8 -8 8h-126q-9 0 -12 -13v-8q-5 -25 36 -47l34 -18l43 -18q122 -48 122 -150q0 -3 -2 -27l-6 -36q-10 -59 -54 -96q-43 -37 -100 -37h-139q-45 0 -80 33q-33 35 -33 82q0 14 1 18l14 89h130 l-12 -79q0 -2 -1 -3v-2q0 -8 8 -8h127q8 0 11 13l3 18l1 3v6q0 25 -27 44q-10 9 -38 19q-5 3 -23 10t-20 8q-128 53 -128 146q0 1 2 25l3 25q10 59 53.5 96t100.5 37zM315 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5 t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 527,
    d: "M279 806h139q54 0 88.5 -39t34.5 -98q0 -3 -2 -27h-130q1 4 1 15q0 19 -12 19h-139q-12 0 -17 -14l-8 -55q-1 -3 -1 -12q0 -36 34 -65q21 -16 32 -23l43 -26q6 -5 10 -6q114 -71 114 -210q0 -31 -4 -54l-12 -77q-11 -61 -59 -102q-48 -42 -108 -42h-139q-54 0 -88.5 34.5 t-34.5 86.5q0 1 2 23l23 148h130l-23 -148v-2q0 -12 11 -12h139q12 0 17 14l12 77q2 14 2 29q0 45 -26 82q-7 12 -32 31q-23 19 -34 25l-41 26q-100 61 -100 167q0 18 3 36l8 55q11 61 58 102q50 42 109 42zM211 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5 q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 490,
    d: "M221 570h139q46 0 80 -33t34 -80q0 -2 -2 -20l-5 -30h-130l3 20v3l1 2q0 8 -8 8h-126q-9 0 -12 -13v-8q-5 -25 36 -47l34 -18l43 -18q122 -48 122 -150q0 -3 -2 -27l-6 -36q-10 -59 -54 -96q-43 -37 -100 -37h-139q-45 0 -80 33q-33 35 -33 82q0 14 1 18l14 89h130 l-12 -79q0 -2 -1 -3v-2q0 -8 8 -8h127q8 0 11 13l3 18l1 3v6q0 25 -27 44q-10 9 -38 19q-5 3 -23 10t-20 8q-128 53 -128 146q0 1 2 25l3 25q10 59 53.5 96t100.5 37zM193 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5 t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotaccent",
    unicode: "\u1E6A",
    horizAdvX: 474,
    d: "M528 670h-164l-106 -670h-130l106 670h-164l20 130h458zM350 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotaccent",
    unicode: "\u1E6B",
    horizAdvX: 359,
    d: "M256 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5zM191 142v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44t-27 108l46 290h-73l20 128h74l23 144h132l-23 -144h138l-21 -128h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 474,
    d: "M528 670h-164l-106 -670h-130l106 670h-164l20 130h458zM185 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 359,
    d: "M191 142v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44t-27 108l46 290h-73l20 128h74l23 144h132l-23 -144h138l-21 -128h-138zM131 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 850,
    d: "M487 1005l80 -131h-125l-81 131h126zM870 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-80q-49 0 -82 28t-40 74q-21 -45 -64 -73.5t-92 -28.5h-80q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h80q33 0 59 32q25 32 30 57l93 591 h130l-93 -591q-4 -25 11 -58q16 -31 48 -31h80q15 0 17 14l105 666h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 765,
    d: "M410 765l80 -131h-125l-81 131h126zM753 560l-66 -420q-10 -66 -53.5 -108t-103.5 -42h-66q-45 0 -75.5 25.5t-37.5 70.5q-20 -45 -59 -70.5t-84 -25.5h-65q-52 0 -81.5 32.5t-29.5 86.5q0 17 2 31l66 420h130l-66 -420v-5q0 -15 15 -15h49q64 0 79 95l54 345h130 l-54 -345q-3 -19 -3 -34q0 -61 50 -61h50q20 0 23 20l66 420h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 850,
    d: "M697 1005l-122 -131h-126l123 131h125zM870 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-80q-49 0 -82 28t-40 74q-21 -45 -64 -73.5t-92 -28.5h-80q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h80q33 0 59 32q25 32 30 57 l93 591h130l-93 -591q-4 -25 11 -58q16 -31 48 -31h80q15 0 17 14l105 666h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 765,
    d: "M620 765l-122 -131h-126l123 131h125zM753 560l-66 -420q-10 -66 -53.5 -108t-103.5 -42h-66q-45 0 -75.5 25.5t-37.5 70.5q-20 -45 -59 -70.5t-84 -25.5h-65q-52 0 -81.5 32.5t-29.5 86.5q0 17 2 31l66 420h130l-66 -420v-5q0 -15 15 -15h49q64 0 79 95l54 345h130 l-54 -345q-3 -19 -3 -34q0 -61 50 -61h50q20 0 23 20l66 420h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 850,
    d: "M447 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM615 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM870 800l-105 -666 q-11 -61 -59 -102q-48 -42 -108 -42h-80q-49 0 -82 28t-40 74q-21 -45 -64 -73.5t-92 -28.5h-80q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h80q33 0 59 32q25 32 30 57l93 591h130l-93 -591q-4 -25 11 -58q16 -31 48 -31h80q15 0 17 14 l105 666h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 765,
    d: "M369 757q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM537 757q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM753 560l-66 -420 q-10 -66 -53.5 -108t-103.5 -42h-66q-45 0 -75.5 25.5t-37.5 70.5q-20 -45 -59 -70.5t-84 -25.5h-65q-52 0 -81.5 32.5t-29.5 86.5q0 17 2 31l66 420h130l-66 -420v-5q0 -15 15 -15h49q64 0 79 95l54 345h130l-54 -345q-3 -19 -3 -34q0 -61 50 -61h50q20 0 23 20l66 420h130 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 503,
    d: "M194 130h257l-21 -130h-446l364 670h-258l20 130h446zM201 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 462,
    d: "M452 434l-301 -305h256l-21 -129h-400l21 130l299 304h-249l19 126h395zM190 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378zM184 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 492,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-139q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM344 440h-129 q-9 0 -10 -9l-18 -116l134 55q23 11 24 31l5 30q0 9 -6 9zM195 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    horizAdvX: 485,
    d: "M510 670h-247l-31 -194h221l-20 -130h-221l-34 -216h248l-21 -130h-378l126 800h378zM219 864l13 111q31 31 67 31q25 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-40 18 -64 18q-32 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 492,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-16 -99q-4 -26 -54 -52l-246 -110l-7 -41v-4q0 -11 6 -11h127q7 0 12 15l9 60h130l-11 -72q-9 -56 -54 -95q-46 -38 -100 -38h-139q-50 0 -82 31.5t-32 79.5q0 4 2 22l50 314q7 54 53 94q45 39 101 39zM344 440h-129 q-9 0 -10 -9l-18 -116l134 55q23 11 24 31l5 30q0 9 -6 9zM173 624l13 111q31 31 67 31q25 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-40 18 -64 18q-32 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 283,
    d: "M162 0h-130l126 800h130zM93 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 298,
    d: "M257 659h-130l17 106h130zM241 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44t-27 108l66 418h132zM99 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 551,
    d: "M284 806h150q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-83 -528q-11 -61 -59 -102q-48 -42 -108 -42h-150q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l83 528q11 61 58 102q49 42 109 42zM414 676h-150q-14 0 -17 -14l-83 -528v-2q0 -12 11 -12h150q15 0 17 14l83 528v3 q0 11 -11 11zM225 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 507,
    d: "M230 570h139q50 0 82 -32t32 -81q0 -2 -2 -20l-50 -314q-9 -55 -54 -94t-100 -39h-139q-50 0 -82 32t-32 80q0 3 2 21l50 314q7 54 53 94q45 39 101 39zM345 440h-131q-6 0 -9 -8l-47 -298q-1 -1 -1 -6q0 -8 5 -8h130q8 0 11 14l47 298q2 8 -5 8zM202 -115q25 0 42 -17 t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 561,
    d: "M581 800l-105 -666q-11 -61 -59 -102q-48 -42 -108 -42h-149q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l105 666h130l-105 -666v-2q0 -12 11 -12h149q15 0 17 14l105 666h130zM223 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41 q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 522,
    d: "M287 0l8 47q-137 -57 -189 -57q-36 0 -58.5 23t-22.5 58q0 13 1 16l74 473h130l-65 -418q-1 -9 4 -9q9 0 146 44l60 383h130l-88 -560h-130zM221 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 569,
    d: "M634 800l-209 -546q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130zM338 1005l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 527,
    d: "M511 560l-92 -582q-9 -57 -54 -94q-43 -39 -100 -39h-261l20 130h254q9 0 11 11l12 70q-135 -59 -187 -59q-36 0 -59 23.5t-23 58.5q0 12 1 15l74 466h130l-65 -406q-1 -2 -1 -8q0 -7 7 -7q16 0 144 45l59 376h130zM304 765l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 569,
    d: "M634 800l-209 -546q-6 -11 -22.5 -21.5t-26.5 -10.5h-34l-34 -222h-129l35 222h-31q-15 0 -27 9t-12 23l-44 546h133l30 -443q0 -6 6 -6h61q6 0 7 6l167 443h130zM232 864l13 111q31 31 67 31q26 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32 q-24 0 -67 17q-40 18 -64 18q-33 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 527,
    d: "M511 560l-92 -582q-9 -57 -54 -94q-43 -39 -100 -39h-261l20 130h254q9 0 11 11l12 70q-135 -59 -187 -59q-36 0 -59 23.5t-23 58.5q0 12 1 15l74 466h130l-65 -406q-1 -2 -1 -8q0 -7 7 -7q16 0 144 45l59 376h130zM198 624l13 111q31 31 67 31q26 0 66 -18 q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-41 18 -64 18q-33 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 419,
    d: "M433 416l-20 -129h-404l20 129h404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 697,
    d: "M711 416l-20 -129h-682l20 129h682z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2015",
    unicode: "\u2015",
    horizAdvX: 1015,
    d: "M1029 416l-20 -129h-1000l20 129h1000z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 246,
    d: "M170 799l103 -22l-40 -72q-9 -18 -9 -26q0 -17 21 -30l-72 -62q-61 27 -61 78q0 29 19 63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 247,
    d: "M105 615l40 72q9 18 9 26q0 17 -21 30l72 62q61 -27 61 -78q0 -29 -19 -63l-39 -71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 247,
    d: "M-14 -136l40 72q9 18 9 26q0 16 -21 30l72 62q61 -27 61 -78q0 -29 -19 -63l-39 -71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 391,
    d: "M170 799l103 -22l-40 -72q-9 -18 -9 -26q0 -17 21 -30l-72 -62q-61 27 -61 78q0 29 19 63zM315 799l103 -22l-40 -72q-9 -18 -9 -26q0 -17 21 -30l-72 -62q-61 27 -61 78q0 29 19 63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 390,
    d: "M208 593l-103 22l40 72q9 18 9 26q0 17 -21 30l72 62q61 -27 61 -78q0 -29 -19 -63zM351 593l-103 22l40 72q9 18 9 26q0 17 -21 30l72 62q61 -27 61 -78q0 -29 -19 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 390,
    d: "M88 -162l-103 22l40 72q9 18 9 26q0 16 -21 30l72 62q61 -27 61 -78q0 -29 -19 -63zM232 -162l-103 22l40 72q9 18 9 26q0 16 -21 30l72 62q61 -27 61 -78q0 -29 -19 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 464,
    d: "M377 795l-20 -129h111l-21 -129h-111l-84 -532h-128l84 532h-110l20 129h110l21 129h128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 464,
    d: "M377 795l-20 -129h111l-21 -128h-111l-42 -272h111l-20 -128h-111l-22 -133h-130l22 133h-109l20 128h109l42 272h-109l21 128h109l20 129h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 288,
    d: "M164 406q31 0 52.5 -21t21.5 -52q0 -40 -31 -71q-31 -30 -70 -30q-32 0 -53.5 21.5t-21.5 51.5q0 40 31 70q31 31 71 31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 611,
    d: "M102 138q25 0 42.5 -17t17.5 -41q0 -31 -24.5 -55.5t-56.5 -24.5q-25 0 -42 17t-17 42v3q1 4 1 6q5 29 28 49.5t51 20.5zM282 138q25 0 42.5 -17t17.5 -41q0 -31 -24.5 -55.5t-56.5 -24.5q-25 0 -42 17t-17 42v3q1 4 1 6q5 29 28 49.5t51 20.5zM462 138q25 0 42.5 -17 t17.5 -41q0 -31 -24.5 -55.5t-56.5 -24.5q-25 0 -42 17t-17 42v3q1 4 1 6q5 29 28 49.5t51 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1297,
    d: "M301 0h-90l435 798h90zM249 778h127q42 0 68 -30.5t26 -78.5q0 -2 -2 -24l-24 -149q-7 -55 -48 -94q-39 -39 -86 -39h-127q-42 0 -68 30.5t-26 78.5q0 2 2 24l24 149q7 54 47 94q40 39 87 39zM337 662h-86q-10 0 -13 -17l-24 -149v-5q0 -11 8 -11h86q11 0 14 16l24 149v4 q0 13 -9 13zM625 407h126q42 0 68 -30.5t26 -77.5q0 -1 -2 -25l-24 -149q-7 -54 -48 -95q-39 -39 -86 -39h-126q-41 0 -67.5 31.5t-26.5 78.5q0 2 2 24l24 149q9 57 48 94q39 39 86 39zM1021 407h127q42 0 68 -30.5t26 -77.5q0 -1 -2 -25l-24 -149q-7 -54 -48 -95 q-39 -39 -86 -39h-127q-41 0 -67.5 31.5t-26.5 78.5q0 2 2 24l24 149q9 57 48 94q39 39 86 39zM712 290h-86q-12 0 -13 -16l-24 -149q0 -1 -0.5 -3t-0.5 -3q0 -11 9 -11h87q9 0 12 17l24 149v5q0 11 -8 11zM1109 290h-86q-11 0 -14 -16l-24 -149v-4q0 -13 9 -13h86 q10 0 13 17l24 149v5q0 11 -8 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 408,
    d: "M264 392l98 -48l-165 -105l131 -105l-113 -47l-186 152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 408,
    d: "M182 392l184 -153l-233 -152l-100 47l165 105l-131 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 443,
    d: "M517 798l-434 -798h-121l435 798h120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    d: "M298 776h139q54 0 89 -35t35 -87q0 -4 -2 -22l-20 -126h-130l20 126q0 2 1 3v2q0 9 -13 9h-139q-8 0 -11 -2.5t-5 -11.5l-20 -116h107l-16 -100h-293l16 100h56l20 116q9 60 57 102q49 42 109 42zM347 134l25 158h133l-25 -158q-11 -61 -59 -102q-48 -42 -108 -42h-139 q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l24 146h-54l16 100h293l-16 -100h-109l-24 -146v-5q0 -9 11 -9h139q22 0 22 2l-5 4q-4 4 -3 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2116",
    unicode: "\u2116",
    horizAdvX: 982,
    d: "M640 800l-126 -800h-223l-21 670h-7l-106 -670h-130l126 800h225l18 -670h9l105 670h130zM759 582h130q30 0 49 -19t19 -48q0 -10 -1 -13l-30 -188q-5 -33 -32.5 -56.5t-60.5 -23.5h-130q-30 0 -49 19t-19 48q0 10 1 13l30 188q5 34 32 57t61 23zM844 492h-70 q-10 0 -11 -10l-24 -148v-2q0 -8 9 -8h70q10 0 11 10l24 148v2q0 8 -9 8zM920 207l-16 -99h-311l16 99h311z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 765,
    d: "M384 800l-10 -62h-91l-54 -344h-63l54 344h-91l10 62h245zM768 800l-41 -406h-64l33 332h-5l-126 -327h-52l-23 327h-5l-71 -332h-64l89 406h105l16 -271l98 271h110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    d: "M489 416l-20 -129h-410l20 129h410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 547,
    d: "M401 560h130l-88 -560h-130l8 47q-97 -40 -153 -52q-11 -64 -63 -107q-53 -45 -115 -45h-72l20 130h71q26 0 29 22l13 87l1 5l6 39l9 58l59 376h130l-65 -418q-1 -9 4 -9q9 0 146 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    d: "M453 376h-117l-22 -50h132l-21 -131h-168l-26 -61h-115l26 61h-67l21 131h103l22 50h-118l20 130h154l21 49h115l-21 -49h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    d: "M501 622l-26 -138l-145 -68l121 -63l-19 -137l-331 200zM428 206l-22 -129h-350l22 129h350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    d: "M133 622l335 -206l-395 -200l25 137l141 63l-125 68zM425 206l-22 -129h-350l22 129h350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apple",
    unicode: "\uF8FF",
    horizAdvX: 653,
    d: "M448 738l-90 -85q-28 2 -56 0l-90 85h59l58 -61l59 61h60zM330 620q130 0 223 -93t93 -223t-93 -223t-223 -93q-131 0 -223 92q-92 94 -92 224q0 131 92 223q91 93 223 93zM521 495q-80 80 -191 80q-112 0 -192 -80q-79 -79 -79 -191q0 -113 79 -192t192 -79 q112 0 191 79t79 192q0 112 -79 191zM188 135l9 47q67 -41 128 -41q40 0 65 16.5t25 42.5q0 23 -22.5 42.5t-54.5 35t-64 32.5t-54.5 42.5t-22.5 56.5q0 54 39 78q40 25 92 25q39 0 71 -17q37 -16 50 -26l-11 -43q-48 42 -107 42q-36 0 -58 -15.5t-22 -39.5q0 -39 78 -73 q32 -13 50.5 -22t43.5 -25.5t37 -38.5t12 -50q0 -52 -43 -80t-112 -28q-49 0 -129 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "CR",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.ss01",
    horizAdvX: 332,
    d: "M363 801l-21 -129h-49l-85 -543h49l-20 -129h-229l20 129h50l85 543h-50l21 129h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute.ss01",
    horizAdvX: 332,
    d: "M448 1005l-122 -131h-126l123 131h125zM342 672h-49l-85 -543h49l-20 -129h-229l20 129h50l85 543h-50l21 129h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve.ss01",
    horizAdvX: 332,
    d: "M304 990h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75l-1 -2v-3q0 -15 19 -15q20 0 25 20zM342 672h-49l-85 -543h49l-20 -129h-229l20 129h50l85 543h-50l21 129h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex.ss01",
    horizAdvX: 332,
    d: "M314 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69zM342 672h-49l-85 -543h49l-20 -129h-229l20 129h50l85 543h-50l21 129h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis.ss01",
    horizAdvX: 332,
    d: "M198 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM366 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM342 672h-49l-85 -543h49 l-20 -129h-229l20 129h50l85 543h-50l21 129h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent.ss01",
    horizAdvX: 332,
    d: "M287 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5zM342 672h-49l-85 -543h49l-20 -129h-229l20 129h50l85 543h-50l21 129h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow.ss01",
    horizAdvX: 332,
    d: "M342 672h-49l-85 -543h49l-20 -129h-229l20 129h50l85 543h-50l21 129h229zM112 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave.ss01",
    horizAdvX: 332,
    d: "M238 1005l80 -131h-125l-81 131h126zM342 672h-49l-85 -543h49l-20 -129h-229l20 129h50l85 543h-50l21 129h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron.ss01",
    horizAdvX: 332,
    d: "M395 976l-15 -99h-220l15 99h220zM342 672h-49l-85 -543h49l-20 -129h-229l20 129h50l85 543h-50l21 129h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek.ss01",
    horizAdvX: 332,
    d: "M342 672h-49l-85 -543h49l-20 -129q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22l38 -64q-65 -48 -129 -48q-40 0 -65.5 25.5t-25.5 66.5q0 31 17 62h-92l20 129h50l85 543h-50l21 129h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde.ss01",
    horizAdvX: 332,
    d: "M133 864l13 111q31 31 67 31q25 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-41 18 -64 18q-32 0 -61 -27zM342 672h-49l-85 -543h49l-20 -129h-229l20 129h50l85 543h-50l21 129h229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.ss01",
    horizAdvX: 850,
    d: "M18 0l105 666q11 61 58 102q50 42 109 42h80q49 0 82 -28t40 -74q21 45 64 73.5t92 28.5h80q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-105 -666h-130l105 666v2q0 12 -11 12h-80q-33 0 -59 -32q-25 -32 -30 -57l-93 -591h-130l93 591q5 25 -12 57q-15 32 -47 32h-80 q-15 0 -17 -14l-105 -666h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Mdotaccent.ss01",
    horizAdvX: 850,
    d: "M18 0l105 666q11 61 58 102q50 42 109 42h80q49 0 82 -28t40 -74q21 45 64 73.5t92 28.5h80q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-105 -666h-130l105 666v2q0 12 -11 12h-80q-33 0 -59 -32q-25 -32 -30 -57l-93 -591h-130l93 591q5 25 -12 57q-15 32 -47 32h-80 q-15 0 -17 -14l-105 -666h-130zM542 996q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.ss01",
    horizAdvX: 550,
    d: "M153 800h290q54 0 89 -32t35 -83q0 -1 -2 -23l-22 -136q-6 -48 -41.5 -87t-83.5 -51l69 -388h-133l-68 382h-68l-61 -382h-130zM413 526l21 130v2l1 2q0 10 -12 10h-160l-25 -158h160q12 0 15 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute.ss01",
    horizAdvX: 550,
    d: "M153 800h290q54 0 89 -32t35 -83q0 -1 -2 -23l-22 -136q-6 -48 -41.5 -87t-83.5 -51l69 -388h-133l-68 382h-68l-61 -382h-130zM413 526l21 130v2l1 2q0 10 -12 10h-160l-25 -158h160q12 0 15 14zM552 1005l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron.ss01",
    horizAdvX: 550,
    d: "M153 800h290q54 0 89 -32t35 -83q0 -1 -2 -23l-22 -136q-6 -48 -41.5 -87t-83.5 -51l69 -388h-133l-68 382h-68l-61 -382h-130zM413 526l21 130v2l1 2q0 10 -12 10h-160l-25 -158h160q12 0 15 14zM554 1014l-158 -158h-69l-110 158h115l43 -58h3l61 58h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent.ss01",
    horizAdvX: 550,
    d: "M153 800h290q54 0 89 -32t35 -83q0 -1 -2 -23l-22 -136q-6 -48 -41.5 -87t-83.5 -51l69 -388h-133l-68 382h-68l-61 -382h-130zM413 526l21 130v2l1 2q0 10 -12 10h-160l-25 -158h160q12 0 15 14zM293 -41l-25 -169h-115l25 169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow.ss01",
    horizAdvX: 550,
    d: "M153 800h290q54 0 89 -32t35 -83q0 -1 -2 -23l-22 -136q-6 -48 -41.5 -87t-83.5 -51l69 -388h-133l-68 382h-68l-61 -382h-130zM413 526l21 130v2l1 2q0 10 -12 10h-160l-25 -158h160q12 0 15 14zM233 -115q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16 t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.ss01",
    horizAdvX: 755,
    d: "M688 800h133l-264 -784q-4 -16 -20 -16h-105q-15 0 -17 17l16 771h111l-21 -556zM222 794h156l-139 -752q-1 -18 -16 -18h-70q-9 0 -7 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute.ss01",
    horizAdvX: 755,
    d: "M660 1005l-122 -131h-126l123 131h125zM821 800l-264 -784q-4 -16 -20 -16h-105q-15 0 -17 17l16 771h111l-21 -556l167 568h133zM378 794l-139 -752q-1 -18 -16 -18h-70q-9 0 -7 18l76 752h156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex.ss01",
    horizAdvX: 755,
    d: "M526 1035l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69zM821 800l-264 -784q-4 -16 -20 -16h-105q-15 0 -17 17l16 771h111l-21 -556l167 568h133zM378 794l-139 -752q-1 -18 -16 -18h-70q-9 0 -7 18l76 752h156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis.ss01",
    horizAdvX: 755,
    d: "M410 997q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM578 997q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM821 800l-264 -784 q-4 -16 -20 -16h-105q-15 0 -17 17l16 771h111l-21 -556l167 568h133zM378 794l-139 -752q-1 -18 -16 -18h-70q-9 0 -7 18l76 752h156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave.ss01",
    horizAdvX: 755,
    d: "M450 1005l80 -131h-125l-81 131h126zM821 800l-264 -784q-4 -16 -20 -16h-105q-15 0 -17 17l16 771h111l-21 -556l167 568h133zM378 794l-139 -752q-1 -18 -16 -18h-70q-9 0 -7 18l76 752h156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i.loclTRK",
    horizAdvX: 298,
    d: "M252 560l-66 -418v-6q0 -16 20 -16h54l-20 -130h-57q-64 -1 -102 44q-37 45 -27 108l66 418h132zM217 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.ss01",
    horizAdvX: 498,
    d: "M258 569h80q56 0 93.5 -30t37.5 -80v-3.5t-0.5 -5t-1 -6.5t-0.5 -7l-69 -437h-130l7 47q-134 -57 -187 -57q-36 0 -59 23t-23 58q0 12 1 15l17 103q12 82 51 113q28 24 71 36l180 27l8 51v5q0 18 -21 18h-73q-24 0 -29 -23l-2 -18h-130l6 38q9 64 60 98q53 35 113 35z M309 259l-128 -21q-23 -12 -30 -64l-5 -28v-4l-1 -3q0 -10 10 -10l140 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute.ss01",
    horizAdvX: 498,
    d: "M258 569h80q56 0 93.5 -30t37.5 -80v-3.5t-0.5 -5t-1 -6.5t-0.5 -7l-69 -437h-130l7 47q-134 -57 -187 -57q-36 0 -59 23t-23 58q0 12 1 15l17 103q12 82 51 113q28 24 71 36l180 27l8 51v5q0 18 -21 18h-73q-24 0 -29 -23l-2 -18h-130l6 38q9 64 60 98q53 35 113 35z M309 259l-128 -21q-23 -12 -30 -64l-5 -28v-4l-1 -3q0 -10 10 -10l140 41zM493 765l-122 -131h-126l123 131h125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve.ss01",
    horizAdvX: 498,
    d: "M258 569h80q56 0 93.5 -30t37.5 -80v-3.5t-0.5 -5t-1 -6.5t-0.5 -7l-69 -437h-130l7 47q-134 -57 -187 -57q-36 0 -59 23t-23 58q0 12 1 15l17 103q12 82 51 113q28 24 71 36l180 27l8 51v5q0 18 -21 18h-73q-24 0 -29 -23l-2 -18h-130l6 38q9 64 60 98q53 35 113 35z M309 259l-128 -21q-23 -12 -30 -64l-5 -28v-4l-1 -3q0 -10 10 -10l140 41zM348 750h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75l-1 -2v-3q0 -15 19 -15q20 0 25 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex.ss01",
    horizAdvX: 498,
    d: "M258 569h80q56 0 93.5 -30t37.5 -80v-3.5t-0.5 -5t-1 -6.5t-0.5 -7l-69 -437h-130l7 47q-134 -57 -187 -57q-36 0 -59 23t-23 58q0 12 1 15l17 103q12 82 51 113q28 24 71 36l180 27l8 51v5q0 18 -21 18h-73q-24 0 -29 -23l-2 -18h-130l6 38q9 64 60 98q53 35 113 35z M309 259l-128 -21q-23 -12 -30 -64l-5 -28v-4l-1 -3q0 -10 10 -10l140 41zM359 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis.ss01",
    horizAdvX: 498,
    d: "M242 757q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM410 757q22 0 37.5 -16.5t15.5 -39.5q0 -29 -22.5 -51.5t-51.5 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM258 569h80q56 0 93.5 -30 t37.5 -80v-3.5t-0.5 -5t-1 -6.5t-0.5 -7l-69 -437h-130l7 47q-134 -57 -187 -57q-36 0 -59 23t-23 58q0 12 1 15l17 103q12 82 51 113q28 24 71 36l180 27l8 51v5q0 18 -21 18h-73q-24 0 -29 -23l-2 -18h-130l6 38q9 64 60 98q53 35 113 35zM309 259l-128 -21 q-23 -12 -30 -64l-5 -28v-4l-1 -3q0 -10 10 -10l140 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave.ss01",
    horizAdvX: 498,
    d: "M258 569h80q56 0 93.5 -30t37.5 -80v-3.5t-0.5 -5t-1 -6.5t-0.5 -7l-69 -437h-130l7 47q-134 -57 -187 -57q-36 0 -59 23t-23 58q0 12 1 15l17 103q12 82 51 113q28 24 71 36l180 27l8 51v5q0 18 -21 18h-73q-24 0 -29 -23l-2 -18h-130l6 38q9 64 60 98q53 35 113 35z M309 259l-128 -21q-23 -12 -30 -64l-5 -28v-4l-1 -3q0 -10 10 -10l140 41zM283 765l80 -131h-125l-81 131h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron.ss01",
    horizAdvX: 498,
    d: "M258 569h80q56 0 93.5 -30t37.5 -80v-3.5t-0.5 -5t-1 -6.5t-0.5 -7l-69 -437h-130l7 47q-134 -57 -187 -57q-36 0 -59 23t-23 58q0 12 1 15l17 103q12 82 51 113q28 24 71 36l180 27l8 51v5q0 18 -21 18h-73q-24 0 -29 -23l-2 -18h-130l6 38q9 64 60 98q53 35 113 35z M309 259l-128 -21q-23 -12 -30 -64l-5 -28v-4l-1 -3q0 -10 10 -10l140 41zM440 736l-15 -99h-220l15 99h220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek.ss01",
    horizAdvX: 498,
    d: "M258 569h80q56 0 93.5 -30t37.5 -80v-3.5t-0.5 -5t-1 -6.5t-0.5 -7l-69 -435l1 -2q-24 0 -38 -11t-14 -30q0 -23 24 -23q18 0 56 22l38 -64q-65 -48 -129 -48q-40 0 -65.5 25.5t-25.5 66.5t25 75l5 34q-134 -57 -187 -57q-36 0 -59 23t-23 58q0 12 1 15l17 103 q12 82 51 113q28 24 71 36l180 27l8 51v5q0 18 -21 18h-73q-24 0 -29 -23l-2 -18h-130l6 38q9 64 60 98q53 35 113 35zM151 174l-5 -28v-4l-1 -3q0 -10 10 -10l140 41l14 89l-128 -21q-23 -12 -30 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring.ss01",
    horizAdvX: 498,
    d: "M258 569h80q56 0 93.5 -30t37.5 -80v-3.5t-0.5 -5t-1 -6.5t-0.5 -7l-69 -437h-130l7 47q-134 -57 -187 -57q-36 0 -59 23t-23 58q0 12 1 15l17 103q12 82 51 113q28 24 71 36l180 27l8 51v5q0 18 -21 18h-73q-24 0 -29 -23l-2 -18h-130l6 38q9 64 60 98q53 35 113 35z M309 259l-128 -21q-23 -12 -30 -64l-5 -28v-4l-1 -3q0 -10 10 -10l140 41zM344 835q47 0 76.5 -31.5t29.5 -77.5t-40 -93q-39 -47 -105 -47q-48 0 -78 31.5t-30 79.5q0 45 38 92q39 46 109 46zM331 756q-20 0 -37 -16.5t-17 -35.5q0 -16 11.5 -28t28.5 -12q20 0 37 16.5 t17 35.5q0 16 -11.5 28t-28.5 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute.ss01",
    horizAdvX: 498,
    d: "M536 985l-122 -131h-126l123 131h125zM344 835q47 0 76.5 -31.5t29.5 -77.5t-40 -93q-39 -47 -105 -47q-48 0 -78 31.5t-30 79.5q0 45 38 92q39 46 109 46zM331 756q-20 0 -37 -16.5t-17 -35.5q0 -16 11.5 -28t28.5 -12q20 0 37 16.5t17 35.5q0 16 -11.5 28t-28.5 12z M258 569h80q56 0 93.5 -30t37.5 -80v-3.5t-0.5 -5t-1 -6.5t-0.5 -7l-69 -437h-130l7 47q-134 -57 -187 -57q-36 0 -59 23t-23 58q0 12 1 15l17 103q12 82 51 113q28 24 71 36l180 27l8 51v5q0 18 -21 18h-73q-24 0 -29 -23l-2 -18h-130l6 38q9 64 60 98q53 35 113 35z M309 259l-128 -21q-23 -12 -30 -64l-5 -28v-4l-1 -3q0 -10 10 -10l140 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde.ss01",
    horizAdvX: 498,
    d: "M258 569h80q56 0 93.5 -30t37.5 -80v-3.5t-0.5 -5t-1 -6.5t-0.5 -7l-69 -437h-130l7 47q-134 -57 -187 -57q-36 0 -59 23t-23 58q0 12 1 15l17 103q12 82 51 113q28 24 71 36l180 27l8 51v5q0 18 -21 18h-73q-24 0 -29 -23l-2 -18h-130l6 38q9 64 60 98q53 35 113 35z M309 259l-128 -21q-23 -12 -30 -64l-5 -28v-4l-1 -3q0 -10 10 -10l140 41zM177 624l13 111q31 31 67 31q25 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-41 18 -64 18q-32 0 -61 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g.ss01",
    horizAdvX: 521,
    d: "M532 570l-11 -68h-46q17 -15 17 -49q0 -12 -1 -16l-25 -154q-9 -56 -54 -95q-46 -38 -100 -38h-62q-28 0 -29 -16v-3q0 -12 24 -12h62q55 0 86 -23.5t31 -66.5q0 -2 -2 -20l-8 -57q-9 -51 -49.5 -80.5t-101.5 -29.5h-139q-55 0 -86 23.5t-31 66.5q0 2 2 20l9 57 q12 67 77 96q-7 7 -7 23q0 24 23 39q-52 31 -52 96q0 2 2 20l25 154q7 54 53 94q45 39 101 39h292zM338 293l21 134v3q0 10 -8 10h-125q-11 0 -12 -13l-21 -134q0 -2 -1 -3v-1q0 -9 9 -9h125q9 0 12 13zM278 18h-113q-15 0 -19 -19l-6 -37v-5q0 -14 13 -14h113q16 0 19 19 l5 37q1 2 1 8q0 11 -13 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve.ss01",
    horizAdvX: 521,
    d: "M371 750h74q-6 -40 -38.5 -68t-72.5 -28q-36 0 -59 23t-23 58q0 12 1 15h75v-2q-1 -2 -1 -3q0 -15 19 -15q20 0 25 20zM521 502h-46q17 -15 17 -49q0 -12 -1 -16l-25 -154q-9 -56 -54 -95q-46 -38 -100 -38h-62q-28 0 -29 -16v-3q0 -12 24 -12h62q55 0 86 -23.5t31 -66.5 q0 -2 -2 -20l-8 -57q-9 -51 -49.5 -80.5t-101.5 -29.5h-139q-55 0 -86 23.5t-31 66.5q0 2 2 20l9 57q12 67 77 96q-7 7 -7 23q0 24 23 39q-52 31 -52 96q0 2 2 20l25 154q7 54 53 94q45 39 101 39h292zM338 293l21 134v3q0 10 -8 10h-125q-11 0 -12 -13l-21 -134q0 -2 -1 -3 v-1q0 -9 9 -9h125q9 0 12 13zM278 18h-113q-15 0 -19 -19l-6 -37v-5q0 -14 13 -14h113q16 0 19 19l5 37q1 2 1 8q0 11 -13 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex.ss01",
    horizAdvX: 521,
    d: "M382 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69zM521 502h-46q17 -15 17 -49q0 -12 -1 -16l-25 -154q-9 -56 -54 -95q-46 -38 -100 -38h-62q-28 0 -29 -16v-3q0 -12 24 -12h62q55 0 86 -23.5t31 -66.5q0 -2 -2 -20l-8 -57q-9 -51 -49.5 -80.5t-101.5 -29.5 h-139q-55 0 -86 23.5t-31 66.5q0 2 2 20l9 57q12 67 77 96q-7 7 -7 23q0 24 23 39q-52 31 -52 96q0 2 2 20l25 154q7 54 53 94q45 39 101 39h292zM338 293l21 134v3q0 10 -8 10h-125q-11 0 -12 -13l-21 -134q0 -2 -1 -3v-1q0 -9 9 -9h125q9 0 12 13zM278 18h-113 q-15 0 -19 -19l-6 -37v-5q0 -14 13 -14h113q16 0 19 19l5 37q1 2 1 8q0 11 -13 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent.ss01",
    horizAdvX: 521,
    d: "M399 799l-25 -169h-115l25 169h115zM521 502h-46q17 -15 17 -49q0 -12 -1 -16l-25 -154q-9 -56 -54 -95q-46 -38 -100 -38h-62q-28 0 -29 -16v-3q0 -12 24 -12h62q55 0 86 -23.5t31 -66.5q0 -2 -2 -20l-8 -57q-9 -51 -49.5 -80.5t-101.5 -29.5h-139q-55 0 -86 23.5 t-31 66.5q0 2 2 20l9 57q12 67 77 96q-7 7 -7 23q0 24 23 39q-52 31 -52 96q0 2 2 20l25 154q7 54 53 94q45 39 101 39h292zM338 293l21 134v3q0 10 -8 10h-125q-11 0 -12 -13l-21 -134q0 -2 -1 -3v-1q0 -9 9 -9h125q9 0 12 13zM278 18h-113q-15 0 -19 -19l-6 -37v-5 q0 -14 13 -14h113q16 0 19 19l5 37q1 2 1 8q0 11 -13 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent.ss01",
    horizAdvX: 521,
    d: "M351 756q25 0 42 -17t17 -41q0 -32 -24 -55.5t-57 -23.5q-25 0 -41.5 16t-16.5 41q0 31 24.5 55.5t55.5 24.5zM521 502h-46q17 -15 17 -49q0 -12 -1 -16l-25 -154q-9 -56 -54 -95q-46 -38 -100 -38h-62q-28 0 -29 -16v-3q0 -12 24 -12h62q55 0 86 -23.5t31 -66.5 q0 -2 -2 -20l-8 -57q-9 -51 -49.5 -80.5t-101.5 -29.5h-139q-55 0 -86 23.5t-31 66.5q0 2 2 20l9 57q12 67 77 96q-7 7 -7 23q0 24 23 39q-52 31 -52 96q0 2 2 20l25 154q7 54 53 94q45 39 101 39h292zM338 293l21 134v3q0 10 -8 10h-125q-11 0 -12 -13l-21 -134q0 -2 -1 -3 v-1q0 -9 9 -9h125q9 0 12 13zM278 18h-113q-15 0 -19 -19l-6 -37v-5q0 -14 13 -14h113q16 0 19 19l5 37q1 2 1 8q0 11 -13 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.ss01",
    horizAdvX: 486,
    d: "M508 559l-226 -715h-124l46 145h-92q-15 0 -26.5 10.5t-11.5 23.5l-7 536h133l-12 -425v-5q0 -13 7 -13h47q10 0 16 18l120 425h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute.ss01",
    horizAdvX: 486,
    d: "M481 765l-122 -131h-126l123 131h125zM282 -156h-124l46 145h-92q-15 0 -26.5 10.5t-11.5 23.5l-7 536h133l-12 -425v-5q0 -13 7 -13h47q10 0 16 18l120 425h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex.ss01",
    horizAdvX: 486,
    d: "M348 795l108 -158h-115l-42 58h-3l-62 -58h-115l160 158h69zM282 -156h-124l46 145h-92q-15 0 -26.5 10.5t-11.5 23.5l-7 536h133l-12 -425v-5q0 -13 7 -13h47q10 0 16 18l120 425h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis.ss01",
    horizAdvX: 486,
    d: "M231 757q24 0 40 -16.5t16 -39.5q0 -29 -23.5 -51.5t-53.5 -22.5q-24 0 -39.5 15.5t-15.5 38.5q0 30 23.5 53t52.5 23zM399 757q22 0 37.5 -16.5t15.5 -39.5q0 -29 -23 -51.5t-51 -22.5q-24 0 -40 15.5t-16 38.5q0 30 23.5 53t53.5 23zM282 -156h-124l46 145h-92 q-15 0 -26.5 10.5t-11.5 23.5l-7 536h133l-12 -425v-5q0 -13 7 -13h47q10 0 16 18l120 425h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave.ss01",
    horizAdvX: 486,
    d: "M272 765l80 -131h-125l-81 131h126zM282 -156h-124l46 145h-92q-15 0 -26.5 10.5t-11.5 23.5l-7 536h133l-12 -425v-5q0 -13 7 -13h47q10 0 16 18l120 425h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde.ss01",
    horizAdvX: 486,
    d: "M166 624l13 111q31 31 67 31q26 0 66 -18q42 -17 64 -17q28 0 62 28l-13 -111q-32 -32 -67 -32q-24 0 -67 17q-41 18 -64 18q-33 0 -61 -27zM282 -156h-124l46 145h-92q-15 0 -26.5 10.5t-11.5 23.5l-7 536h133l-12 -425v-5q0 -13 7 -13h47q10 0 16 18l120 425h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_h",
    horizAdvX: 971,
    d: "M717 765l-40 -252q136 56 188 56q36 0 59 -23t23 -57q0 -13 -1 -16l-75 -473h-130l64 407q0 1 0.5 4t0.5 4q0 10 -8 10l-141 -42l-32 -198l-9 -62q-9 -55 -54 -94t-100 -39h-323q-50 0 -82 32t-32 80q0 3 2 21l49 314q9 57 54 94q45 39 100 39h139q50 0 82 -31.5 t32 -79.5q0 -4 -2 -22l-11 -75h-130l10 65v4q0 9 -7 9h-127q-10 0 -11 -13l-47 -294v-4q0 -9 7 -9h311q10 0 11 13l11 62l89 570h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lf",
    horizAdvX: 518,
    d: "M279 775h117q54 0 88.5 -34.5t34.5 -86.5q0 -1 -2 -23l-78 -497q-11 -61 -59 -102q-48 -42 -108 -42h-117q-54 0 -88.5 34.5t-34.5 86.5q0 1 2 23l78 497q11 61 58 102q50 42 109 42zM376 645h-117q-14 0 -17 -14l-78 -497v-3l-1 -3q0 -8 12 -8h117q14 0 17 14l78 497 q0 1 0.5 3t0.5 3q0 8 -12 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lf",
    horizAdvX: 318,
    d: "M324 765l-121 -765h-130l100 635h-69l21 130h199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lf",
    horizAdvX: 515,
    d: "M269 776h133q53 0 87.5 -36t34.5 -91q0 -3 -2 -27l-5 -31q-7 -42 -24 -81q-18 -41 -35.5 -65.5t-48.5 -52.5q-22 -20 -49 -42q-15 -12 -56 -39l-48 -33q-86 -59 -100 -148h288l-20 -130h-421l11 70q18 109 53.5 178.5t99.5 114.5q21 15 58 37q28 16 57 35q95 64 105 156 l5 31q1 3 1 10q0 14 -21 14h-113q-14 0 -20 -7t-10 -27h-130q11 70 60 116q50 48 110 48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lf",
    horizAdvX: 514,
    d: "M263 775h133q54 0 84.5 -26.5t30.5 -74.5q0 -2 -2 -26l-18 -110q-17 -98 -66 -117q38 -17 38 -79q0 -24 -3 -42l-27 -175q-10 -65 -51 -100t-104 -35h-131q-55 0 -86 27.5t-31 78.5q0 15 2 29l25 157h130l-23 -146v-3l-1 -3q0 -10 9 -10h121q9 0 12 16l25 164q1 3 1 13 q0 27 -33 27h-68l20 130h68q17 0 27 15.5t16 52.5l16 95v3q0 9 -8 9h-123q-10 0 -13 -12l-3 -19h-130l3 19q11 66 54.5 104t105.5 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lf",
    horizAdvX: 553,
    d: "M513 765l-83 -521h52l-20 -130h-52l-18 -114h-130l18 114h-300l306 651h227zM362 635h-9l-168 -391h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lf",
    horizAdvX: 516,
    d: "M545 764l-21 -129h-252l-24 -154h98q70 0 101 -27.5t31 -85.5q0 -18 -5 -53l-27 -178q-11 -72 -57.5 -109.5t-119.5 -37.5h-93q-64 0 -100 29.5t-36 85.5q0 15 3 32l22 145h130l-22 -145v-4q0 -13 24 -13h92q24 0 27 17l27 178q1 3 1 14q0 22 -19 22h-228l66 413h382z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lf",
    horizAdvX: 509,
    d: "M269 776h139q48 0 79 -37q33 -36 33 -86q0 -4 -2 -22l-10 -64h-130l10 64q0 1 0.5 3t0.5 3q0 9 -11 9h-119q-15 0 -16 -15l-32 -197h132q53 0 87.5 -34t34.5 -86q0 -1 -2 -23l-25 -157q-9 -60 -58 -101q-50 -42 -109 -42h-117q-54 0 -88.5 34.5t-34.5 86.5q0 4 2 22 l80 499q7 54 55 99q49 44 101 44zM308 134l25 157q0 2 1 3v1q0 9 -12 9h-119q-12 0 -15 -14l-25 -156v-3q0 -10 11 -10h119q14 0 15 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lf",
    horizAdvX: 420,
    d: "M491 770l-360 -770h-130l301 640h-237l20 130h406z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lf",
    horizAdvX: 519,
    d: "M281 775h113q53 0 86 -33.5t33 -84.5q0 -3 -2 -25l-15 -96q-15 -89 -81 -118q53 -21 53 -91q0 -3 -2 -29l-26 -160q-11 -61 -60 -104t-110 -43h-113q-54 0 -89.5 35.5t-35.5 87.5q0 2 2 24l26 160q13 94 88 120q-47 23 -47 85q0 15 3 33l15 96q11 59 57 101q48 42 105 42 zM242 491h102q17 13 22 45l15 96l1 2v2q0 9 -10 9h-110q-10 0 -13 -13l-15 -96q-1 -4 -1 -17q0 -17 9 -28zM310 138l26 160q1 3 1 15q0 23 -16 33h-102q-24 -14 -29 -48l-26 -160v-5q0 -12 14 -12h113q16 0 19 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lf",
    horizAdvX: 510,
    d: "M272 777h117q53 0 88 -34.5t35 -86.5q0 -4 -2 -22l-80 -501q-7 -55 -56 -99q-47 -44 -100 -44h-139q-47 0 -80 36q-32 38 -32 87q0 4 2 22l10 64h130l-10 -64q0 -1 -0.5 -3t-0.5 -3q0 -9 11 -9h119q14 0 16 15l32 199h-132q-54 0 -88 34t-34 86q0 1 2 23l25 157 q9 60 58 101q49 42 109 42zM355 478l25 156v3q0 10 -11 10h-119q-14 0 -15 -13l-25 -157v-3l-1 -1q0 -9 12 -9h119q12 0 15 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccentinvert",
    horizAdvX: 521,
    d: "M284 800h115l-25 -169h-115z"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "comma,period,ellipsis",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,Alphatonos,Alpha,increment,Lambda,alphatonos,alpha,delta,lambda,uni0410,uni0430",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oogonek,Oslashacute,Theta,Omicron,theta,omicron,uni0404,uni041E,uni0421,uni043E,uni0441,uni0454,Odotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,Alphatonos,Alpha,increment,Lambda,alphatonos,alpha,delta,lambda,uni0410,uni0430",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,Alphatonos,Alpha,increment,Lambda,alphatonos,alpha,delta,lambda,uni0410,uni0430",
    g2: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,Alphatonos,Alpha,increment,Lambda,alphatonos,alpha,delta,lambda,uni0410,uni0430",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,uni040E,uni0423,uni0443,uni045E,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,Alphatonos,Alpha,increment,Lambda,alphatonos,alpha,delta,lambda,uni0410,uni0430",
    g2: "Psi,psi,uni0427,uni0447",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oogonek,Oslashacute,Omicrontonos,Theta,Omicron,theta,omicron,omicrontonos,uni041E,uni042D,uni042E,uni043E,uni044D,uni044E,Ddotaccent,Ddotbelow,Odotbelow",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F,Fdotaccent",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,Alpha,increment,Lambda,alpha,delta,lambda,uni0410,uni0430",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,Kcommaaccent,Kappa,Chi,kappa,chi,uni040C,uni0416,uni041A,uni0425,uni0436,uni043A,uni0445,uni045C",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,Kcommaaccent,Kappa,Chi,kappa,chi,uni040C,uni0416,uni041A,uni0425,uni0436,uni043A,uni0445,uni045C",
    g2: "t,tcedilla,tcaron,tbar,uni021B,tdotaccent,tdotbelow",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,Kcommaaccent,Kappa,Chi,kappa,chi,uni040C,uni0416,uni041A,uni0425,uni0436,uni043A,uni0445,uni045C",
    g2: "v,y.ss01,yacute.ss01,ycircumflex.ss01,ydieresis.ss01,ygrave.ss01,ytilde.ss01",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lslash",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lslash",
    g2: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,uni040E,uni0423,uni0443,uni045E,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lslash",
    g2: "v,y.ss01,yacute.ss01,ycircumflex.ss01,ydieresis.ss01,ygrave.ss01,ytilde.ss01",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "M,Mu,mu,uni041C,uni043C,Mdotaccent",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Rho,Psi,rho,psi,uni0420,uni0440,Pdotaccent",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,Alpha,increment,Lambda,alpha,delta,lambda,uni0410,uni0430",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Rho,Psi,rho,psi,uni0420,uni0440,Pdotaccent",
    g2: "J,Jcircumflex,uni0408,uni0458",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Rho,Psi,rho,psi,uni0420,uni0440,Pdotaccent",
    g2: "X,Sigma,Chi,sigmafinal,sigma,chi,uni0416,uni0425,uni0436,uni0445",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Rho,Psi,rho,psi,uni0420,uni0440,Pdotaccent",
    g2: "uni0409,uni0414,uni041B,uni0434,uni043B,uni0459",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "comma,period,ellipsis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oogonek,Oslashacute,Theta,Omicron,theta,omicron,uni0404,uni041E,uni0421,uni043E,uni0441,uni0454,Odotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,uni040E,uni0423,uni0443,uni045E,Ygrave,Ytilde",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,Alpha,increment,Lambda,alpha,delta,lambda,uni0410,uni0430",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "t,tcedilla,tcaron,tbar,uni021B,tdotaccent,tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "v,y.ss01,yacute.ss01,ycircumflex.ss01,ydieresis.ss01,ygrave.ss01,ytilde.ss01",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "J,Jcircumflex,uni0408,uni0458",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "X,Sigma,Chi,sigmafinal,sigma,chi,uni0416,uni0425,uni0436,uni0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "uni0409,uni0414,uni041B,uni0434,uni043B,uni0459",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "colon",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "M,Mu,mu,uni041C,uni043C,Mdotaccent",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "a,d,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,dcaron,dslash,dzcaron,dz,aringacute,aeacute,ddotaccent,ddotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oogonek,oslashacute,edotbelow,etilde,odotbelow,c_h",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent,g.ss01,gbreve.ss01,gcircumflex.ss01,gcommaaccent.ss01,gdotaccent.ss01",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "m,n,p,r,kgreenlandic,nacute,ncommaaccent,ncaron,eng,rcommaaccent,nj,mdotaccent,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "s,scedilla,scommaaccent,sdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "u,w,y,ugrave,uacute,ucircumflex,udieresis,yacute,ydieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,udotbelow,ygrave,ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "x",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "z,zdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "guillemotright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "germandbls",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "napostrophe",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "longs",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "bullet",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcedilla,Tcaron,uni021A,Gamma,Tau,gamma,tau,uni0403,uni0413,uni0422,uni0433,uni0442,uni0453,Tdotaccent,Tdotbelow",
    g2: "a.ss01,aacute.ss01,abreve.ss01,acircumflex.ss01,adieresis.ss01,agrave.ss01,amacron.ss01,aogonek.ss01,aring.ss01,aringacute.ss01,atilde.ss01",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,Alpha,increment,Lambda,alpha,delta,lambda,uni0410,uni0430",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    g2: "t,tcedilla,tcaron,tbar,uni021B,tdotaccent,tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    g2: "uni0409,uni0414,uni041B,uni0434,uni043B,uni0459",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    g2: "a,d,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,dcaron,dslash,dzcaron,dz,aringacute,aeacute,ddotaccent,ddotbelow",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oogonek,oslashacute,edotbelow,etilde,odotbelow,c_h",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    g2: "m,n,p,r,kgreenlandic,nacute,ncommaaccent,ncaron,eng,rcommaaccent,nj,mdotaccent,ndotaccent,rdotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    g2: "u,w,y,ugrave,uacute,ucircumflex,udieresis,yacute,ydieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,udotbelow,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    g2: "a.ss01,aacute.ss01,abreve.ss01,acircumflex.ss01,adieresis.ss01,agrave.ss01,amacron.ss01,aogonek.ss01,aring.ss01,aringacute.ss01,atilde.ss01",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,Alpha,increment,Lambda,alpha,delta,lambda,uni0410,uni0430",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "t,tcedilla,tcaron,tbar,uni021B,tdotaccent,tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "v,y.ss01,yacute.ss01,ycircumflex.ss01,ydieresis.ss01,ygrave.ss01,ytilde.ss01",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "J,Jcircumflex,uni0408,uni0458",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "uni0409,uni0414,uni041B,uni0434,uni043B,uni0459",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "a,d,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,dcaron,dslash,dzcaron,dz,aringacute,aeacute,ddotaccent,ddotbelow",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oogonek,oslashacute,edotbelow,etilde,odotbelow,c_h",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent,g.ss01,gbreve.ss01,gcircumflex.ss01,gcommaaccent.ss01,gdotaccent.ss01",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "m,n,p,r,kgreenlandic,nacute,ncommaaccent,ncaron,eng,rcommaaccent,nj,mdotaccent,ndotaccent,rdotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "s,scedilla,scommaaccent,sdotbelow",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "u,w,y,ugrave,uacute,ucircumflex,udieresis,yacute,ydieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,udotbelow,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,Ygrave,Ytilde",
    g2: "a.ss01,aacute.ss01,abreve.ss01,acircumflex.ss01,adieresis.ss01,agrave.ss01,amacron.ss01,aogonek.ss01,aring.ss01,aringacute.ss01,atilde.ss01",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,Zeta,zeta,Zdotbelow",
    g2: "t,tcedilla,tcaron,tbar,uni021B,tdotaccent,tdotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,Zeta,zeta,Zdotbelow",
    g2: "v,y.ss01,yacute.ss01,ycircumflex.ss01,ydieresis.ss01,ygrave.ss01,ytilde.ss01",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0409,uni040A,uni042A,uni042C,uni044A,uni044C,uni0459,uni045A,bdotaccent,pdotaccent",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0409,uni040A,uni042A,uni042C,uni044A,uni044C,uni0459,uni045A,bdotaccent,pdotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Upsilon,Upsilondieresis,upsilondieresistonos,upsilon,upsilondieresis,upsilontonos,uni040E,uni0423,uni0443,uni045E,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,longs,fdotaccent",
    g2: "question",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,longs,fdotaccent",
    g2: "bracketright",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,longs,fdotaccent",
    g2: "quoteleft,quotedblleft",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,longs,fdotaccent",
    g2: "quoteright,quotedblright",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,ellipsis",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y.ss01,yacute.ss01,ycircumflex.ss01,ydieresis.ss01,ygrave.ss01,ytilde.ss01",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni0443,uni045E",
    g2: "uni0409,uni0414,uni041B,uni0434,uni043B,uni0459",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,Alpha,increment,Lambda,alpha,delta,lambda,uni0410,uni0430",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oogonek,oslashacute,edotbelow,etilde,odotbelow,c_h",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,ellipsis",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,scedilla,scommaaccent,sdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotesinglbase,quotedblbase",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotesinglbase,quotedblbase",
    g2: "V,W.ss01,Wacute.ss01,Wcircumflex.ss01,Wdieresis.ss01,Wgrave.ss01",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bullet",
    g2: "T,Tcedilla,Tcaron,uni021A,Tau,tau,uni0402,uni040B,uni0422,uni042A,uni0442,uni044A,uni0452,uni045B,Tdotaccent,Tdotbelow",
    k: 38
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliticaExtraBoldItalic);
export default __webpack_public_path__ + "static/media/Politica-ExtraBoldItalic.d2b23ffe4a5783902afaeffd8fd8084b.svg";
export { ForwardRef as ReactComponent };